// ==========================================
// 🇺🇸 ENGLISH LESSON CURRICULUM
// ==========================================
export const getEnglishLessons = () => {
  return [
    // ------------------------------------------
    // Lesson 1: Home Row Core (A S D F J K L ;)
    // ------------------------------------------
    {
      title: "1.1",
      instruction: "Welcome to the Home Row! Place your left fingers on A, S, D, F and right on J, K, L, ;",
      text: [
        "Welcome to the Foundation of Touch Typing! Every great typist starts exactly where you are right now: The Home Row. This is the base camp for your hands. No matter where your fingers reach, they will always return here.",
        "The Left Hand: Rest your pinky lightly on 'A', your ring finger on 'S', your middle finger on 'D', and anchor your index finger firmly on 'F'.",
        "The Right Hand: Anchor your right index finger firmly on 'J', your middle finger on 'K', your ring finger on 'L', and rest your pinky on the semicolon ';'.",
        "The Golden Rule: Gently rub the 'F' and 'J' keys to feel the small, raised physical bumps. Let these bumps be your eyes. Trust your hands, rely on the home row, and never look down!"
      ],
      image: "/Homerowkeys.webp"
    },
    {
      title: "1.2",
      instruction: "Begin your muscle memory training. Type these precise 2-letter blocks arranged in a strict grid. Do not rush; focus entirely on hitting the exact center of each key without looking down at your hands. Accuracy builds speed.",
      text: [
        "as df jk l; ",
        "sa fd kj ;l ",
        "ad fs jl k; ",
        "da sf lj ;k ",
        "fa la ka sa ",
        "as jk df l; ",
        "sa kj fd ;l ",
        "ad jl fs k; "
      ]
    },
    {
      title: "1.3",
      instruction: "Expand your finger reach. Type these 3-letter combinations while maintaining a perfectly steady rhythm. If you make a mistake, do not panic—simply locate the correct key by feel, pull your fingers back to the home row, and continue the pattern.",
      text: [
        "sad dad all ask ",
        "fad lad las sal ",
        "fas dsa klj lkj ",
        "add sda jak lal ",
        "dad sad ask all ",
        "las fad sal lad ",
        "dsa fas lkj klj ",
        "sad ask dad all "
      ]
    },
    {
      title: "1.4",
      instruction: "Build fluid keystroke transitions. These 4-letter blocks require your fingers to move sequentially. Keep your wrists slightly elevated above the desk and let your fingers curl naturally over the keys. Breathe and maintain a steady pace.",
      text: [
        "fall lass asks dads ",
        "alas fads lads sals ",
        "dalf flad laks slak ",
        "fdsa asdf lkj; jkl; ",
        "lass fall dads asks ",
        "fads alas sals lads ",
        "flad dalf slak laks ",
        "fall dads asks lass "
      ]
    },
    {
      title: "1.5",
      instruction: "Transition from abstract blocks to real typing patterns. Read the entire phrase in your mind before you start typing it. Connect the words smoothly, ensuring you strike the spacebar gently with the side of your resting thumb.",
      text: [
        "a sad dad ",
        "all fall asks ",
        "a lad asks ",
        "dads fall sad ",
        "a sad lass ",
        "all lads ask ",
        "a dad falls ",
        "lads ask a dad "
      ]
    },
    {
      title: "1.6",
      instruction: "Endurance and stamina test. Type the full paragraph with deep focus to train your sustained muscle memory. You must press the ENTER key at the exact end of each paragraph to proceed. Prioritize absolute accuracy over speed.",
      text: [
        "alas a sad dad falls a sad lass asks a dad alas all fall sad",
        "a lad asks a lass a dad falls sad all lads ask a sad dad",
        "all fall sad alas a dad asks a lad a lass falls a sad lad",
        "a sad dad asks a lass all lads fall sad alas a lad asks",
        "alas all fall sad a lad asks a dad a sad lass falls",
        "a dad asks a sad lad all fall alas a lass asks a dad"
      ]
    },

    // ------------------------------------------
    // Lesson 2: Top Row (E, I)
    // ------------------------------------------
    {
      title: "2.1",
      instruction: "Reach up with your middle fingers to type E and I.",
      text: [
        "Welcome to the Top Row! Now that your hands are safely anchored on the Home Row, it is time to reach for new letters. The secret to typing fast is keeping your base secure while only stretching the specific finger you need.",
        "The Left Hand (E): Keep your index finger safely anchored on the 'F' key. To type 'E', simply stretch your left middle finger upward from 'D', tap the 'E' key, and immediately pull it back down to its resting spot.",
        "The Right Hand (I): Keep your index finger safely anchored on the 'J' key. To type 'I', stretch your right middle finger upward from 'K', tap the 'I' key, and quickly snap it back down to rest on 'K'.",
        "The Golden Rule: Never move your entire hand to press a single key! Keep your wrists slightly elevated to give your fingers the flexibility they need, and always let them snap back to home base."
      ],
      image: "/lesson2.webp"
    },
    {
      title: "2.2",
      instruction: "Begin your muscle memory training. Type these precise 2-letter blocks arranged in a strict grid. Do not rush; focus entirely on hitting the exact center of each key without looking down at your hands. Accuracy builds speed.",
      text: [
        "ed ik de ki ",
        "se li fe ji ",
        "ie ei di ke ",
        "es is el il ",
        "id ek le if ",
        "si le fi je ",
        "ei ie ke di ",
        "is es il el "
      ]
    },
    {
      title: "2.3",
      instruction: "Expand your finger reach. Type these 3-letter combinations while maintaining a perfectly steady rhythm. If you make a mistake, do not panic—simply locate the correct key by feel, pull your fingers back to the home row, and continue the pattern.",
      text: [
        "did kid lid lie ",
        "die fee see ail ",
        "sad fad lad eel ",
        "ill ell see lee ",
        "lid kid did lie ",
        "see fee die ail ",
        "lad fad sad eel ",
        "ell ill lee see "
      ]
    },
    {
      title: "2.4",
      instruction: "Build fluid keystroke transitions. These 4-letter blocks require your fingers to move sequentially. Keep your wrists slightly elevated above the desk and let your fingers curl naturally over the keys. Breathe and maintain a steady pace.",
      text: [
        "desk side fake fade ",
        "file life idle lied ",
        "seed feed deed kids ",
        "sail fail jail dial ",
        "side desk fade fake ",
        "life file lied idle ",
        "feed seed kids deed ",
        "fail sail dial jail "
      ]
    },
    {
      title: "2.5",
      instruction: "Transition from abstract blocks to real typing patterns. Read the entire phrase in your mind before you start typing it. Connect the words smoothly, ensuring you strike the spacebar gently with the side of your resting thumb.",
      text: [
        "a fake desk ",
        "see a sad kid ",
        "did a kid lie ",
        "kids slide safely ",
        "a side desk ",
        "fake a leaf ",
        "idle kids lie ",
        "sail a safe sea "
      ]
    },
    {
      title: "2.6",
      instruction: "Endurance and stamina test. Type the full paragraph with deep focus to train your sustained muscle memory. You must press the ENTER key at the exact end of each paragraph to proceed. Prioritize absolute accuracy over speed.",
      text: [
        "a kid likes a slide as a fake desk falls ladies like a safe side feed a kid a seal",
        "idle kids see a sea life as ladies sail a fake seal slides safely did a kid lie",
        "sail a safe sea side as a kid likes a leaf ladies see a fake desk fall feed a sad kid",
        "a safe seal likes a slide as idle kids see ladies fake a sad sigh did a kid sail a sea",
        "kids sail a safe sea as a fake desk falls ladies like a seal slide feed a kid a leaf",
        "a safe side desk falls as ladies see a kid idle kids slide safely did a seal fake a lie"
      ]
    },

    // ------------------------------------------
    // Lesson 3: Top Row (R, U)
    // ------------------------------------------
    {
      title: "3.1",
      instruction: "Reach up with your index fingers to type R and U.",
      text: [
        "Your index fingers are the most agile and hardest-working fingers on the keyboard! Because they handle multiple keys, it is crucial to train them to immediately return to their home base after every single keystroke.",
        "The Left Hand (R): Keep your pinky, ring, and middle fingers resting lightly on A, S, and D. Stretch your left index finger upward and slightly to the left to strike the 'R' key. Immediately pull it back down to rest on 'F'.",
        "The Right Hand (U): Keep your other fingers resting safely on K, L, and the semicolon. Stretch your right index finger upward and slightly to the left to tap the 'U' key. Quickly snap it back down to rest on 'J'.",
        "The Golden Rule: Because your index fingers move so much, they can easily get lost. Always feel for the small physical bumps on the F and J keys to instantly reset your hand position without looking down!"
      ],
      image: "/lesson3.webp"
    },
    {
      title: "3.2",
      instruction: "Begin your muscle memory training. Type these precise 2-letter blocks arranged in a strict grid. Do not rush; focus entirely on hitting the exact center of each key without looking down at your hands. Accuracy builds speed.",
      text: [
        "ur ru re er ",
        "us rs is es ",
        "du fu ju ku ",
        "ar ir er ur ",
        "ru ur er re ",
        "rs us es is ",
        "fu du ku ju ",
        "ir ar ur er "
      ]
    },
    {
      title: "3.3",
      instruction: "Expand your finger reach. Type these 3-letter combinations while maintaining a perfectly steady rhythm. If you make a mistake, do not panic—simply locate the correct key by feel, pull your fingers back to the home row, and continue the pattern.",
      text: [
        "fur sir use rue ",
        "red ear era are ",
        "due sue rue fur ",
        "air ire err err ",
        "sir fur rue use ",
        "ear red are era ",
        "sue due fur rue ",
        "ire air err err "
      ]
    },
    {
      title: "3.4",
      instruction: "Build fluid keystroke transitions. These 4-letter blocks require your fingers to move sequentially. Keep your wrists slightly elevated above the desk and let your fingers curl naturally over the keys. Breathe and maintain a steady pace.",
      text: [
        "sure rule rude ride ",
        "fire dire sire read ",
        "deer rear user dark ",
        "fail sail rail dual ",
        "rule sure ride rude ",
        "dire fire read sire ",
        "rear deer dark user ",
        "sail fail dual rail "
      ]
    },
    {
      title: "3.5",
      instruction: "Transition from abstract blocks to real typing patterns. Read the entire phrase in your mind before you start typing it. Connect the words smoothly, ensuring you strike the spacebar gently with the side of your resting thumb.",
      text: [
        "are we sure ",
        "a dark fire ",
        "rule a user ",
        "read a file ",
        "sure we are ",
        "fire in dark ",
        "user of rule ",
        "file a read "
      ]
    },
    {
      title: "3.6",
      instruction: "Endurance and stamina test. Type the full paragraph with deep focus to train your sustained muscle memory. You must press the ENTER key at the exact end of each paragraph to proceed. Prioritize absolute accuracy over speed.",
      text: [
        "a user rides a deer a dark fire fails read a file sure kids like a rule",
        "dark users like rules fire rides a dark sail deer fail a sure run kids rule a dark desk",
        "read a sure file a deer rides a dark user. sail a dark fire fails rule a kid",
        "kids ride a dark deer a rule fails a sure user read a dark fire a sail fails",
        "a user reads a sure file dark deer ride a rule fire sails a dark desk kids fail a run",
        "sure kids read dark rules a user rides a dark fire a deer fails a sail read a desk"
      ]
    },

    // ------------------------------------------
    // Lesson 4: Top Row (T, O)
    // ------------------------------------------
    {
      title: "4.1",
      instruction: "Reach up with your left index finger for T, and right ring finger for O.",
      text: [
        "We are expanding your reach again! In this lesson, you will practice stretching your fingers a bit further. A common mistake beginners make here is twisting their hands to reach the keys. Focus on keeping your wrists perfectly straight and letting your fingers do the work.",
        "The Left Hand (T): Your left index finger has another job! Keep your pinky, ring, and middle fingers anchored on A, S, and D. Stretch your index finger upward and slightly to the right to tap the 'T' key. Immediately pull it back down to rest on 'F'.",
        "The Right Hand (O): Keep your index and middle fingers safely anchored on J and K. Stretch your right ring finger straight upward from 'L' to strike the 'O' key. Once pressed, quickly snap it back down to its home base on 'L'.",
        "The Golden Rule: Watch your wrists! If you feel your hands rotating or your wrists twisting inward to reach these new keys, stop and reset. Your wrists should remain completely still and elevated while your fingers do the stretching."
      ],
      image: "/lesson4.webp"
    },
    {
      title: "4.2",
      instruction: "Begin your muscle memory training. Type these precise 2-letter blocks arranged in a strict grid. Do not rush; focus entirely on hitting the exact center of each key without looking down at your hands. Accuracy builds speed.",
      text: [
        "to ot do to ",
        "so to lo or ",
        "of to it at ",
        "do to of or ",
        "ot to to do ",
        "to so or lo ",
        "to of at it ",
        "to do or of "
      ]
    },
    {
      title: "4.3",
      instruction: "Expand your finger reach. Type these 3-letter combinations while maintaining a perfectly steady rhythm. If you make a mistake, do not panic—simply locate the correct key by feel, pull your fingers back to the home row, and continue the pattern.",
      text: [
        "too out dot lot ",
        "rot tot fot fit ",
        "foo too out dot ",
        "sit sat fat rat ",
        "out too lot dot ",
        "tot rot fit fot ",
        "too foo dot out ",
        "sat sit rat fat "
      ]
    },
    {
      title: "4.4",
      instruction: "Build fluid keystroke transitions. These 4-letter blocks require your fingers to move sequentially. Keep your wrists slightly elevated above the desk and let your fingers curl naturally over the keys. Breathe and maintain a steady pace.",
      text: [
        "foot root loot toot ",
        "door tour four sour ",
        "told fold sold roll ",
        "suit rout star tour ",
        "root foot toot loot ",
        "tour door sour four ",
        "fold told roll sold ",
        "rout suit tour star "
      ]
    },
    {
      title: "4.5",
      instruction: "Transition from abstract blocks to real typing patterns. Read the entire phrase in your mind before you start typing it. Connect the words smoothly, ensuring you strike the spacebar gently with the side of your resting thumb.",
      text: [
        "too out of it ",
        "a root or door ",
        "told to sit ",
        "a lot of loot ",
        "out of it too ",
        "door or a root ",
        "sit to fold it ",
        "loot of a lot "
      ]
    },
    {
      title: "4.6",
      instruction: "Endurance and stamina test. Type the full paragraph with deep focus to train your sustained muscle memory. You must press the ENTER key at the exact end of each paragraph to proceed. Prioritize absolute accuracy over speed.",
      text: [
        "a lot of doors sit out a root of a tree rots fold a solid door roll to a tour",
        "four kids out a door told to sit on a root a lot of sour loot roll a solid tree",
        "a solid tree rots fold a tour door a lot of kids sit out four roots of a tree",
        "roll a sour root told kids to fold a door a lot of solid loot sit out on a tour",
        "a tour of a solid door four roots roll out fold a lot of sour trees kids sit and told",
        "told a solid kid to roll a root rots out of doors four of a lot sit sour trees fold"
      ]
    },

    // ------------------------------------------
    // Lesson 5: Capitals & Period (.)
    // ------------------------------------------
    {
      title: "5.1",
      instruction: "Use the opposite Shift key to capitalize. Right ring finger drops for period (.).",
      text: [
        "Welcome to capitalization! Mastering the Shift key is a major milestone. The unbreakable rule of typing capital letters is this: you must ALWAYS use the pinky finger of the OPPOSITE hand to hold down the Shift key.",
        "Left-Hand Capitals (Blue Line): To capitalize a letter typed with your left hand (like 'A' or 'T'), reach your right pinky down to hold the Right Shift key, as shown by the blue line. Type the letter, then immediately release Shift and return your right pinky to the semicolon.",
        "Right-Hand Capitals (Orange Line): To capitalize a letter typed with your right hand (like 'J' or 'U'), stretch your left pinky down to hold the Left Shift key, as indicated by the orange line. After typing, snap your left pinky back to 'A'.",
        "The Period (Green Line): We are also adding punctuation! To type a Period (.), keep your right index and middle fingers safely anchored on J and K. Drop your right ring finger straight down from 'L' to tap the period key, as shown by the green line."
      ],
      image: "/lesson5.webp"
    },
    {
      title: "5.2",
      instruction: "Begin your muscle memory training. Type these precise 2-letter blocks arranged in a strict grid. Do not rush; focus entirely on hitting the exact center of each key without looking down at your hands. Accuracy builds speed.",
      text: [
        "To It Do So ",
        "As Is Or Of ",
        "At Us If Ed ",
        "Ra Ur Ta Or ",
        "It To So Do ",
        "Is As Of Or ",
        "Us At Ed If ",
        "Ur Ra Or Ta "
      ]
    },
    {
      title: "5.3",
      instruction: "Expand your finger reach. Type these 3-letter combinations while maintaining a perfectly steady rhythm. If you make a mistake, do not panic—simply locate the correct key by feel, pull your fingers back to the home row, and continue the pattern.",
      text: [
        "Out Dot Lot Tot ",
        "Rot Fit Sit Sat ",
        "Fat Rat Art Tar ",
        "Oar Our Are Era ",
        "Dot Out Tot Lot ",
        "Fit Rot Sat Sit ",
        "Rat Fat Tar Art ",
        "Our Oar Era Are "
      ]
    },
    {
      title: "5.4",
      instruction: "Build fluid keystroke transitions. These 4-letter blocks require your fingers to move sequentially. Keep your wrists slightly elevated above the desk and let your fingers curl naturally over the keys. Breathe and maintain a steady pace.",
      text: [
        "Foot Root Loot Toot ",
        "Door Tour Four Sour ",
        "Told Fold Sold Roll ",
        "Ours Ours Ours Ours ",
        "Root Foot Toot Loot ",
        "Tour Door Sour Four ",
        "Fold Told Roll Sold ",
        "Ours Ours Ours Ours "
      ]
    },
    {
      title: "5.5",
      instruction: "Transition from abstract blocks to real typing patterns. Read the entire phrase in your mind before you start typing it. Connect the words smoothly, ensuring you strike the spacebar gently with the side of your resting thumb.",
      text: [
        "To do it. ",
        "It is so. ",
        "As I do. ",
        "Of a lot. ",
        "Do it to. ",
        "So it is. ",
        "Do as I. ",
        "Lot of it. "
      ]
    },
    {
      title: "5.6",
      instruction: "Endurance and stamina test. Type the full paragraph with deep focus to train your sustained muscle memory. You must press the ENTER key at the exact end of each paragraph to proceed. Prioritize absolute accuracy over speed.",
      text: [
        "It is a door. A tour of a root. Four of us sit. I told a rat to sit. It is out of a lot.",
        "To sit is to do it. A lot of roots rot. Four rats sit out. I do as I told. It is a tour.",
        "A door is out of roots. I fold four lots. As I do it so. Rats sit on a door. To tour a lot.",
        "It is a root of a lot. I told four of us to sit. A rat rots out of a door. Do it as I told.",
        "Four of us tour a lot. It is a rat on a root. To fold a door is to do it. I sit out as told.",
        "A lot of us do it. I sit on a root of a door. Four rats told to rot. It is as I do so out."
      ]
    },

    // ------------------------------------------
    // Lesson 6: Bottom Row (C, ,)
    // ------------------------------------------
    {
      title: "6.1",
      instruction: "Left middle finger drops down to C. Right middle finger drops down to Comma (,).",
      text: [
        "It is time to explore the bottom row! Reaching downwards can feel a bit unnatural at first. Because your fingers have to curl inward, it is extra important to keep your index fingers planted on the F and J keys to maintain your balance.",
        "The Left Hand (C): Keep your left index finger firmly anchored on 'F'. Drop your left middle finger down and slightly to the right to tap the 'C' key. Once pressed, immediately pull it back up to rest on 'D'.",
        "The Right Hand (Comma): Keep your right index finger safely anchored on 'J'. Drop your right middle finger down and slightly to the right to strike the Comma (,) key. Quickly snap it back up to its home position on 'K'.",
        "The Golden Rule: Try not to let your entire hand slide down the keyboard when reaching for the bottom row. Keep your wrists slightly elevated above the desk—this gives your fingers the clearance they need to curl downward cleanly!"
      ],
      image: "/lesson6.webp"
    },
    {
      title: "6.2",
      instruction: "Begin your muscle memory training. Type these precise 2-letter blocks arranged in a strict grid. Do not rush; focus entirely on hitting the exact center of each key without looking down at your hands. Accuracy builds speed.",
      text: [
        "co oc ca ac ",
        "ce ec ci ic ",
        "cu uc cr rc ",
        "cd dc cl lc ",
        "oc co ac ca ",
        "ec ce ic ci ",
        "uc cu rc cr ",
        "dc cd lc cl "
      ]
    },
    {
      title: "6.3",
      instruction: "Expand your finger reach. Type these 3-letter combinations while maintaining a perfectly steady rhythm. If you make a mistake, do not panic—simply locate the correct key by feel, pull your fingers back to the home row, and continue the pattern.",
      text: [
        "cat cot cut car ",
        "sec sic sac soc ",
        "ice ace act tic ",
        "fac lac rac cac ",
        "cot cat car cut ",
        "sic sec soc sac ",
        "ace ice tic act ",
        "lac fac cac rac "
      ]
    },
    {
      title: "6.4",
      instruction: "Build fluid keystroke transitions. These 4-letter blocks require your fingers to move sequentially. Keep your wrists slightly elevated above the desk and let your fingers curl naturally over the keys. Breathe and maintain a steady pace.",
      text: [
        "coat cost cast cart ",
        "card cord cold calf ",
        "face lace race care ",
        "fact tact cact cots ",
        "cost coat cart cast ",
        "cord card calf cold ",
        "lace face care race ",
        "tact fact cots cact "
      ]
    },
    {
      title: "6.5",
      instruction: "Transition from abstract blocks to real typing patterns. Read the entire phrase in your mind before you start typing it. Connect the words smoothly, ensuring you strike the spacebar gently with the side of your resting thumb.",
      text: [
        "a cat, a cot ",
        "cut a car, ",
        "ice a face, ",
        "cost a cast, ",
        "a cot, a cat ",
        "car, cut a ",
        "face, ice a ",
        "cast, cost a "
      ]
    },
    {
      title: "6.6",
      instruction: "Endurance and stamina test. Type the full paragraph with deep focus to train your sustained muscle memory. You must press the ENTER key at the exact end of each paragraph to proceed. Prioritize absolute accuracy over speed.",
      text: [
        "A cat cut a coat. A cast cost a lot, a cold face. Race to a car, care for a calf. A cool card.",
        "Care for a cold cat, cut a cord. Race a calf to a car. A coat cost a lot, a cool face cast.",
        "A cast cold cord, care for a cat. A coat cut a race. Calf to a car, a card cost a lot.",
        "A car race, a cold calf. Cut a card, coat a cat. A face cast cost a lot, care for a cord.",
        "Cold cast of a face, cut a coat. A cat care cord. Race a car to a calf, a card cost a lot.",
        "A lot of cold cats, a calf race. Cut a coat, care for a car. Cast a card, a face cost a cord."
      ]
    },

    // ------------------------------------------
    // Lesson 7: Center Keys (G, H, ')
    // ------------------------------------------
    {
      title: "7.1",
      instruction: "Index fingers stretch inward to G and H. Pinky stretches for apostrophe (').",
      text: [
        "Welcome to the center stretch! In this lesson, you will practice reaching sideways into the middle of the keyboard, as well as stretching outward for common punctuation.",
        "The Index Fingers (G & H): Your index fingers are taking on even more responsibility. Stretch your left index finger inward to the right to tap 'G'. Stretch your right index finger inward to the left to tap 'H'. Always feel for the F and J bumps as you pull them back to home base.",
        "The Right Pinky (Apostrophe): It is time for an outward stretch. Keep your right index finger firmly planted on 'J'. Reach your right pinky outward to the right to strike the Apostrophe (') key, then immediately snap it back to the semicolon.",
        "The Golden Rule: The biggest temptation during sideways reaches is to let your entire hand slide across the keyboard. Resist it! Keep your wrists perfectly still and force only your fingers to do the stretching."
      ],
      image: "/lesson7.webp"
    },
    {
      title: "7.2",
      instruction: "Begin your muscle memory training. Type these precise 2-letter blocks arranged in a strict grid. Do not rush; focus entirely on hitting the exact center of each key without looking down at your hands. Accuracy builds speed.",
      text: [
        "go ho ah oh ",
        "ha he hi ho ",
        "ga ge gi go ",
        "gh hg ag ah ",
        "ho go oh ah ",
        "he ha ho hi ",
        "ge ga go gi ",
        "hg gh ah ag "
      ]
    },
    {
      title: "7.3",
      instruction: "Expand your finger reach. Type these 3-letter combinations while maintaining a perfectly steady rhythm. If you make a mistake, do not panic—simply locate the correct key by feel, pull your fingers back to the home row, and continue the pattern.",
      text: [
        "the she her his ",
        "get got hog dog ",
        "hug dug tug lug ",
        "gag hag tag rag ",
        "she the his her ",
        "got get dog hog ",
        "dug hug lug tug ",
        "hag gag rag tag "
      ]
    },
    {
      title: "7.4",
      instruction: "Build fluid keystroke transitions. These 4-letter blocks require your fingers to move sequentially. Keep your wrists slightly elevated above the desk and let your fingers curl naturally over the keys. Breathe and maintain a steady pace.",
      text: [
        "that this high sigh ",
        "huge hash gash dash ",
        "host toss loss goss ",
        "hear heat head heal ",
        "this that sigh high ",
        "hash huge dash gash ",
        "toss host goss loss ",
        "heat hear heal head "
      ]
    },
    {
      title: "7.5",
      instruction: "Transition from abstract blocks to real typing patterns. Read the entire phrase in your mind before you start typing it. Connect the words smoothly, ensuring you strike the spacebar gently with the side of your resting thumb.",
      text: [
        "he's a dog ",
        "she's a cat ",
        "it's a hog ",
        "that's a log ",
        "a dog he's ",
        "a cat she's ",
        "a hog it's ",
        "a log that's "
      ]
    },
    {
      title: "7.6",
      instruction: "Endurance and stamina test. Type the full paragraph with deep focus to train your sustained muscle memory. You must press the ENTER key at the exact end of each paragraph to proceed. Prioritize absolute accuracy over speed.",
      text: [
        "He's a ghost. She's a high sort of catch. That's a huge dog. It's a rough dash. The head goes.",
        "She's a huge ghost. He's got a high catch. That's a rough dog. The head goes on a dash. It's high.",
        "That's a head catch. It's a huge ghost of a dog. She's high on a dash. He goes on a rough sort.",
        "The dog is a huge ghost. She's a rough head. That's a high dash. He's got a catch. It's a sort.",
        "It's a high ghost dog. That's a huge head catch. She's got a dash. He goes rough. The sort is high.",
        "He's got a huge head. She's a rough ghost dog. It's a high catch. That's a dash of a sort. Goes high."
      ]
    },

    // ------------------------------------------
    // Lesson 8: Bottom Row (V, N, ?)
    // ------------------------------------------
    {
      title: "8.1",
      instruction: "Left index finger down for V. Right index finger down for N. Right pinky reaches for Question Mark (?).",
      text: [
        "We are heading back to the bottom row! This time, your versatile index fingers will be doing the reaching. You will also practice a complex two-handed combination to type the Question Mark.",
        "The Index Fingers (V & N): Drop your left index finger down and slightly to the right to tap the 'V' key. Drop your right index finger down and slightly to the left to strike the 'N' key. As always, quickly pull them back to the F and J bumps.",
        "The Question Mark (Blue Lines): Remember the opposite hand rule for the Shift key! To type a Question Mark (?), hold down the Left Shift key with your left pinky. While holding it, reach your right pinky down to tap the '/' key.",
        "The Golden Rule: When combining a Shift hold with a bottom-row stretch, it is very easy to accidentally twist your wrists. Keep your wrists elevated and perfectly straight, letting only your pinkies do the stretching!"
      ],
      image: "/lesson8.webp"
    },
    {
      title: "8.2",
      instruction: "Begin your muscle memory training. Type these precise 2-letter blocks arranged in a strict grid. Do not rush; focus entirely on hitting the exact center of each key without looking down at your hands. Accuracy builds speed.",
      text: [
        "an in on un ",
        "va ve vi vo ",
        "na ne ni no ",
        "nv vn nv vn ",
        "in an un on ",
        "ve va vo vi ",
        "ne na no ni ",
        "vn nv vn nv "
      ]
    },
    {
      title: "8.3",
      instruction: "Expand your finger reach. Type these 3-letter combinations while maintaining a perfectly steady rhythm. If you make a mistake, do not panic—simply locate the correct key by feel, pull your fingers back to the home row, and continue the pattern.3-letter blocks.",
      text: [
        "van vat vet via ",
        "net not nut nit ",
        "and end ind und ",
        "nov von nov von ",
        "vat van via vet ",
        "not net nit nut ",
        "end and und ind ",
        "von nov von nov "
      ]
    },
    {
      title: "8.4",
      instruction: "Build fluid keystroke transitions. These 4-letter blocks require your fingers to move sequentially. Keep your wrists slightly elevated above the desk and let your fingers curl naturally over the keys. Breathe and maintain a steady pace.",
      text: [
        "vain vein vent vest ",
        "nest noun none nine ",
        "done gone soon moon ",
        "even ever novs sovs ",
        "vein vain vest vent ",
        "noun nest nine none ",
        "gone done moon soon ",
        "ever even sovs novs "
      ]
    },
    {
      title: "8.5",
      instruction: "Transition from abstract blocks to real typing patterns. Read the entire phrase in your mind before you start typing it. Connect the words smoothly, ensuring you strike the spacebar gently with the side of your resting thumb.",
      text: [
        "is it a van? ",
        "no not a vet? ",
        "an even event? ",
        "done and gone? ",
        "a van is it? ",
        "a vet no not? ",
        "event an even? ",
        "gone and done? "
      ]
    },
    {
      title: "8.6",
      instruction: "Endurance and stamina test. Type the full paragraph with deep focus to train your sustained muscle memory. You must press the ENTER key at the exact end of each paragraph to proceed. Prioritize absolute accuracy over speed.",
      text: [
        "Is it a noun? No, it is not. It is an even event. Have I seen a van? A nine is a none.",
        "No, it is an even noun. Have I seen an event? It is not a van. Is a nine a none? Not even.",
        "Have I seen a noun? It is not an even event. Is a van a nine? No, it is a none. Not an event.",
        "An even noun is not a van. Have I seen a nine? No, it is an event. Is a none even? Not a van.",
        "Is an event a noun? Have I seen a none? No, a nine is not even. It is a van. Not an even nine.",
        "A none is not an even noun. Have I seen a van? No, it is an event. Is a nine not even? An event."
      ]
    },

    // ------------------------------------------
    // Lesson 9: Reaches (W, M)
    // ------------------------------------------
    {
      title: "9.1",
      instruction: "left ring finger up for W. Right index finger down for M",
      text: [
        "Welcome to the awkward reaches! As you master the keyboard, you will find that some finger stretches naturally feel less comfortable than others. Take your time with these keys, and trust that your muscle memory will quickly adapt.",
        "The Left Hand (W): Keep your left index finger safely anchored on the 'F' bump. Stretch your left ring finger upward and slightly to the left from its home on 'S' to tap the 'W' key. Pull it right back down to 'S' when finished.",
        "The Right Hand (M): Keep your right hand anchored with your other fingers. Drop your right index finger down and slightly to the right to strike the 'M' key. Immediately snap it back up to rest on the 'J' bump.",
        "The Golden Rule: Because these stretches feel a bit unnatural at first, beginners often twist their wrists or slide their entire hand to compensate. Keep your wrists steady and your anchor fingers planted. Let the reaching fingers do all the heavy lifting!"
      ],
      image: "/lesson9.webp"
    },
    {
      title: "9.2",
      instruction: "Begin your muscle memory training. Type these precise 2-letter blocks arranged in a strict grid. Do not rush; focus entirely on hitting the exact center of each key without looking down at your hands. Accuracy builds speed.",
      text: [
        "we me wa ma ",
        "wi mi wo mo ",
        "ow aw ew mw ",
        "wm mw wm mw ",
        "me we ma wa ",
        "mi wi mo wo ",
        "aw ow mw ew ",
        "mw wm mw wm "
      ]
    },
    {
      title: "9.3",
      instruction: "Expand your finger reach. Type these 3-letter combinations while maintaining a perfectly steady rhythm. If you make a mistake, do not panic—simply locate the correct key by feel, pull your fingers back to the home row, and continue the pattern.",
      text: [
        "who how now wow ",
        "man men mom mum ",
        "was saw law raw ",
        "mad mud mid mod ",
        "how who wow now ",
        "men man mum mom ",
        "saw was raw law ",
        "mud mad mod mid "
      ]
    },
    {
      title: "9.4",
      instruction: "Build fluid keystroke transitions. These 4-letter blocks require your fingers to move sequentially. Keep your wrists slightly elevated above the desk and let your fingers curl naturally over the keys. Breathe and maintain a steady pace.",
      text: [
        "what when whom show ",
        "more most must much ",
        "warm worm word wood ",
        "made maid mind mend ",
        "when what show whom ",
        "most more much must ",
        "worm warm wood word ",
        "maid made mend mind "
      ]
    },
    {
      title: "9.5",
      instruction: "Transition from abstract blocks to real typing patterns. Read the entire phrase in your mind before you start typing it. Connect the words smoothly, ensuring you strike the spacebar gently with the side of your resting thumb.",
      text: [
        "what a man ",
        "when we show ",
        "more warm wood ",
        "whom we saw ",
        "a man what ",
        "we show when ",
        "warm wood more ",
        "we saw whom "
      ]
    },
    {
      title: "9.6",
      instruction: "Endurance and stamina test. Type the full paragraph with deep focus to train your sustained muscle memory. You must press the ENTER key at the exact end of each paragraph to proceed. Prioritize absolute accuracy over speed.",
      text: [
        "What a warm word we saw. We must show more wood. When is a man mad? How much mud is on a worm?",
        "We saw a warm man. What more wood must we show? When is a worm mad? How much word is on mud?",
        "How much warm wood we saw. What must a man show? When is a word mad? More mud is on a worm.",
        "When we show more mud. What is a warm worm? How much must a mad man see? Wood is a word we saw.",
        "We must see more warm mud. What man is mad on a word? When show a worm how much wood we saw.",
        "A mad man saw a warm worm. What wood must we show? How much is a word when more mud is on?"
      ]
    },

    // ------------------------------------------
    // Lesson 10: Outer Keys (Q, P)
    // ------------------------------------------
    {
      title: "10.1",
      instruction: "Pinky reaches up for Q and P.",
      text: [
        "Welcome to the outer edges! Your pinky fingers are naturally your weakest fingers, so it is important to train them carefully. Stretching to the top corners requires precision without tensing up your hands.",
        "The Left Hand (Q): Keep your left index and middle fingers safely anchored on the 'F' and 'D' keys. Stretch your left pinky straight up from 'A' to tap the 'Q' key. Immediately pull it back down to rest on 'A'.",
        "The Right Hand (P): Keep your right index and middle fingers anchored on 'J' and 'K'. Stretch your right pinky straight up from the semicolon (;) to strike the 'P' key. Quickly snap it back down to its home position.",
        "The Golden Rule: Because the pinkies are weak, beginners often tense their entire hand, flare their elbows, or twist their wrists to press these keys. Keep your hands completely relaxed and let only the pinky stretch to prevent cramping!"
      ],
      image: "/lesson10.webp"
    },
    {
      title: "10.2",
      instruction: "Begin your muscle memory training. Type these precise 2-letter blocks arranged in a strict grid. Do not rush; focus entirely on hitting the exact center of each key without looking down at your hands. Accuracy builds speed.",
      text: [
        "pa pe pi po ",
        "qa qi qu qe ",
        "up op ap ip ",
        "pq qp pq qp ",
        "pe pa po pi ",
        "qi qa qe qu ",
        "op up ip ap ",
        "qp pq qp pq "
      ]
    },
    {
      title: "10.3",
      instruction: "Expand your finger reach. Type these 3-letter combinations while maintaining a perfectly steady rhythm. If you make a mistake, do not panic—simply locate the correct key by feel, pull your fingers back to the home row, and continue the pattern.",
      text: [
        "pen pan pin pun ",
        "qua quo qui pop ",
        "pat pet pit pot ",
        "put pit pat pet ",
        "pan pen pun pin ",
        "quo qua pop qui ",
        "pet pat pot pit ",
        "pit put pet pat "
      ]
    },
    {
      title: "10.4",
      instruction: "Build fluid keystroke transitions. These 4-letter blocks require your fingers to move sequentially. Keep your wrists slightly elevated above the desk and let your fingers curl naturally over the keys. Breathe and maintain a steady pace.",
      text: [
        "quit quip part port ",
        "post past path push ",
        "pull pill pond pond ",
        "pump pump pump pump ",
        "quip quit port part ",
        "past post push path ",
        "pill pull pond pond ",
        "pump pump pump pump "
      ]
    },
    {
      title: "10.5",
      instruction: "Transition from abstract blocks to real typing patterns. Read the entire phrase in your mind before you start typing it. Connect the words smoothly, ensuring you strike the spacebar gently with the side of your resting thumb.",
      text: [
        "quit the port ",
        "push a pill ",
        "part a pond ",
        "put a pen ",
        "the port quit ",
        "a pill push ",
        "a pond part ",
        "a pen put "
      ]
    },
    {
      title: "10.6",
      instruction: "Endurance and stamina test. Type the full paragraph with deep focus to train your sustained muscle memory. You must press the ENTER key at the exact end of each paragraph to proceed. Prioritize absolute accuracy over speed.",
      text: [
        "Put a pen on the port. Quit pushing a pill. A part of the pond is a path. The pump is past.",
        "Quit the past pump. Put a pill on a part of the port. Pushing a pen is a path on the pond.",
        "A part of the port is a pond. Put a pump past the path. Quit pushing a pen on the pill.",
        "Pushing a pump is a past path. Put a part of a pill on the port. Quit the pen on the pond.",
        "The past path is a part of the port. Put the pill pump on a pond. Quit pushing a pen.",
        "A pond is part of the past path. Put a pen on a pump. Quit pushing the pill on the port."
      ]
    },

    // ------------------------------------------
    // Lesson 11: Stretches (B, Y)
    // ------------------------------------------
    {
      title: "11.1",
      instruction: "Index fingers stretch inward and down for B, inward and up for Y.",
      text: [
        "Welcome to the longest stretches on the keyboard! This lesson is the ultimate test of your index fingers' agility. Because these keys are so far from the center, maintaining your home row anchors is more critical than ever.",
        "The Left Hand (B): Keep your pinky, ring, and middle fingers resting on A, S, and D. Stretch your left index finger far down and to the right to strike the 'B' key. Once pressed, immediately pull it back up to the 'F' bump.",
        "The Right Hand (Y): Keep your other right fingers anchored safely on K, L, and the semicolon. Stretch your right index finger far up and to the left to tap the 'Y' key. Quickly snap it back down to its home base on 'J'.",
        "The Golden Rule: It is very tempting to let your entire hand float away from the home row to make these long reaches easier. Do not let your hands drift! Keep your wrists steady and force only the index fingers to do the long-distance stretching."
      ],
      image: "/lesson11.webp"
    },
    {
      title: "11.2",
      instruction: "Begin your muscle memory training. Type these precise 2-letter blocks arranged in a strict grid. Do not rush; focus entirely on hitting the exact center of each key without looking down at your hands. Accuracy builds speed.",
      text: [
        "by ya ye yo ",
        "ba be bi bo ",
        "yb yb ab ob ",
        "ib ub eb yi ",
        "ya by yo ye ",
        "be ba bo bi ",
        "yb yb ob ab ",
        "ub ib yi eb "
      ]
    },
    {
      title: "11.3",
      instruction: "Expand your finger reach. Type these 3-letter combinations while maintaining a perfectly steady rhythm. If you make a mistake, do not panic—simply locate the correct key by feel, pull your fingers back to the home row, and continue the pattern.",
      text: [
        "boy buy bay bog ",
        "yes yet you yon ",
        "bad bed bid bud ",
        "bat bet bit but ",
        "buy boy bog bay ",
        "yet yes yon you ",
        "bed bad bud bid ",
        "bet bat but bit "
      ]
    },
    {
      title: "11.4",
      instruction: "Build fluid keystroke transitions. These 4-letter blocks require your fingers to move sequentially. Keep your wrists slightly elevated above the desk and let your fingers curl naturally over the keys. Breathe and maintain a steady pace.",
      text: [
        "baby back bare bear ",
        "year yard yarn yawn ",
        "boat boot bolt boom ",
        "yard baby yawn boat ",
        "back baby bear bare ",
        "yard year yawn yarn ",
        "boot boat boom bolt ",
        "baby yard boat yawn "
      ]
    },
    {
      title: "11.5",
      instruction: "Transition from abstract blocks to real typing patterns. Read the entire phrase in your mind before you start typing it. Connect the words smoothly, ensuring you strike the spacebar gently with the side of your resting thumb.",
      text: [
        "a baby boy ",
        "buy a boat ",
        "yes you yawn ",
        "a bad bear ",
        "boy a baby ",
        "boat a buy ",
        "yawn you yes ",
        "bear a bad "
      ]
    },
    {
      title: "11.6",
      instruction: "Endurance and stamina test. Type the full paragraph with deep focus to train your sustained muscle memory. You must press the ENTER key at the exact end of each paragraph to proceed. Prioritize absolute accuracy over speed.",
      text: [
        "Yes, you buy a boat. A baby boy yawns in the yard. Bear back a bad bit. You bet a bat is a bird.",
        "A baby boy buys a bad boat. You yawn in the back yard. Yes, bear a bird bit. Bet you a bat.",
        "You bet a baby boy yawns. Buy a back yard boat. Yes, a bat is a bad bird bit. Bear you back.",
        "Bear a baby boy in the back yard. You bet a boat is bad. Yes, yawn at a bat. Buy a bird bit.",
        "A bad bat bits a bird. Yes, you buy a baby boat. Bear back the yard boy. You bet a yawn.",
        "Buy a baby bird in the yard. Yes, you bear a back bit. A bad boy yawns. You bet a bat boat."
      ]
    },

    // ------------------------------------------
    // Lesson 12: Full Keyboard (Z, X)
    // ------------------------------------------
    {
      title: "12.1",
      instruction: "Pinky drops to Z. Ring finger drops to X.",
      text: [
        "Welcome to the final letters! You have reached a major milestone. In this lesson, we will cover the last two letters of the alphabet, which are tucked away in the bottom left corner of the keyboard.",
        "The Left Pinky (Z): Keep your left index finger firmly anchored on the 'F' bump. Drop your left pinky straight down from its home on 'A' to tap the 'Z' key, then immediately pull it back up.",
        "The Left Ring Finger (X): Keep your anchor on 'F'. Drop your left ring finger straight down from 'S' to strike the 'X' key. Quickly snap it back up to its resting position.",
        "Congratulations! You now know the exact location of every single letter on the QWERTY keyboard. Remember to keep your wrists elevated and your hands relaxed as you build muscle memory for these final reaches."
      ],
      image: "/lesson12.webp"
    },
    {
      title: "12.2",
      instruction: "Begin your muscle memory training. Type these precise 2-letter blocks arranged in a strict grid. Do not rush; focus entirely on hitting the exact center of each key without looking down at your hands. Accuracy builds speed.",
      text: [
        "za ze zi zo ",
        "xa xe xi xo ",
        "az ez iz oz ",
        "ax ex ix ox ",
        "ze za zo zi ",
        "xe xa xo xi ",
        "ez az oz iz ",
        "ex ax ox ix "
      ]
    },
    {
      title: "12.3",
      instruction: "Expand your finger reach. Type these 3-letter combinations while maintaining a perfectly steady rhythm. If you make a mistake, do not panic—simply locate the correct key by feel, pull your fingers back to the home row, and continue the pattern.",
      text: [
        "zoo zip zap zig ",
        "six box fox pox ",
        "tax wax max lax ",
        "zag zed zen zit ",
        "zip zoo zig zap ",
        "box six pox fox ",
        "wax tax lax max ",
        "zed zag zit zen "
      ]
    },
    {
      title: "12.4",
      instruction: "Build fluid keystroke transitions. These 4-letter blocks require your fingers to move sequentially. Keep your wrists slightly elevated above the desk and let your fingers curl naturally over the keys. Breathe and maintain a steady pace.",
      text: [
        "zero zone zest zeal ",
        "exam exit axle axis ",
        "size lazy maze haze ",
        "zoom zinc zulu zeus ",
        "zone zero zeal zest ",
        "exit exam axis axle ",
        "lazy size haze maze ",
        "zinc zoom zeus zulu "
      ]
    },
    {
      title: "12.5",
      instruction: "Transition from abstract blocks to real typing patterns. Read the entire phrase in your mind before you start typing it. Connect the words smoothly, ensuring you strike the spacebar gently with the side of your resting thumb.",
      text: [
        "a zero zone ",
        "exam on a box ",
        "size of a zoo ",
        "lazy fox box ",
        "zone a zero ",
        "box on exam ",
        "zoo of size ",
        "fox lazy box "
      ]
    },
    {
      title: "12.6",
      instruction: "Endurance and stamina test. Type the full paragraph with deep focus to train your sustained muscle memory. You must press the ENTER key at the exact end of each paragraph to proceed. Prioritize absolute accuracy over speed.",
      text: [
        "A lazy fox sits in a box. The zoo is a zero zone. An exam on an axis. Max size of a maze.",
        "The lazy zoo is a zero size. A fox sits on an axis. Max exam in a maze. A box of a zone.",
        "An exam on a lazy fox. The box sits in a zero zoo. Max axis of a size. A maze of a zone.",
        "Max sits in a lazy zone. A zero fox on a zoo axis. The size of an exam. A box in a maze.",
        "The size of a zero box. A lazy exam on a maze axis. Max sits in a zoo. A fox of a zone.",
        "A zero axis in a lazy maze. The fox sits on an exam box. Max size of a zoo. A zone of a fox."
      ]
    }
  ];
};

// ==========================================
// 🇮🇳 HINDI (KRUTI DEV 010) LESSON CURRICULUM
// ==========================================
export const getKrutiDevLessons = () => {
  return [
    // ------------------------------------------
    // Lesson 1: Home Row Core (a s d f j k l ;)
    // ------------------------------------------
    {
      title: "1.1",
      instruction: "Welcome to Kruti Dev! Place your fingers on a s d f and j k l ;",
      text: [
        "Welcome to Kruti Dev typing! Your journey begins on the Home Row. Just like standard typing, this is the base camp for your hands. No matter where your fingers reach, they will always return here.",
        "The Left Hand: Rest your pinky lightly on 'A' (ं), your ring finger on 'S' (े), your middle finger on 'D' (क), and anchor your index finger firmly on 'F' (ि).",
        "The Right Hand: Anchor your right index finger firmly on 'J' (र), your middle finger on 'K' (ा), your ring finger on 'L' (स), and rest your pinky on the semicolon ';' (य).",
        "The Golden Rule: Gently rub the 'F' and 'J' keys to feel the small, raised physical bumps. Keep your wrists elevated, sit up straight, and never look down at your hands!"
      ],
      image: "/Homerowkrutidevkeys.webp"
    },
    {
      title: "1.2",
      instruction: "Begin your muscle memory training. Type these precise 2-letter blocks arranged in a strict grid. Do not rush; focus entirely on hitting the exact center of each key without looking down at your hands. Accuracy builds speed.",
      text: [
        "dj dk lk jk ",
        "ls ds jl lj ",
        "fd fl sd ad ",
        "df sf jf kf ",
        "dj dk lk jk ",
        "ls ds jl lj ",
        "fd fl sd ad ",
        "df sf jf kf "
      ]
    },
    {
      title: "1.3",
      instruction: "Expand your finger reach. Type these 3-letter combinations while maintaining a perfectly steady rhythm. If you make a mistake, do not panic—simply locate the correct key by feel, pull your fingers back to the home row, and continue the pattern.",
      text: [
        "djk ljk jlk dks ",
        "lks jks fdf flf ",
        "djf djd ljd jld ",
        "kjk lkl dkl jkl ",
        "djk ljk jlk dks ",
        "lks jks fdf flf ",
        "djf djd ljd jld ",
        "kjk lkl dkl jkl "
      ]
    },
    {
      title: "1.4",
      instruction: "Build fluid keystroke transitions. These 4-letter blocks require your fingers to move sequentially. Keep your wrists slightly elevated above the desk and let your fingers curl naturally over the keys. Breathe and maintain a steady pace.",
      text: [
        "djdj dkds lsjs djds ",
        "fdfk flfk dsjk lsjk ",
        "dkls jkls lkds jkds ",
        "dfdf fkfk kjkj lklk ",
        "djdj dkds lsjs djds ",
        "fdfk flfk dsjk lsjk ",
        "dkls jkls lkds jkds ",
        "dfdf fkfk kjkj lklk "
      ]
    },
    {
      title: "1.5",
      instruction: "Transition from abstract blocks to real typing patterns. Read the entire phrase in your mind before you start typing it. Connect the words smoothly, ensuring you strike the spacebar gently with the side of your resting thumb.",
      text: [
        "dk lk jk ",
        "dj dl jl ",
        "djk ljk jlk ",
        "fd;k fl;k djdj ",
        "dk lk jk ",
        "dj dl jl ",
        "djk ljk jlk ",
        "fd;k fl;k djdj "
      ]
    },
    {
      title: "1.6",
      instruction: "Endurance and stamina test. Type the full paragraph with deep focus to train your sustained muscle memory. You must press the ENTER key at the exact end of each paragraph to proceed. Prioritize absolute accuracy over speed.",
      text: [
        "dj dk lk jk djk ljk jlk dks djdj dkds lsjs djds",
        "ls ds jl lj lks jks fdf flf fdfk flfk dsjk lsjk",
        "fd fl sd ad djf djd ljd jld dkls jkls lkds jkds",
        "df sf jf kf kjk lkl dkl jkl dfdf fkfk kjkj lklk",
        "dj dk lk jk djk ljk jlk dks djdj dkds lsjs djds",
        "ls ds jl lj lks jks fdf flf fdfk flfk dsjk lsjk"
      ]
    },

    // ------------------------------------------
    // Lesson 2: Home Row Extensions (g h ')
    // ------------------------------------------
    {
      title: "2.1",
      instruction: "Reach your index fingers inward for g and h, and your right pinky outward for the apostrophe (').",
      text: [
        "Welcome to the home row extensions! In this lesson, you will practice reaching sideways into the middle of the keyboard, as well as stretching your pinky outward.",
        "The Index Fingers (G & H): Stretch your left index finger inward to the right to tap the 'G' (ह) key. Stretch your right index finger inward to the left to tap the 'H' (ी) key. Always feel for the F and J bumps to instantly pull them back to home base.",
        "The Right Pinky (Apostrophe): Keep your right index finger firmly planted on 'J'. Reach your right pinky outward to the right to strike the Apostrophe (') key, which types 'श'. Once pressed, immediately snap it back to the semicolon.",
        "The Golden Rule: The biggest temptation during sideways reaches is to let your entire hand slide across the keyboard. Resist it! Keep your wrists perfectly still, maintain your anchor fingers, and let only the reaching fingers do the work."
      ],
      image: "/Lesson2krutidev.webp"
    },
    {
      title: "2.2",
      instruction: "Begin your muscle memory training. Type these precise 2-letter blocks arranged in a strict grid. Do not rush; focus entirely on hitting the exact center of each key without looking down at your hands. Accuracy builds speed.",
      text: [
        "gh hg gk hk ",
        "dh lh jh fg ",
        "g' h' k' j' ",
        "hf hg hd h' ",
        "gh hg gk hk ",
        "dh lh jh fg ",
        "g' h' k' j' ",
        "hf hg hd h' "
      ]
    },
    {
      title: "2.3",
      instruction: "Expand your finger reach. Type these 3-letter combinations while maintaining a perfectly steady rhythm. If you make a mistake, do not panic—simply locate the correct key by feel, pull your fingers back to the home row, and continue the pattern.",
      text: [
        "gks gjk dgk lgh ",
        "djh gjh h'k j'k ",
        "ghd dhg f'g l'h ",
        "hgj hgk hgd hg' ",
        "gks gjk dgk lgh ",
        "djh gjh h'k j'k ",
        "ghd dhg f'g l'h ",
        "hgj hgk hgd hg' "
      ]
    },
    {
      title: "2.4",
      instruction: "Build fluid keystroke transitions. These 4-letter blocks require your fingers to move sequentially. Keep your wrists slightly elevated above the desk and let your fingers curl naturally over the keys. Breathe and maintain a steady pace.",
      text: [
        "dgks lgks djds gjds ",
        "ghdj dhgj h'kg j'kg ",
        "dghk lghk j'hk f'hk ",
        "gdhj lhgj j'gk g'hl ",
        "dgks lgks djds gjds ",
        "ghdj dhgj h'kg j'kg ",
        "dghk lghk j'hk f'hk ",
        "gdhj lhgj j'gk g'hl "
      ]
    },
    {
      title: "2.5",
      instruction: "Transition from abstract blocks to real typing patterns. Read the entire phrase in your mind before you start typing it. Connect the words smoothly, ensuring you strike the spacebar gently with the side of your resting thumb.",
      text: [
        "gh hg gk ",
        "dh l' j' ",
        "gks g'k d'k ",
        "dgks l'ks j'ds ",
        "gh hg gk ",
        "dh l' j' ",
        "gks g'k d'k ",
        "dgks l'ks j'ds "
      ]
    },
    {
      title: "2.6",
      instruction: "Endurance and stamina test. Type the full paragraph with deep focus to train your sustained muscle memory. You must press the ENTER key at the exact end of each paragraph to proceed. Prioritize absolute accuracy over speed.",
      text: [
        "gh hg gk hk gks gjk dgk lgh dgks lgks djds gjds",
        "dh lh jh fg djh gjh h'k j'k ghdj dhgj h'kg j'kg",
        "g' h' k' j' ghd dhg f'g l'h dghk lghk j'hk f'hk",
        "hf hg hd h' hgj hgk hgd hg' gdhj lhgj j'gk g'hl",
        "gh hg gk hk gks gjk dgk lgh dgks lgks djds gjds",
        "dh lh jh fg djh gjh h'k j'k ghdj dhgj h'kg j'kg"
      ]
    },

    // ------------------------------------------
    // Lesson 3: Top Row Left (q w e r t)
    // ------------------------------------------
    {
      title: "3.1",
      instruction: "Reach your left hand up to type q, w, e, r, and t.",
      text: [
        "Welcome to the Top Row! It is time to train your left hand to reach upwards. The secret to typing fast is keeping your base secure on the home row while only stretching the specific finger you need.",
        "Left Hand (Q, W, E): Keep your index finger anchored on 'F'. Stretch your pinky up to 'Q' (ु), your ring finger up to 'W' (ू), and your middle finger up to 'E' (म). After striking, always pull them back down to their resting spots.",
        "The Index Finger (R & T): Your left index finger has two jobs here. Stretch it straight up to tap 'R' (त), and reach up and slightly right to strike 'T' (ज). Immediately return it to the 'F' bump after every keystroke.",
        "The Golden Rule: Let your fingers do the reaching! Never move your entire wrist or slide your whole hand up the keyboard. Keep your wrists steady and slightly elevated."
      ],
      image: "/Lesson3krutidev.webp"
    },
    {
      title: "3.2",
      instruction: "Begin your muscle memory training. Type these precise 2-letter blocks arranged in a strict grid. Do not rush; focus entirely on hitting the exact center of each key without looking down at your hands. Accuracy builds speed.",
      text: [
        "ed ej ek eh ",
        "rd rj rk rh ",
        "td tj tk th ",
        "dq lq dw lw ",
        "ed ej ek eh ",
        "rd rj rk rh ",
        "td tj tk th ",
        "dq lq dw lw "
      ]
    },
    {
      title: "3.3",
      instruction: "Expand your finger reach. Type these 3-letter combinations while maintaining a perfectly steady rhythm. If you make a mistake, do not panic—simply locate the correct key by feel, pull your fingers back to the home row, and continue the pattern.",
      text: [
        "edj rek rdk tdk ",
        "rjt tjr edh ejh ",
        "rdj eqk teq req ",
        "der jer ler ker ",
        "edj rek rdk tdk ",
        "rjt tjr edh ejh ",
        "rdj eqk teq req ",
        "der jer ler ker "
      ]
    },
    {
      title: "3.4",
      instruction: "Build fluid keystroke transitions. These 4-letter blocks require your fingers to move sequentially. Keep your wrists slightly elevated above the desk and let your fingers curl naturally over the keys. Breathe and maintain a steady pace.",
      text: [
        "ekrk rkrk tjtk edkj ",
        "drjr trjr drer tred ",
        "dkej tkej rkej jker ",
        "derj jerj lerj kerj ",
        "ekrk rkrk tjtk edkj ",
        "drjr trjr drer tred ",
        "dkej tkej rkej jker ",
        "derj jerj lerj kerj "
      ]
    },
    {
      title: "3.5",
      instruction: "Transition from abstract blocks to real typing patterns. Read the entire phrase in your mind before you start typing it. Connect the words smoothly, ensuring you strike the spacebar gently with the side of your resting thumb.",
      text: [
        "ed ej ek ",
        "rd rj rk ",
        "edj rek rdk ",
        "ekrk rkrk tjtk ",
        "ed ej ek ",
        "rd rj rk ",
        "edj rek rdk ",
        "ekrk rkrk tjtk "
      ]
    },
    {
      title: "3.6",
      instruction: "Endurance and stamina test. Type the full paragraph with deep focus to train your sustained muscle memory. You must press the ENTER key at the exact end of each paragraph to proceed. Prioritize absolute accuracy over speed.",
      text: [
        "ed ej ek eh edj rek rdk tdk ekrk rkrk tjtk edkj",
        "rd rj rk rh rjt tjr edh ejh drjr trjr drer tred",
        "td tj tk th rdj eqk teq req dkej tkej rkej jker",
        "dq lq dw lw der jer ler ker derj jerj lerj kerj",
        "ed ej ek eh edj rek rdk tdk ekrk rkrk tjtk edkj",
        "rd rj rk rh rjt tjr edh ejh drjr trjr drer tred"
      ]
    },

    // ------------------------------------------
    // Lesson 4: Top Row Right (y u i o p [ ] \)
    // ------------------------------------------
    {
      title: "4.1",
      instruction: "Right hand reaches up for y, u, i, o, p, [, ], and \\.",
      text: [
        "Welcome to the Top Row Right! It is time to train your right hand to stretch upwards. Keep your index finger anchored on 'J' while the other fingers do the reaching.",
        "Right Hand (Y, U, I): Keep your index finger anchored on 'J'. Stretch your index finger up and left to 'Y' (ल), and straight up to 'U' (न). Stretch your middle finger up to 'I' (प). Always pull them back down to their resting spots.",
        "The Outer Reaches (O, P, [, ], \\): Stretch your ring finger up to 'O' (व). Stretch your pinky up to 'P' (च), '[' (ख), ']' (,), and all the way to '\\' (?). The pinky has to cover a lot of ground, so keep your wrist steady and let the finger stretch.",
        "The Golden Rule: Because the right pinky handles so many keys, beginners often twist their entire hand outward. Keep your hand straight, rely on your 'J' anchor, and let your pinky build the flexibility to reach!"
      ],
      image: "/Lesson4krutidev.webp"
    },
    {
      title: "4.2",
      instruction: "Begin your muscle memory training. Type these precise 2-letter blocks arranged in a strict grid. Do not rush; focus entirely on hitting the exact center of each key without looking down at your hands. Accuracy builds speed.",
      text: [
        "uk uh ik ih ",
        "ok oh pk ph ",
        "[k ]k \\k yk ",
        "uq iq oq pq ",
        "[q ]q \\q yq ",
        "ok oh pk ph ",
        "[k ]k \\k yk ",
        "uq iq oq pq "
      ]
    },
    {
      title: "4.3",
      instruction: "Expand your finger reach. Type these 3-letter combinations while maintaining a perfectly steady rhythm. If you make a mistake, do not panic—simply locate the correct key by feel, pull your fingers back to the home row, and continue the pattern.",
      text: [
        "ukj ikj okj pkj ",
        "[kj ]kj \\kj ykj ",
        "duy juy luy kuy ",
        "diy jiy liy kiy ",
        "ukj ikj okj pkj ",
        "[kj ]kj \\kj ykj ",
        "duy juy luy kuy ",
        "diy jiy liy kiy "
      ]
    },
    {
      title: "4.4",
      instruction: "Build fluid keystroke transitions. These 4-letter blocks require your fingers to move sequentially. Keep your wrists slightly elevated above the desk and let your fingers curl naturally over the keys. Breathe and maintain a steady pace.",
      text: [
        "ukuk ikik pkpk [k[k ",
        "]k]k \\k\\k ikuh uohj ",
        "duyu juyu luyu kuyu ",
        "diyi jiyi liyi kiyi ",
        "ukuk ikik pkpk [k[k ",
        "]k]k \\k\\k ikuh uohj ",
        "duyu juyu luyu kuyu ",
        "diyi jiyi liyi kiyi "
      ]
    },
    {
      title: "4.5",
      instruction: "Transition from abstract blocks to real typing patterns. Read the entire phrase in your mind before you start typing it. Connect the words smoothly, ensuring you strike the spacebar gently with the side of your resting thumb.",
      text: [
        "uk uh ik ",
        "ok oh pk ",
        "[k ]k \\k ",
        "ukuk ikik pkpk ",
        "uk uh ik ",
        "ok oh pk ",
        "[k ]k \\k ",
        "ukuk ikik pkpk "
      ]
    },
    {
      title: "4.6",
      instruction: "Endurance and stamina test. Type the full paragraph with deep focus to train your sustained muscle memory. You must press the ENTER key at the exact end of each paragraph to proceed. Prioritize absolute accuracy over speed.",
      text: [
        "uk uh ik ih ukj ikj okj pkj ukuk ikik pkpk [k[k",
        "ok oh pk ph [kj ]kj \\kj ykj ]k]k \\k\\k ikuh uohj",
        "[k [h ]k ]h duy juy luy kuy duyu juyu luyu kuyu",
        "\\k \\h yk yh diy jiy liy kiy diyi jiyi liyi kiyi",
        "uk uh ik ih ukj ikj okj pkj ukuk ikik pkpk [k[k",
        "ok oh pk ph [kj ]kj \\kj ykj ]k]k \\k\\k ikuh uohj"
      ]
    },

    // ------------------------------------------
    // Lesson 5: Bottom Row Left (z x c v b)
    // ------------------------------------------
    {
      title: "5.1",
      instruction: "Drop your left fingers down to type z, x, c, v, and b.",
      text: [
        "Welcome to the Bottom Row! Reaching downwards can feel a bit unnatural at first because your fingers have to curl inward. Do not flatten your hands; keep a natural curve as you pull your fingers downward.",
        "Left Hand (Z, X, C): Keep your left index finger anchored on the 'F' bump. Drop your pinky down to 'Z' (्र), your ring finger down to 'X' (ग), and your middle finger down to 'C' (ब). Pull them back up to the home row immediately after striking.",
        "The Index Finger (V & B): Your left index finger does double duty here. Drop it straight down to tap 'V' (अ), and reach down and slightly right to strike 'B' (इ). Always return to the 'F' bump to stay oriented.",
        "The Golden Rule: Because the bottom row requires curling, beginners often tend to drop their entire wrist onto the desk to reach. Keep your wrists slightly elevated to give your fingers the clearance they need to curl cleanly!"
      ],
      image: "/Lesson5krutidev.webp"
    },
    {
      title: "5.2",
      instruction: "Begin your muscle memory training. Type these precise 2-letter blocks arranged in a strict grid. Do not rush; focus entirely on hitting the exact center of each key without looking down at your hands. Accuracy builds speed.",
      text: [
        "xk xh ck ch ",
        "vk vh bk bh ",
        "zk zh cx vx ",
        "zx bx cv bv ",
        "xk xh ck ch ",
        "vk vh bk bh ",
        "zk zh cx vx ",
        "zx bx cv bv "
      ]
    },
    {
      title: "5.3",
      instruction: "Expand your finger reach. Type these 3-letter combinations while maintaining a perfectly steady rhythm. If you make a mistake, do not panic—simply locate the correct key by feel, pull your fingers back to the home row, and continue the pattern.",
      text: [
        "xkj ckj vkt ckr ",
        "vcx rcx dcx tcx ",
        "vcn rcn dcn tcn ",
        "vxj rxj cxj bxj ",
        "xkj ckj vkt ckr ",
        "vcx rcx dcx tcx ",
        "vcn rcn dcn tcn ",
        "vxj rxj cxj bxj "
      ]
    },
    {
      title: "5.4",
      instruction: "Build fluid keystroke transitions. These 4-letter blocks require your fingers to move sequentially. Keep your wrists slightly elevated above the desk and let your fingers curl naturally over the keys. Breathe and maintain a steady pace.",
      text: [
        "cktk xkuk vkyk xkyk ",
        "vcxc rcxc dcxc tcxc ",
        "vcnv rcnv dcnv tcnv ",
        "vxjk cxjk bxjk zxjk ",
        "cktk xkuk vkyk xkyk ",
        "vcxc rcxc dcxc tcxc ",
        "vcnv rcnv dcnv tcnv ",
        "vxjk cxjk bxjk zxjk "
      ]
    },
    {
      title: "5.5",
      instruction: "Transition from abstract blocks to real typing patterns. Read the entire phrase in your mind before you start typing it. Connect the words smoothly, ensuring you strike the spacebar gently with the side of your resting thumb.",
      text: [
        "xk xh ck ",
        "vk vh bk ",
        "xkj ckj vkt ",
        "cktk xkuk vkyk ",
        "xk xh ck ",
        "vk vh bk ",
        "xkj ckj vkt ",
        "cktk xkuk vkyk "
      ]
    },
    {
      title: "5.6",
      instruction: "Endurance and stamina test. Type the full paragraph with deep focus to train your sustained muscle memory. You must press the ENTER key at the exact end of each paragraph to proceed. Prioritize absolute accuracy over speed.",
      text: [
        "xk xh ck ch xkj ckj vkt ckr cktk xkuk vkyk xkyk",
        "vk vh bk bh vcx rcx dcx tcx vcxc rcxc dcxc tcxc",
        "zk zh cx vx vcn rcn dcn tcn vcnv rcnv dcnv tcnv",
        "zx bx cv bv vxj rxj cxj bxj vxjk cxjk bxjk zxjk",
        "xk xh ck ch xkj ckj vkt ckr cktk xkuk vkyk xkyk",
        "vk vh bk bh vcx rcx dcx tcx vcxc rcxc dcxc tcxc"
      ]
    },

    // ------------------------------------------
    // Lesson 6: Bottom Row Right (n m , . /)
    // ------------------------------------------
    {
      title: "6.1",
      instruction: "Drop your right fingers down to type n, m, comma (,), period (.), and slash (/).",
      text: [
        "Welcome to the Bottom Row Right! This lesson completes the primary unshifted characters of the Kruti Dev layout. Reaching downwards requires keeping a natural curve in your fingers without flattening your hand.",
        "The Index Finger (N & M): Keep your right index finger anchored on the 'J' bump. Drop it down and slightly left to tap 'N' (द), and straight down to tap 'M' (उ). Immediately pull it back to the home row after striking.",
        "The Outer Fingers (Comma, Period, Slash): Drop your right middle finger down to the Comma ',' (ए). Drop your ring finger down to the Period '.' (ण्). Drop your right pinky down to the Slash '/' (ध).",
        "Congratulations! You have now mapped all the core unshifted keys. The Golden Rule remains: keep your wrists slightly elevated above the desk. This gives your fingers the necessary clearance to curl downward cleanly without your hands dragging."
      ],
      image: "/Lesson6krutidev.webp"
    },
    {
      title: "6.2",
      instruction: "Begin your muscle memory training. Type these precise 2-letter blocks arranged in a strict grid. Do not rush; focus entirely on hitting the exact center of each key without looking down at your hands. Accuracy builds speed.",
      text: [
        "nk nh /k /h ",
        "mk mh ,k ,h ",
        ".k .h nm ,. ",
        "n/ m/ ,/ ./ ",
        "nk nh /k /h ",
        "mk mh ,k ,h ",
        ".k .h nm ,. ",
        "n/ m/ ,/ ./ "
      ]
    },
    {
      title: "6.3",
      instruction: "Expand your finger reach. Type these 3-letter combinations while maintaining a perfectly steady rhythm. If you make a mistake, do not panic—simply locate the correct key by feel, pull your fingers back to the home row, and continue the pattern.",
      text: [
        "nkj nku /ku mld ",
        "n,k m,k /,k .,k ",
        "ndk mdk ,dk /dk ",
        "n/k m/k ,/k ./k ",
        "nkj nku /ku mld ",
        "n,k m,k /,k .,k ",
        "ndk mdk ,dk /dk ",
        "n/k m/k ,/k ./k "
      ]
    },
    {
      title: "6.4",
      instruction: "Build fluid keystroke transitions. These 4-letter blocks require your fingers to move sequentially. Keep your wrists slightly elevated above the desk and let your fingers curl naturally over the keys. Breathe and maintain a steady pace.",
      text: [
        "nknk nknh /kuh mldk ",
        "n,k, m,k, /,k, .,k, ",
        "ndjk mdjk ,djk /djk ",
        "n/jk m/jk ,/jk ./jk ",
        "nknk nknh /kuh mldk ",
        "n,k, m,k, /,k, .,k, ",
        "ndjk mdjk ,djk /djk ",
        "n/jk m/jk ,/jk ./jk "
      ]
    },
    {
      title: "6.5",
      instruction: "Transition from abstract blocks to real typing patterns. Read the entire phrase in your mind before you start typing it. Connect the words smoothly, ensuring you strike the spacebar gently with the side of your resting thumb.",
      text: [
        "nk nh /k ",
        "mk mh ,k ",
        "nkj nku /ku ",
        "nknk nknh /kuh ",
        "nk nh /k ",
        "mk mh ,k ",
        "nkj nku /ku ",
        "nknk nknh /kuh "
      ]
    },
    {
      title: "6.6",
      instruction: "Endurance and stamina test. Type the full paragraph with deep focus to train your sustained muscle memory. You must press the ENTER key at the exact end of each paragraph to proceed. Prioritize absolute accuracy over speed.",
      text: [
        "nk nh /k /h. nkj nku /ku mld. nknk nknh /kuh mldk.",
        "mk mh ,k ,h. n,k m,k /,k .,k. n,k, m,k, /,k, .,k,.",
        ".k .h nm ,.. ndk mdk ,dk /dk. ndjk mdjk ,djk /djk.",
        "n/ m/ ,/ ./. n/k m/k ,/k ./k. n/jk m/jk ,/jk ./jk.",
        "nk nh /k /h. nkj nku /ku mld. nknk nknh /kuh mldk.",
        "mk mh ,k ,h. n,k m,k /,k .,k. n,k, m,k, /,k, .,k,."
      ]
    },

    // ------------------------------------------
    // Lesson 7: Left Hand (Top & Home Row) + Right Shift
    // ------------------------------------------
    {
      title: "7.1",
      instruction: "Hold Right Shift and type the Top & Home rows with your left hand, including the inward reach for G.",
      text: [
        "Welcome to Capitalization and Half-Letters! To type these special characters in Kruti Dev, you must use the Shift key. The unbreakable rule is to ALWAYS use the pinky finger of the OPPOSITE hand to hold down Shift.",
        "The Right Shift Anchor: Because we are typing with the left hand, reach your right pinky down to firmly hold the Right Shift key (indicated by the orange line). Do not twist your right wrist; keep your hand straight and let the pinky stretch.",
        "The Left Hand (Home Row): Keep holding Right Shift. Use your left fingers to type 'A' (ँ), 'S' (ै), 'D' (क्), and 'F' (थ). Finally, stretch your left index finger inward to type 'G' (ळ).",
        "The Left Hand (Top Row): Keep holding Right Shift. Reach your left fingers up to type 'Q' (फ), 'W' (ॅ), 'E' (म्), 'R' (त्), and 'T' (ज्). Let go of the Shift key immediately after completing your keystrokes to return to the resting home row."
      ],
      image: "/Lesson7krutidev.webp"
    },
    {
      title: "7.2",
      instruction: "Begin your muscle memory training. Type these precise 2-letter blocks arranged in a strict grid. Do not rush; focus entirely on hitting the exact center of each key without looking down at your hands. Accuracy builds speed.",
      text: [
        "Fk Fh Dk Dh ",
        "Sk Sh Ak Ah ",
        "Qk Qh Wk Wh ",
        "Ek Eh Rk Gk ",
        "Fk Fh Dk Dh ",
        "Sk Sh Ak Ah ",
        "Qk Qh Wk Wh ",
        "Ek Eh Rk Gk "
      ]
    },
    {
      title: "7.3",
      instruction: "Expand your finger reach. Type these 3-letter combinations while maintaining a perfectly steady rhythm. If you make a mistake, do not panic—simply locate the correct key by feel, pull your fingers back to the home row, and continue the pattern.",
      text: [
        "Fky Qky Dky Eky ",
        "Rky Tky Gky Sky ",
        "Fkj Qkj Dkj Ekj ",
        "Rkj Tkj Gkj Skj ",
        "Fky Qky Dky Eky ",
        "Rky Tky Gky Sky ",
        "Fkj Qkj Dkj Ekj ",
        "Rkj Tkj Gkj Skj "
      ]
    },
    {
      title: "7.4",
      instruction: "Build fluid keystroke transitions. These 4-letter blocks require your fingers to move sequentially. Keep your wrists slightly elevated above the desk and let your fingers curl naturally over the keys. Breathe and maintain a steady pace.",
      text: [
        "FkFk DkDk SkSk GkGk ",
        "QkQk WkWk EkEk RkRk ",
        "Fkyk Qkyk Dkyk Gkyk ",
        "Rkyk Tkyk Akyk Skyk ",
        "FkFk DkDk SkSk GkGk ",
        "QkQk WkWk EkEk RkRk ",
        "Fkyk Qkyk Dkyk Gkyk ",
        "Rkyk Tkyk Akyk Skyk "
      ]
    },
    {
      title: "7.5",
      instruction: "Transition from abstract blocks to real typing patterns. Read the entire phrase in your mind before you start typing it. Connect the words smoothly, ensuring you strike the spacebar gently with the side of your resting thumb.",
      text: [
        "Fk Fh Dk Gk ",
        "Sk Sh Ak Ah ",
        "Fky Qky Dky Gky ",
        "FkFk DkDk SkSk GkGk ",
        "Fk Fh Dk Gk ",
        "Sk Sh Ak Ah ",
        "Fky Qky Dky Gky ",
        "FkFk DkDk SkSk GkGk "
      ]
    },
    {
      title: "7.6",
      instruction: "Endurance and stamina test. Type the full paragraph with deep focus to train your sustained muscle memory. You must press the ENTER key at the exact end of each paragraph to proceed. Prioritize absolute accuracy over speed.",
      text: [
        "Fk Fh Dk Dh. Fky Qky Dky Gky. FkFk DkDk SkSk GkGk.",
        "Sk Sh Ak Ah. Rky Tky Aky Sky. QkQk WkWk EkEk RkRk.",
        "Qk Qh Wk Wh. Fkj Qkj Dkj Gkj. Fkyk Qkyk Dkyk Gkyk.",
        "Ek Eh Rk Rh. Rkj Tkj Akj Skj. Rkyk Tkyk Akyk Skyk.",
        "Fk Fh Dk Gk. Fky Qky Dky Gky. FkFk DkDk SkSk GkGk.",
        "Sk Sh Ak Ah. Rky Tky Aky Sky. QkQk WkWk EkEk RkRk."
      ]
    },

    // ------------------------------------------
    // Lesson 8: Left Hand (Bottom Row) + Right Shift
    // ------------------------------------------
    {
      title: "8.1",
      instruction: "Hold Right Shift and type the bottom row with your left hand.",
      text: [
        "Welcome to the Bottom Row Shifts! Curling your fingers downward while your opposite hand holds the Shift key is one of the most complex stretches in typing. Take your time and keep your wrists relaxed.",
        "The Right Shift Anchor: Reach your right pinky down to firmly hold the Right Shift key (indicated by the orange line). Keep your hand straight and avoid twisting your right wrist.",
        "Left Hand (Z, X, C): While holding Right Shift, drop your left pinky down to 'Z' (र्), your ring finger to 'X' (ग्), and your middle finger to 'C' (ब्). Return them to the home row immediately after each strike.",
        "The Index Finger (V & B): Keep holding Right Shift. Drop your left index finger straight down for 'V' (ट), and reach down and slightly right for 'B' (ठ). Ensure your left wrist stays elevated so your fingers have room to curl cleanly without your hand collapsing onto the keys."
      ],
      image: "/Lesson8krutidev.webp"
    },
    {
      title: "8.2",
      instruction: "Begin your muscle memory training. Type these precise 2-letter blocks arranged in a strict grid. Do not rush; focus entirely on hitting the exact center of each key without looking down at your hands. Accuracy builds speed.",
      text: [
        "Zk Zh Xk Xh ",
        "Ck Ch Vk Vh ",
        "Bk Bh Zk Xk ",
        "Ck Vk Bk Bh ",
        "Zk Zh Xk Xh ",
        "Ck Ch Vk Vh ",
        "Bk Bh Zk Xk ",
        "Ck Vk Bk Bh "
      ]
    },
    {
      title: "8.3",
      instruction: "Expand your finger reach. Type these 3-letter combinations while maintaining a perfectly steady rhythm. If you make a mistake, do not panic—simply locate the correct key by feel, pull your fingers back to the home row, and continue the pattern.",
      text: [
        "Zky Xky Cky Vky ",
        "Bky Zkj Xkj Ckj ",
        "Vkj Bkj Cky Vky ",
        "Zky Xky Bky Zkj ",
        "Zky Xky Cky Vky ",
        "Bky Zkj Xkj Ckj ",
        "Vkj Bkj Cky Vky ",
        "Zky Xky Bky Zkj "
      ]
    },
    {
      title: "8.4",
      instruction: "Build fluid keystroke transitions. These 4-letter blocks require your fingers to move sequentially. Keep your wrists slightly elevated above the desk and let your fingers curl naturally over the keys. Breathe and maintain a steady pace.",
      text: [
        "ZkZk XkXk CkCk VkVk ",
        "BkBk ZkXk CkVk BkZh ",
        "Zkyk Xkyk Ckyk Vkyk ",
        "Bkyk Zkyk Xkyk Ckyk ",
        "ZkZk XkXk CkCk VkVk ",
        "BkBk ZkXk CkVk BkZh ",
        "Zkyk Xkyk Ckyk Vkyk ",
        "Bkyk Zkyk Xkyk Ckyk "
      ]
    },
    {
      title: "8.5",
      instruction: "Transition from abstract blocks to real typing patterns. Read the entire phrase in your mind before you start typing it. Connect the words smoothly, ensuring you strike the spacebar gently with the side of your resting thumb.",
      text: [
        "Zk Zh Xk ",
        "Ck Ch Vk ",
        "Zky Xky Cky ",
        "ZkZk XkXk CkCk ",
        "Zk Zh Xk ",
        "Ck Ch Vk ",
        "Zky Xky Cky ",
        "ZkZk XkXk CkCk "
      ]
    },
    {
      title: "8.6",
      instruction: "Endurance and stamina test. Type the full paragraph with deep focus to train your sustained muscle memory. You must press the ENTER key at the exact end of each paragraph to proceed. Prioritize absolute accuracy over speed.",
      text: [
        "Zk Zh Xk Xh. Zky Xky Cky Vky. ZkZk XkXk CkCk VkVk.",
        "Ck Ch Vk Vh. Bky Zkj Xkj Ckj. BkBk ZkXk CkVk BkZh.",
        "Bk Bh Zk Xk. Vkj Bkj Cky Vky. Zkyk Xkyk Ckyk Vkyk.",
        "Ck Vk Bk Bh. Zky Xky Bky Zkj. Bkyk Zkyk Xkyk Ckyk.",
        "Zk Zh Xk Xh. Zky Xky Cky Vky. ZkZk XkXk CkCk VkVk.",
        "Ck Ch Vk Vh. Bky Zkj Xkj Ckj. BkBk ZkXk CkVk BkZh."
      ]
    },

    // ------------------------------------------
    // Lesson 9: Right Hand (Top & Home Row) + Left Shift
    // ------------------------------------------
    {
      title: "9.1",
      instruction: "Hold Left Shift and type the Top & Home rows with your right hand, including } and |.",
      text: [
        "Welcome to the Right Hand Shifts! Here you will practice holding the Left Shift key while your right hand navigates both the Home and Top rows, including the furthest outer reaches.",
        "The Left Shift Anchor: Use your left pinky to firmly press and hold the Left Shift key (indicated by the blue lines). Keep your left hand securely anchored on the desk to prevent your wrists from twisting.",
        "Right Hand (Home Row): While holding Left Shift, use your right fingers to strike 'H' (भ), 'J' (श्र), 'K' (ज्ञ), 'L' (स्), ':' (रू), and '\"' (ष्).",
        "Right Hand (Top Row & Extremes): Keep holding Left Shift. Stretch your right fingers up to type 'Y' (ल्), 'U' (न्), 'I' (प्), 'O' (व्), 'P' (च्), '{' (ख्), and push your pinky to its absolute limits for '}' (द्व) and '|' (द्य). Release the shift key immediately after completing the stroke."
      ],
      image: "/Lesson9krutidev.webp"
    },
    {
      title: "9.2",
      instruction: "Begin your muscle memory training. Type these precise 2-letter blocks arranged in a strict grid. Do not rush; focus entirely on hitting the exact center of each key without looking down at your hands. Accuracy builds speed.",
      text: [
        "Yk Yh Uk Uh ",
        "Ik Ih Ok Oh ",
        "Pk Ph {k }k ",
        "|k |h Hk Hh ",
        "Jk Jh Kk Kh ",
        "Lk Lh :k :h ",
        "\"k \"h }k |k ",
        "Yk Uk }k |k "
      ]
    },
    {
      title: "9.3",
      instruction: "Expand your finger reach. Type these 3-letter combinations while maintaining a perfectly steady rhythm. If you make a mistake, do not panic—simply locate the correct key by feel, pull your fingers back to the home row, and continue the pattern.",
      text: [
        "Ykj Ukj Ikj Okj ",
        "Pkj {kj }kj |kj ",
        "Hkj Jkj Kkj Lkj ",
        ":kj \"kj }kj |kj ",
        "Ykj Ukj Ikj Okj ",
        "Pkj {kj }kj |kj ",
        "Hkj Jkj Kkj Lkj ",
        ":kj \"kj }kj |kj "
      ]
    },
    {
      title: "9.4",
      instruction: "Build fluid keystroke transitions. These 4-letter blocks require your fingers to move sequentially. Keep your wrists slightly elevated above the desk and let your fingers curl naturally over the keys. Breathe and maintain a steady pace.",
      text: [
        "YkYk UkUk IkIk OkOk ",
        "PkPk {k{k }k}k |k|k ",
        "HkHk JkJk KkKk LkLk ",
        ":k:k \"k\"k }k}k |k|k ",
        "YkYk UkUk IkIk OkOk ",
        "PkPk {k{k }k}k |k|k ",
        "HkHk JkJk KkKk LkLk ",
        ":k:k \"k\"k }k}k |k|k "
      ]
    },
    {
      title: "9.5",
      instruction: "Transition from abstract blocks to real typing patterns. Read the entire phrase in your mind before you start typing it. Connect the words smoothly, ensuring you strike the spacebar gently with the side of your resting thumb.",
      text: [
        "Yk Yh Uk ",
        "Ik Ih Ok ",
        "Ykj Ukj Ikj ",
        "YkYk UkUk IkIk ",
        "}k }h |k ",
        "Pkj {kj }kj ",
        "PkPk {k{k }k}k ",
        "}k}k |k|k \"k\"k "
      ]
    },
    {
      title: "9.6",
      instruction: "Endurance and stamina test. Type the full paragraph with deep focus to train your sustained muscle memory. You must press the ENTER key at the exact end of each paragraph to proceed. Prioritize absolute accuracy over speed.",
      text: [
        "Yk Yh Uk Uh. Ykj Ukj Ikj Okj. YkYk UkUk IkIk OkOk.",
        "Ik Ih Ok Oh. Pkj {kj }kj |kj. PkPk {k{k }k}k |k|k.",
        "Pk Ph {k {h. Kkj Lkj :kj \"kj. KkKk LkLk :k:k \"k\"k.",
        "Hk Hh Jk Jh. Yky Uky Iky Oky. Ykyk Ukyk }kyk |kyk.",
        "Yk Yh Uk Uh. Ykj Ukj Ikj Okj. YkYk UkUk IkIk OkOk.",
        "Ik Ih Ok Oh. Pkj {kj }kj |kj. PkPk {k{k }k}k |k|k."
      ]
    },

    // ------------------------------------------
    // Lesson 10: Right Hand (Bottom Row) + Left Shift
    // ------------------------------------------
    {
      title: "10.1",
      instruction: "Hold Left Shift and type the bottom row with your right hand.",
      text: [
        "Welcome to the final shift lesson! Dropping your right fingers downward while holding the Left Shift key requires focus and coordination. Keep your hands relaxed.",
        "The Left Shift Anchor: Use your left pinky to firmly press and hold the Left Shift key (indicated by the solid blue line). Keep your left wrist steady and avoid twisting your hand.",
        "The Index Finger (N & M): While holding Left Shift, drop your right index finger down and slightly left to tap 'N' (छ), and straight down to tap 'M' (ड). Return it to the home row immediately.",
        "The Outer Fingers (<, >, ?): Keep holding Left Shift. Drop your right middle finger down to '<' (ढ), your ring finger to '>' (झ), and your right pinky to '?' (घ). Always keep your wrists elevated to allow your fingers to curl cleanly!"
      ],
      image: "/Lesson10krutidev.webp"
    },
    {
      title: "10.2",
      instruction: "Begin your muscle memory training. Type these precise 2-letter blocks arranged in a strict grid. Do not rush; focus entirely on hitting the exact center of each key without looking down at your hands. Accuracy builds speed.",
      text: [
        "Nk Nh Mk Mh ",
        "<k <h >k >h ",
        "?k ?h Nk Mk ",
        "<k >k ?k Nh ",
        "Nk Nh Mk Mh ",
        "<k <h >k >h ",
        "?k ?h Nk Mk ",
        "<k >k ?k Nh "
      ]
    },
    {
      title: "10.3",
      instruction: "Expand your finger reach. Type these 3-letter combinations while maintaining a perfectly steady rhythm. If you make a mistake, do not panic—simply locate the correct key by feel, pull your fingers back to the home row, and continue the pattern.",
      text: [
        "Nkj Mkj <kj >kj ",
        "?kj Nky Mky <ky ",
        ">ky ?ky Nkj Mkj ",
        "<kj >kj ?kj Nky ",
        "Nkj Mkj <kj >kj ",
        "?kj Nky Mky <ky ",
        ">ky ?ky Nkj Mkj ",
        "<kj >kj ?kj Nky "
      ]
    },
    {
      title: "10.4",
      instruction: "Build fluid keystroke transitions. These 4-letter blocks require your fingers to move sequentially. Keep your wrists slightly elevated above the desk and let your fingers curl naturally over the keys. Breathe and maintain a steady pace.",
      text: [
        "NkNk MkMk <k<k >k>k ",
        "?k?k NkMk <k>k ?kNh ",
        "Nkyk Mkyk <kyk >kyk ",
        "?kyk Nkyk Mkyk <kyk ",
        "NkNk MkMk <k<k >k>k ",
        "?k?k NkMk <k>k ?kNh ",
        "Nkyk Mkyk <kyk >kyk ",
        "?kyk Nkyk Mkyk <kyk "
      ]
    },
    {
      title: "10.5",
      instruction: "Transition from abstract blocks to real typing patterns. Read the entire phrase in your mind before you start typing it. Connect the words smoothly, ensuring you strike the spacebar gently with the side of your resting thumb.",
      text: [
        "Nk Nh Mk ",
        "<k <h >k ",
        "Nkj Mkj <kj ",
        "NkNk MkMk <k<k ",
        "Nk Nh Mk ",
        "<k <h >k ",
        "Nkj Mkj <kj ",
        "NkNk MkMk <k<k "
      ]
    },
    {
      title: "10.6",
      instruction: "Endurance and stamina test. Type the full paragraph with deep focus to train your sustained muscle memory. You must press the ENTER key at the exact end of each paragraph to proceed. Prioritize absolute accuracy over speed.",
      text: [
        "Nk Nh Mk Mh. Nkj Mkj <kj >kj. NkNk MkMk <k<k >k>k.",
        "<k <h >k >h. ?kj Nky Mky <ky. ?k?k NkMk <k>k ?kNh.",
        "?k ?h Nk Mk. >ky ?ky Nkj Mkj. Nkyk Mkyk <kyk >kyk.",
        "<k >k ?k Nh. <kj >kj ?kj Nky. ?kyk Nkyk Mkyk <kyk.",
        "Nk Nh Mk Mh. Nkj Mkj <kj >kj. NkNk MkMk <k<k >k>k.",
        "<k <h >k >h. ?kj Nky Mky <ky. ?k?k NkMk <k>k ?kNh."
      ]
    },

    // ------------------------------------------
    // Lesson 11: Number Row (` 1 2 3 4 5 6 7 8 9 0 - =)
    // ------------------------------------------
    {
      title: "11.1",
      instruction: "Reach up to the number row, including the backtick (`), hyphen (-), and equals (=) keys.",
      text: [
        "Welcome to the Number Row! This is the furthest reach your fingers will make. Always feel for the tactile bumps on the 'F' and 'J' keys to re-center your hands quickly after striking these keys.",
        "The Left Hand: Stretch your left pinky far up and left for the backtick (`) and straight up for '1'. Use your ring finger for '2', middle finger for '3', and let your index finger stretch to both '4' and '5'.",
        "The Right Hand: Your right index finger reaches up to '6' and '7'. Use your middle finger for '8', and ring finger for '9'. Stretch your right pinky up for '0', the hyphen (-), and the equals (=) key.",
        "The Golden Rule: Because the number row is so far away, it is very tempting to lift your hands completely off the keyboard. Try to keep your wrists anchored and let your fingers do the stretching!"
      ],
      image: "/Lesson11krutidev.webp"
    },
    {
      title: "11.2",
      instruction: "Begin your muscle memory training. Type these precise 2-letter blocks arranged in a strict grid. Do not rush; focus entirely on hitting the exact center of each key without looking down at your hands. Accuracy builds speed.",
      text: [
        "`d 1d 2d 3d ",
        "4d 5d 6k 7k ",
        "8k 9k 0k -k ",
        "=k d` k- k= ",
        "`d 1d 2d 3d ",
        "4d 5d 6k 7k ",
        "8k 9k 0k -k ",
        "=k d` k- k= "
      ]
    },
    {
      title: "11.3",
      instruction: "Expand your finger reach. Type these 3-letter combinations while maintaining a perfectly steady rhythm. If you make a mistake, do not panic—simply locate the correct key by feel, pull your fingers back to the home row, and continue the pattern.",
      text: [
        "`dj 1dj 2dj 3dj ",
        "4dj 5dj 6jk 7jk ",
        "8jk 9jk 0jk -jk ",
        "=jk j`d j-k j=k ",
        "`dj 1dj 2dj 3dj ",
        "4dj 5dj 6jk 7jk ",
        "8jk 9jk 0jk -jk ",
        "=jk j`d j-k j=k "
      ]
    },
    {
      title: "11.4",
      instruction: "Build fluid keystroke transitions. These 4-letter blocks require your fingers to move sequentially. Keep your wrists slightly elevated above the desk and let your fingers curl naturally over the keys. Breathe and maintain a steady pace.",
      text: [
        "`djk 1djk 2djk 3djk ",
        "4djk 5djk 6jkl 7jkl ",
        "8jkl 9jkl 0jkl -jkl ",
        "=jkl kj`d kj-k kj=k ",
        "`djk 1djk 2djk 3djk ",
        "4djk 5djk 6jkl 7jkl ",
        "8jkl 9jkl 0jkl -jkl ",
        "=jkl kj`d kj-k kj=k "
      ]
    },
    {
      title: "11.5",
      instruction: "Transition from abstract blocks to real typing patterns. Read the entire phrase in your mind before you start typing it. Connect the words smoothly, ensuring you strike the spacebar gently with the side of your resting thumb.",
      text: [
        "`d 1d 2d ",
        "8k 9k 0k ",
        "-k =k `dj ",
        "-jk =jk `djk ",
        "`d 1d 2d ",
        "8k 9k 0k ",
        "-k =k `dj ",
        "-jk =jk `djk "
      ]
    },
    {
      title: "11.6",
      instruction: "Endurance and stamina test. Type the full paragraph with deep focus to train your sustained muscle memory. You must press the ENTER key at the exact end of each paragraph to proceed. Prioritize absolute accuracy over speed.",
      text: [
        "`d 1d 2d 3d. `dj 1dj 2dj 3dj. `djk 1djk 2djk 3djk.",
        "4d 5d 6k 7k. 4dj 5dj 6jk 7jk. 4djk 5djk 6jkl 7jkl.",
        "8k 9k 0k -k. 8jk 9jk 0jk -jk. 8jkl 9jkl 0jkl -jkl.",
        "=k d` k- k=. =jk j`d j-k j=k. =jkl kj`d kj-k kj=k.",
        "`d 1d 2d 3d. `dj 1dj 2dj 3dj. `djk 1djk 2djk 3djk.",
        "4d 5d 6k 7k. 4dj 5dj 6jk 7jk. 4djk 5djk 6jkl 7jkl."
      ]
    },

    // ------------------------------------------
    // Lesson 12: Symbols & Modifiers (~ ! @ # $ % ^ & * ( ) _ +)
    // ------------------------------------------
    {
      title: "12.1",
      instruction: "Use Shift with numbers to type symbols, including tilde (~), underscore (_), and plus (+).",
      text: [
        "Welcome to Symbols and Modifiers! This lesson combines the extreme upward stretches of the number row with the cross-hand coordination of the Shift key.",
        "Left Hand Symbols: Hold the Right Shift key with your right pinky. Use your left hand fingers to reach up and type '~', '!', '@', '#', '$', and '%'.",
        "Right Hand Symbols: Hold the Left Shift key with your left pinky. Use your right hand fingers to reach up and type '^', '&', '*', '(', ')', '_', and '+'.",
        "The Golden Rule: Because these are the longest and most complex reaches on the keyboard, accuracy is far more important than speed. Take your time, keep your anchor fingers grounded when possible, and always use the opposite hand for the shift key."
      ],
      image: "/Lesson12krutidev.webp"
    },
    {
      title: "12.2",
      instruction: "Begin your muscle memory training. Type these precise 2-letter blocks arranged in a strict grid. Do not rush; focus entirely on hitting the exact center of each key without looking down at your hands. Accuracy builds speed.",
      text: [
        "~k !k @k #k ",
        "$k %k ^k &k ",
        "*k (k )k _k ",
        "+k k~ k_ k+ ",
        "~k !k @k #k ",
        "$k %k ^k &k ",
        "*k (k )k _k ",
        "+k k~ k_ k+ "
      ]
    },
    {
      title: "12.3",
      instruction: "Expand your finger reach. Type these 3-letter combinations while maintaining a perfectly steady rhythm. If you make a mistake, do not panic—simply locate the correct key by feel, pull your fingers back to the home row, and continue the pattern.",
      text: [
        "~kj !kj @kj #kj ",
        "$kj %kj ^kj &kj ",
        "*kj (kj )kj _kj ",
        "+kj j~k j_k j+k ",
        "~kj !kj @kj #kj ",
        "$kj %kj ^kj &kj ",
        "*kj (kj )kj _kj ",
        "+kj j~k j_k j+k "
      ]
    },
    {
      title: "12.4",
      instruction: "Build fluid keystroke transitions. These 4-letter blocks require your fingers to move sequentially. Keep your wrists slightly elevated above the desk and let your fingers curl naturally over the keys. Breathe and maintain a steady pace.",
      text: [
        "~kjk !kjk @kjk #kjk ",
        "$kjk %kjk ^kjk &kjk ",
        "*kjk (kjk )kjk _kjk ",
        "+kjk kj~k kj_k kj+k ",
        "~kjk !kjk @kjk #kjk ",
        "$kjk %kjk ^kjk &kjk ",
        "*kjk (kjk )kjk _kjk ",
        "+kjk kj~k kj_k kj+k "
      ]
    },
    {
      title: "12.5",
      instruction: "Transition from abstract blocks to real typing patterns. Read the entire phrase in your mind before you start typing it. Connect the words smoothly, ensuring you strike the spacebar gently with the side of your resting thumb.",
      text: [
        "~k !k @k ",
        "*k )k _k ",
        "+k ~kj _kj ",
        "+kjk ~kjk _kjk ",
        "~k !k @k ",
        "*k )k _k ",
        "+k ~kj _kj ",
        "+kjk ~kjk _kjk "
      ]
    },
    {
      title: "12.6",
      instruction: "Endurance and stamina test. Type the full paragraph with deep focus to train your sustained muscle memory. You must press the ENTER key at the exact end of each paragraph to proceed. Prioritize absolute accuracy over speed.",
      text: [
        "~k !k @k #k. ~kj !kj @kj #kj. ~kjk !kjk @kjk #kjk.",
        "$k %k ^k &k. $kj %kj ^kj &kj. $kjk %kjk ^kjk &kjk.",
        "*k (k )k _k. *kj (kj )kj _kj. *kjk (kjk )kjk _kjk.",
        "+k k~ k_ k+. +kj j~k j_k j+k. +kjk kj~k kj_k kj+k.",
        "~k !k @k #k. ~kj !kj @kj #kj. ~kjk !kjk @kjk #kjk.",
        "$k %k ^k &k. $kj %kj ^kj &kj. $kjk %kjk ^kjk &kjk."
      ]
    },

    // ------------------------------------------
    // Lesson 13: Real Passages 1
    // ------------------------------------------
    {
      title: "13.1",
      instruction: "You have learned all the keys! Now practice full passages.",
      text: [
        "Congratulations! You have successfully learned the location of every single key on the Kruti Dev keyboard layout.",
        "In this section, you will transition from typing abstract blocks of characters to typing real, meaningful Hindi sentences and paragraphs.",
        "Let your subconscious muscle memory guide your fingers to the correct shapes. Do not look down at your hands, even if you make a mistake.",
        "Accuracy is your absolute primary goal right now. Type at a steady, relaxed pace. As your accuracy improves, your typing speed will naturally follow!"
      ],
      image: null
    },
    {
      title: "13.2",
      mode: "paragraph",
      instruction: "Full Paragraph Practice 1.",
      text: [
        "Hkkjr ,d fo'kky ns'k gSA bldh laLd`fr izkphu gSA",
        ";gka fofHkUu /keZ vkSj tkfr ds yksx jgrs gSaA",
        "ge lc feytqydj igys vius ns'k dk uke Åapk djsaA",
        "Hkkjr ,d fo'kky ns'k gSA bldh laLd`fr izkphu gSA",
        ";gka fofHkUu /keZ vkSj tkfr ds yksx jgrs gSaA",
        "ge lc feytqydj igys vius ns'k dk uke Åapk djsaA"
      ]
    },
    {
      title: "13.3",
      mode: "paragraph",
      instruction: "Full Paragraph Practice 2.",
      text: [
        "lHkh Hkkjrh; feytqydj izse ls jgrs gSaA",
        "gekjh laLd`fr cgqr iqjkuh vkSj esgur dh gSA",
        "ge vius ns'k ds fodkl esa mUufr ykldrs gSaA",
        "lHkh Hkkjrh; feytqydj izse ls jgrs gSaA",
        "gekjh laLd`fr cgqr iqjkuh vkSj esgur dh gSA",
        "ge vius ns'k ds fodkl esa mUufr ykldrs gSaA"
      ]
    },
    {
      title: "13.4",
      mode: "paragraph",
      instruction: "Full Paragraph Practice 3.",
      text: [
        "ns'k dh jkt/kkuh ubZ fnYyh gekjs fy, xkSjo gSA",
        "xaxk gekjh ikou unh gS ftlesa ty cgrk gSA",
        "igkM+ vkSj taxy bls cM+k lqanj cukrs gSaA",
        "ns'k dh jkt/kkuh ubZ fnYyh gekjs fy, xkSjo gSA",
        "xaxk gekjh ikou unh gS ftlesa ty cgrk gSA",
        "igkM+ vkSj taxy bls cM+k lqanj cukrs gSaA"
      ]
    },
    {
      title: "13.5",
      mode: "paragraph",
      instruction: "Full Paragraph Practice 4.",
      text: [
        "f'k{kk thou dk ewy eU= gS ftlls dke;kch gSA",
        "fcuk f'k{kk ds ekuo viuk y{; ugha ik ldrkA",
        "gesa ges'kk f'k{kk izkIr djds vkxs c<+uk pkfg,A",
        "f'k{kk thou dk ewy eU= gS ftlls dke;kch gSA",
        "fcuk f'k{kk ds ekuo viuk y{; ugha ik ldrkA",
        "gesa ges'kk f'k{kk izkIr djds vkxs c<+uk pkfg,A"
      ]
    },
    {
      title: "13.6",
      mode: "paragraph",
      instruction: "Full Paragraph Practice 5.",
      text: [
        "ifjJe gh lQyrk dh lPph dqath dgykrh gSA",
        "dHkh Hkh fujk'k ugha gksuk pkfg, vkSj pyrs jgksA",
        "lgh fn'kk esa fd;k x;k dke dHkh O;FkZ ugha gksrkA",
        "ifjJe gh lQyrk dh lPph dqath dgykrh gSA",
        "dHkh Hkh fujk'k ugha gksuk pkfg, vkSj pyrs jgksA",
        "lgh fn'kk esa fd;k x;k dke dHkh O;FkZ ugha gksrkA"
      ]
    },

    // ------------------------------------------
    // Lesson 14: Real Passages 2
    // ------------------------------------------
    {
      title: "14.1",
      mode: "paragraph",
      instruction: "Final Master Level. Prove your speed and rhythm.",
      text: [
        "Welcome to the Final Master Level! You are now typing complex paragraphs that require deep focus and sustained stamina.",
        "This is the ultimate test of your muscle memory. Maintain a perfectly steady rhythm, striking the keys with even pressure and pacing.",
        "If you make an error, do not panic or let it break your rhythm. Recover gracefully and keep pushing forward like a professional typist.",
        "Keep your wrists elevated, breathe naturally, and trust your hands. You are ready for this!"
      ],
      image: null
    },
    {
      title: "14.2",
      mode: "paragraph",
      instruction: "Master Paragraph Practice 1.",
      text: [
        "fo|ky; Kku dk eafnj gS tgka f'k{kk feyrh gSA",
        "x1#tu gesa vPNk jkLrk vkSj lEeku fl[kkrs gSaA",
        "fo|kFkkhZ thou rils Hkjh yxu dk le; gksrk gSA",
        "fo|ky; Kku dk eafnj gS tgka f'k{kk feyrh gSA",
        "x1#tu gesa vPNk jkLrk vkSj lEeku fl[kkrs gSaA",
        "fo|kFkkhZ thou rils Hkjh yxu dk le; gksrk gSA"
      ]
    },
    {
      title: "14.3",
      mode: "paragraph",
      instruction: "Master Paragraph Practice 2.",
      text: [
        "vkt dk le; rafudh vkSj mUufr dk dky gSA",
        "gesa le; ds lkFh feydj dke djuk lq[kn gSA",
        "ubZ phtksa dks fl[kuk ykHkdkjh vksj csgrj gSA",
        "vkt dk le; rafudh vkSj mUufr dk dky gSA",
        "gesa le; ds lkFh feydj dke djuk lq[kn gSA",
        "ubZ phtksa dks fl[kuk ykHkdkjh vksj csgrj gSA"
      ]
    },
    {
      title: "14.4",
      mode: "paragraph",
      instruction: "Master Paragraph Practice 3.",
      text: [
        "lqcg tYnh mBuk Loj vksj LokLF; ds fy, vPNk gSA",
        "O;k;ke djus ls 'kjhj lqanj vkSj rkdroj curk gSA",
        "gesa izfrfnu mBdj izkFkZuk djds izkjEHk djuk pkfg,A",
        "lqcg tYnh mBuk Loj vksj LokLF; ds fy, vPNk gSA",
        "O;k;ke djus ls 'kjhj lqanj vkSj rkdroj curk gSA",
        "gesa izfrfnu mBdj izkFkZuk djds izkjEHk djuk pkfg,A"
      ]
    },
    {
      title: "14.5",
      mode: "paragraph",
      instruction: "Master Paragraph Practice 4.",
      text: [
        "fe=rk lcls vPNk vksj fuLokFkZ lac/a gksrk gSA",
        "lPpk fe= gelk eq'ldy le; esa dke vkrk gSA",
        "gesa vius nksLrksa ds lkFk dHkh >wB ugha cksyuk pkfg,A",
        "fe=rk lcls vPNk vksj fuLokFkZ lac/a gksrk gSA",
        "lPpk fe= gelk eq'ldy le; esa dke vkrk gSA",
        "gesa vius nksLrksa ds lkFk dHkh >wB ugha cksyuk pkfg,A"
      ]
    },
    {
      title: "14.6",
      mode: "paragraph",
      instruction: "Master Paragraph Practice 5.",
      text: [
        "i;kZoj.k dh j{kk djuk gekjk lHkh dk dRkZO; gSA",
        "isM+ ikS/ks gekjh /kjrh dks thou inku djrs gSaA",
        "ty iznw\"k.k jksduk gekjh ijEijk vkSj /keZ gSA",
        "i;kZoj.k dh j{kk djuk gekjk lHkh dk dRkZO; gSA",
        "isM+ ikS/ks gekjh /kjrh dks thou inku djrs gSaA",
        "ty iznw\"k.k jksduk gekjh ijEijk vkSj /keZ gSA"
      ]
    }
  ];
};

// ==========================================
// 🇮🇳 HINDI (MANGAL INSCRIPT) LESSON CURRICULUM
// ==========================================
export const getMangalInscriptLessons = () => {
  return [
    // ------------------------------------------
    // Lesson 1: Home Row Core (a s d f j k l ;)
    // ------------------------------------------
    {
      title: "1.1",
      instruction: "Welcome to Mangal InScript! Place your fingers on the Home Row.",
      text: [
        "Welcome to Mangal InScript! Unlike Kruti Dev, this layout is completely phonetic. The left hand controls vowels and matras, while the right hand controls consonants.",
        "The Left Hand: Rest your pinky lightly on 'A' (ो), your ring finger on 'S' (े), your middle finger on 'D' (् - halant), and anchor your index finger firmly on 'F' (ि).",
        "The Right Hand: Anchor your right index finger firmly on 'J' (र), your middle finger on 'K' (क), your ring finger on 'L' (त), and rest your pinky on the semicolon ';' (च).",
        "The Golden Rule: Gently rub the 'F' and 'J' keys to feel the small physical bumps. Keep your wrists elevated and never look down at your hands. Accuracy is your priority."
      ],
      image: "/Homerowinscriptkeys.webp"
    },
    {
      title: "1.2",
      instruction: "Begin your muscle memory training. Type these precise 2-letter blocks arranged in a strict grid. Do not rush; focus entirely on hitting the exact center of each key without looking down at your hands. Accuracy builds speed.",
      text: [
        "कर तक चर रक ",
        "कि ति चि रि ",
        "के ते चे रे ",
        "को तो चो रो ",
        "रक चर तक कर ",
        "रि चि ति कि ",
        "रे चे ते के ",
        "रो चो तो को "
      ]
    },
    {
      title: "1.3",
      instruction: "Expand your finger reach. Type these 3-letter combinations while maintaining a perfectly steady rhythm. If you make a mistake, do not panic—simply locate the correct key by feel, pull your fingers back to the home row, and continue the pattern.",
      text: [
        "करक तकर चरक रकर ",
        "किर तिर चिर रिर ",
        "केर तेर चेर रेर ",
        "कोर तोर चोर रोर ",
        "तकत चकत रकत कतक ",
        "तिक चित रित कित ",
        "तेत चेत रेत केत ",
        "तोत चोत रोत कोत "
      ]
    },
    {
      title: "1.4",
      instruction: "Build fluid keystroke transitions. These 4-letter blocks require your fingers to move sequentially. Keep your wrists slightly elevated above the desk and let your fingers curl naturally over the keys. Breathe and maintain a steady pace.",
      text: [
        "करतक चरकर रकचर तकरक ",
        "किरि तिरि चिरि रिकि ",
        "केरे तेरे चेरे रेके ",
        "कोरो तोरो चोरो रोको ",
        "तकरक करतक रकचर चरकर ",
        "तिरि किरि रिकि चिरि ",
        "तेरे केरे रेके चेरे ",
        "तोरो कोरो रोको चोरो "
      ]
    },
    {
      title: "1.5",
      instruction: "Transition from abstract blocks to real typing patterns. Read the entire phrase in your mind before you start typing it. Connect the words smoothly, ensuring you strike the spacebar gently with the side of your resting thumb.",
      text: [
        "कर तक चर ",
        "कि ति चि ",
        "करक तकर चरक ",
        "करतक चरकर रकचर ",
        "के ते चे ",
        "कोर तोर चोर ",
        "केरे तेरे चेरे ",
        "कोरो तोरो चोरो "
      ]
    },
    {
      title: "1.6",
      instruction: "Endurance and stamina test. Type the full paragraph with deep focus to train your sustained muscle memory. You must press the ENTER key at the exact end of each paragraph to proceed. Prioritize absolute accuracy over speed.",
      text: [
        "कर तक चर रक कि ति चि रि के ते चे रे को तो चो रो",
        "रक चर तक कर रि चि ति कि रे चे ते के रो चो तो को",
        "करक तकर चरक रकर किर तिर चिर रिर केर तेर चेर रेर",
        "कोर तोर चोर रोर तकत चकत रकत कतक तिक चित रित कित",
        "तेत चेत रेत केत तोत चोत रोत कोत करतक चरकर रकचर तकरक",
        "किरि तिरि चिरि रिकि केरे तेरे चेरे रेके कोरो तोरो चोरो रोको"
      ]
    },

    // ------------------------------------------
    // Lesson 2: Home Row Extensions (g h ')
    // ------------------------------------------
    {
      title: "2.1",
      instruction: "Reach your index fingers inward for g and h, and your right pinky outward for the apostrophe (').",
      text: [
        "Welcome to the home row extensions! In this lesson, you will practice reaching sideways into the middle of the keyboard, as well as stretching your pinky outward.",
        "The Index Fingers (G & H): Stretch your left index finger inward to the right to tap the 'G' (ु) key. Stretch your right index finger inward to the left to tap the 'H' (प) key. Always feel for the F and J bumps to return.",
        "The Right Pinky (Apostrophe): Keep your right index finger firmly planted on 'J'. Reach your right pinky outward to the right to strike the Apostrophe (') key, which types 'ट'. Once pressed, snap it back to the semicolon.",
        "The Golden Rule: The biggest temptation during sideways reaches is to let your entire hand slide across the keyboard. Resist it! Keep your wrists perfectly still and let only the reaching fingers move."
      ],
      image: "/Lesson2inscript.webp"
    },
    {
      title: "2.2",
      instruction: "Begin your muscle memory training. Type these precise 2-letter blocks arranged in a strict grid. Do not rush; focus entirely on hitting the exact center of each key without looking down at your hands. Accuracy builds speed.",
      text: [
        "पर पक पत पच ",
        "टर टक तट टप ",
        "पु कु तु चु ",
        "टु रु कु पु ",
        "पट कप टप रट ",
        "चप तप कच रप ",
        "पु चु टु कु ",
        "पर पक पत पच "
      ]
    },
    {
      title: "2.3",
      instruction: "Expand your finger reach. Type these 3-letter combinations while maintaining a perfectly steady rhythm. If you make a mistake, do not panic—simply locate the correct key by feel, pull your fingers back to the home row, and continue the pattern.",
      text: [
        "पकप टकट कटक रपर ",
        "पुत कुप चुट टुर ",
        "पिक टिक किप चिप ",
        "पेक टेक केप चेप ",
        "पोट टोप कोप चोर ",
        "कपु टपु पकु कुट ",
        "पटर टपर करट रपट ",
        "तुर पुर चुर कुर "
      ]
    },
    {
      title: "2.4",
      instruction: "Build fluid keystroke transitions. These 4-letter blocks require your fingers to move sequentially. Keep your wrists slightly elevated above the desk and let your fingers curl naturally over the keys. Breathe and maintain a steady pace.",
      text: [
        "परपक टरटक करकच रपरट ",
        "पुकु चुतु टुरु कुपु ",
        "पिकि टिकि किपि चिपि ",
        "पेके टेके केपे चेपे ",
        "पोको टोको कोपो चोपो ",
        "पटरट टपटर करपट रपटर ",
        "पुरु चुरु कुरु टुरु ",
        "पिरि टिरि किरि चिरि "
      ]
    },
    {
      title: "2.5",
      instruction: "Transition from abstract blocks to real typing patterns. Read the entire phrase in your mind before you start typing it. Connect the words smoothly, ensuring you strike the spacebar gently with the side of your resting thumb.",
      text: [
        "पर पक पत ",
        "पु कु तु ",
        "पकप टकट कटक ",
        "परपक टरटक करकच ",
        "टर टक तट ",
        "टु रु कु ",
        "पुत कुप चुट ",
        "पुकु चुतु टुरु "
      ]
    },
    {
      title: "2.6",
      instruction: "Endurance and stamina test. Type the full paragraph with deep focus to train your sustained muscle memory. You must press the ENTER key at the exact end of each paragraph to proceed. Prioritize absolute accuracy over speed.",
      text: [
        "पर पक पत पच टर टक तट टप पु कु तु चु टु रु कु पु",
        "पट कप टप रट चप तप कच रप पकप टकट कटक रपर",
        "पुत कुप चुट टुर पिक टिक किप चिप पेक टेक केप चेप",
        "पोट टोप कोप चोर कपु टपु पकु कुट पटर टपर करट रपट",
        "परपक टरटक करकच रपरट पुकु चुतु टुरु कुपु पिकि टिकि किपि चिपि",
        "पेके टेके केपे चेपे पोको टोको कोपो चोपो पटरट टपटर करपट रपटर"
      ]
    },

    // ------------------------------------------
    // Lesson 3: Top Row Left (q w e r t)
    // ------------------------------------------
    {
      title: "3.1",
      instruction: "Reach your left hand up to type q, w, e, r, and t.",
      text: [
        "Welcome to the Top Row! It is time to train your left hand to reach upwards to access the remaining primary matras.",
        "Left Hand (Q, W, E): Keep your index finger anchored on 'F'. Stretch your pinky up to 'Q' (ौ), your ring finger up to 'W' (ै), and your middle finger up to 'E' (ा).",
        "The Index Finger (R & T): Stretch your left index finger straight up to tap 'R' (ी), and reach up and slightly right to strike 'T' (ू). Immediately return it to the 'F' bump after every keystroke.",
        "The Golden Rule: Let your fingers do the reaching! Never move your entire wrist or slide your whole hand up the keyboard. Keep your wrists steady and slightly elevated."
      ],
      image: "/Lesson3inscript.webp"
    },
    {
      title: "3.2",
      instruction: "Begin your muscle memory training. Type these precise 2-letter blocks arranged in a strict grid. Do not rush; focus entirely on hitting the exact center of each key without looking down at your hands. Accuracy builds speed.",
      text: [
        "का पा टा रा ",
        "की पी टी री ",
        "कू पू टू रू ",
        "कै पै टै रै ",
        "कौ पौ टौ रौ ",
        "चा ता पा का ",
        "ची ती पी की ",
        "चू तू पू कू "
      ]
    },
    {
      title: "3.3",
      instruction: "Expand your finger reach. Type these 3-letter combinations while maintaining a perfectly steady rhythm. If you make a mistake, do not panic—simply locate the correct key by feel, pull your fingers back to the home row, and continue the pattern.",
      text: [
        "काक पाप टाट रार ",
        "कीक पीप टीट रीर ",
        "कूक पूप टूट रूर ",
        "कैक पैप टैट रैर ",
        "कौक पौप टौट रौर ",
        "चाच तात पाक काक ",
        "चीच तीत पीप कीक ",
        "चूच तूत पूप कूक "
      ]
    },
    {
      title: "3.4",
      instruction: "Build fluid keystroke transitions. These 4-letter blocks require your fingers to move sequentially. Keep your wrists slightly elevated above the desk and let your fingers curl naturally over the keys. Breathe and maintain a steady pace.",
      text: [
        "काका पापा टाटा रारा ",
        "कीकी पीपी टीटी रीरी ",
        "कूकू पूपू टूटू रूरू ",
        "कैकै पैपै टैटै रैरै ",
        "कौकौ पौपौ टौटौ रौरौ ",
        "चाचा ताता पापा काका ",
        "चीची तीती पीपी कीकी ",
        "चूचू तूतू पूपू कूकू "
      ]
    },
    {
      title: "3.5",
      instruction: "Transition from abstract blocks to real typing patterns. Read the entire phrase in your mind before you start typing it. Connect the words smoothly, ensuring you strike the spacebar gently with the side of your resting thumb.",
      text: [
        "का पा टा ",
        "की पी टी ",
        "काक पाप टाट ",
        "काका पापा टाटा ",
        "कू पू टू ",
        "कै पै टै ",
        "कूक पूप टूट ",
        "कूकू पूपू टूटू "
      ]
    },
    {
      title: "3.6",
      instruction: "Endurance and stamina test. Type the full paragraph with deep focus to train your sustained muscle memory. You must press the ENTER key at the exact end of each paragraph to proceed. Prioritize absolute accuracy over speed.",
      text: [
        "का पा टा रा की पी टी री कू पू टू रू कै पै टै रै",
        "कौ पौ टौ रौ चा ता पा का काक पाप टाट रार",
        "कीक पीप टीट रीर कूक पूप टूट रूर कैक पैप टैट रैर",
        "कौक पौप टौट रौर चाच तात पाक काक काका पापा टाटा रारा",
        "कीकी पीपी टीटी रीरी कूकू पूपू टूटू रूरू कैकै पैपै टैटै रैरै",
        "कौकौ पौपौ टौटौ रौरौ चाचा ताता पापा काका चीची तीती पीपी कीकी"
      ]
    },

    // ------------------------------------------
    // Lesson 4: Top Row Right (y u i o p [ ] \)
    // ------------------------------------------
    {
      title: "4.1",
      instruction: "Right hand reaches up for y, u, i, o, p, [, ], and \\.",
      text: [
        "Welcome to the Top Row Right! It is time to train your right hand to stretch upwards for new consonants. Keep your index finger anchored on 'J'.",
        "Right Hand (Y, U, I): Stretch your index finger up and left to 'Y' (ब), and straight up to 'U' (ह). Stretch your middle finger up to 'I' (ग).",
        "The Outer Reaches (O, P, [, ], \\): Stretch your ring finger to 'O' (द). Stretch your pinky up to 'P' (ज), '[' (ड), ']' (़ - nukta), and all the way to '\\' (ॉ). The pinky has to cover a lot of ground here.",
        "The Golden Rule: Because the right pinky handles so many keys, beginners often twist their entire hand outward. Keep your hand straight, rely on your 'J' anchor, and let your pinky build the flexibility to reach!"
      ],
      image: "/Lesson4inscript.webp"
    },
    {
      title: "4.2",
      instruction: "Begin your muscle memory training. Type these precise 2-letter blocks arranged in a strict grid. Do not rush; focus entirely on hitting the exact center of each key without looking down at your hands. Accuracy builds speed.",
      text: [
        "बग हद गज दब ",
        "जा जी जु जे ",
        "डग डब डह डज ",
        "बज हग गद दज ",
        "बा हा गा दा ",
        "बी ही गी दी ",
        "बू हू गू दू ",
        "बै है गै दै "
      ]
    },
    {
      title: "4.3",
      instruction: "Expand your finger reach. Type these 3-letter combinations while maintaining a perfectly steady rhythm. If you make a mistake, do not panic—simply locate the correct key by feel, pull your fingers back to the home row, and continue the pattern.",
      text: [
        "बगब हपह गदग दबद ",
        "जाज जीज जुज जेज ",
        "डगड डबड डहड डजड ",
        "बजब हगह गदग दजद ",
        "बाब हाह गाग दाद ",
        "बीब हीह गीग दीद ",
        "बूब हूह गूग दूद ",
        "बैब हैह गैग दैद "
      ]
    },
    {
      title: "4.4",
      instruction: "Build fluid keystroke transitions. These 4-letter blocks require your fingers to move sequentially. Keep your wrists slightly elevated above the desk and let your fingers curl naturally over the keys. Breathe and maintain a steady pace.",
      text: [
        "बगबग हदहद गजगज दबदब ",
        "जाजा जीजी जुजु जेजे ",
        "डगडग डबडब डहडह डजडज ",
        "बजबज हगहग गदगद दजदज ",
        "बाबा हाहा गागा दादा ",
        "बीबी हीही गीगी दीदी ",
        "बूबू हूहू गूगू दूदू ",
        "बैबै हैहै गैगै दैदै "
      ]
    },
    {
      title: "4.5",
      instruction: "Transition from abstract blocks to real typing patterns. Read the entire phrase in your mind before you start typing it. Connect the words smoothly, ensuring you strike the spacebar gently with the side of your resting thumb.",
      text: [
        "बग हद गज ",
        "जा जी जु ",
        "बगब हपह गदग ",
        "बगबग हदहद गजगज ",
        "डग डब डह ",
        "बा हा गा ",
        "डगड डबड डहड ",
        "बाबा हाहा गागा "
      ]
    },
    {
      title: "4.6",
      instruction: "Endurance and stamina test. Type the full paragraph with deep focus to train your sustained muscle memory. You must press the ENTER key at the exact end of each paragraph to proceed. Prioritize absolute accuracy over speed.",
      text: [
        "बग हद गज दब जा जी जु जे डग डब डह डज",
        "बज हग गद दज बा हा गा दा बगब हपह गदग दबद",
        "जाज जीज जुज जेज डगड डबड डहड डजड बजब हगह गदग दजद",
        "बाब हाह गाग दाद बगबग हदहद गजगज दबदब जाजा जीजी जुजु जेजे",
        "डगडग डबडब डहडह डजडज बजबज हगहग गदगद दजदज बाबा हाहा गागा दादा",
        "बीबी हीही गीगी दीदी बूबू हूहू गूगू दूदू बैबै हैहै गैगै दैदै"
      ]
    },

    // ------------------------------------------
    // Lesson 5: Bottom Row Left (z x c v b)
    // ------------------------------------------
    {
      title: "5.1",
      instruction: "Drop your left fingers down to type z, x, c, v, and b.",
      text: [
        "Welcome to the Bottom Row! Reaching downwards can feel a bit unnatural at first because your fingers have to curl inward. Do not flatten your hands; keep a natural curve as you pull your fingers downward.",
        "Left Hand (Z, X, C): Keep your left index finger anchored on the 'F' bump. Drop your pinky down to 'Z' (rarely used in basic typing), your ring finger to 'X' (ं - Anusvara), and your middle finger to 'C' (म).",
        "The Index Finger (V & B): Drop your left index finger straight down to tap 'V' (न), and reach down and slightly right to strike 'B' (व). Always return to the 'F' bump to stay oriented.",
        "The Golden Rule: Because the bottom row requires curling, beginners often tend to drop their entire wrist onto the desk to reach. Keep your wrists slightly elevated to give your fingers the clearance they need to curl cleanly!"
      ],
      image: "/Lesson5inscript.webp"
    },
    {
      title: "5.2",
      instruction: "Begin your muscle memory training. Type these precise 2-letter blocks arranged in a strict grid. Do not rush; focus entirely on hitting the exact center of each key without looking down at your hands. Accuracy builds speed.",
      text: [
        "मन नम वन बम ",
        "मा ना वा मा ",
        "मी नी वी मी ",
        "मू नू वू मू ",
        "मं नं वं मं ",
        "कम कन कव कक ",
        "चम चन चव चच ",
        "तम तन तव तत "
      ]
    },
    {
      title: "5.3",
      instruction: "Expand your finger reach. Type these 3-letter combinations while maintaining a perfectly steady rhythm. If you make a mistake, do not panic—simply locate the correct key by feel, pull your fingers back to the home row, and continue the pattern.",
      text: [
        "मनम नमन वनव बमब ",
        "माम नान वाव माम ",
        "मीम नीन वीव मीम ",
        "मूम नून वूव मूम ",
        "मंम नन वंव मंम ",
        "कमक कनक कवक ककक ",
        "चमच चनच चवच चचच ",
        "तमत तनत तवत ततत "
      ]
    },
    {
      title: "5.4",
      instruction: "Build fluid keystroke transitions. These 4-letter blocks require your fingers to move sequentially. Keep your wrists slightly elevated above the desk and let your fingers curl naturally over the keys. Breathe and maintain a steady pace.",
      text: [
        "मनमन नमनम वनवन बमबम ",
        "मामा नाना वावा मामा ",
        "मीमी नीनी वीवी मीमी ",
        "मूमू नूनू वूवू मूमू ",
        "मंमं नन वंवं मंमं ",
        "कमकम कनकन कवकव कककक ",
        "चमचम चनचन चवचव चचचच ",
        "तमतम तनतन तवतव तततत "
      ]
    },
    {
      title: "5.5",
      instruction: "Transition from abstract blocks to real typing patterns. Read the entire phrase in your mind before you start typing it. Connect the words smoothly, ensuring you strike the spacebar gently with the side of your resting thumb.",
      text: [
        "मन नम वन ",
        "मा ना वा ",
        "मनम नमन वनव ",
        "मनमन नमनम वनवन ",
        "मी नी वी ",
        "कम कन कव ",
        "मीम नीन वीव ",
        "कमकम कनकन कवकव "
      ]
    },
    {
      title: "5.6",
      instruction: "Endurance and stamina test. Type the full paragraph with deep focus to train your sustained muscle memory. You must press the ENTER key at the exact end of each paragraph to proceed. Prioritize absolute accuracy over speed.",
      text: [
        "मन नम वन बम मा ना वा मा मी नी वी मी",
        "मू नू वू मू मं नं वं मं मनम नमन वनव बमब",
        "माम नान वाव माम मीम नीन वीव मीम मूम नून वूव मूम",
        "मंम नन वंव मंम मनमन नमनम वनवन बमबम मामा नाना वावा मामा",
        "मीमी नीनी वीवी मीमी मूमू नूनू वूवू मूमू मंमं नन वंवं मंमं",
        "कमकम कनकन कवकव कककक चमचम चनचन चवचव चचचच तमतम तनतन तवतव तततत"
      ]
    },

    // ------------------------------------------
    // Lesson 6: Bottom Row Right (n m , . /)
    // ------------------------------------------
    {
      title: "6.1",
      instruction: "Drop your right fingers down to type n, m, comma (,), period (.), and slash (/).",
      text: [
        "Welcome to the Bottom Row Right! This lesson completes the primary unshifted characters of the InScript layout. Reaching downwards requires keeping a natural curve in your fingers.",
        "The Index Finger (N & M): Keep your right index finger anchored on the 'J' bump. Drop it down and slightly left to tap 'N' (ल), and straight down to tap 'M' (स).",
        "The Outer Fingers (Comma, Period, Slash): Drop your right middle finger down to the Comma ',' (,). Drop your ring finger down to the Period '.' (.). Drop your right pinky down to the Slash '/' (य).",
        "Congratulations! You have now mapped all the core unshifted keys. Keep your wrists slightly elevated above the desk to curl your fingers downward cleanly."
      ],
      image: "/Lesson6inscript.webp"
    },
    {
      title: "6.2",
      instruction: "Begin your muscle memory training. Type these precise 2-letter blocks arranged in a strict grid. Do not rush; focus entirely on hitting the exact center of each key without looking down at your hands. Accuracy builds speed.",
      text: [
        "लय सस लल यय ",
        "ला सा या मा ",
        "ली सी यी मी ",
        "लू सू यू मू ",
        "कल कस कय क. ",
        "चल चस चय च, ",
        "तल तस तय त. ",
        "लय सस लल यय "
      ]
    },
    {
      title: "6.3",
      instruction: "Expand your finger reach. Type these 3-letter combinations while maintaining a perfectly steady rhythm. If you make a mistake, do not panic—simply locate the correct key by feel, pull your fingers back to the home row, and continue the pattern.",
      text: [
        "जलज मलम समस नयन ",
        "लाल साल याय माम ",
        "लील सीस यीय मीम ",
        "लूल सूस यूय मूम ",
        "लयल ससस ललल ययय ",
        "कलक कसक कयक क.क ",
        "चलच चसच चयच च,च ",
        "तलत तसत तयत त.त "
      ]
    },
    {
      title: "6.4",
      instruction: "Build fluid keystroke transitions. These 4-letter blocks require your fingers to move sequentially. Keep your wrists slightly elevated above the desk and let your fingers curl naturally over the keys. Breathe and maintain a steady pace.",
      text: [
        "जलजल मलमल समसम नयनय ",
        "लाला सासा याया मामा ",
        "लीली सीसी यीयी मीमी ",
        "लूलू सूसू यूयू मूमू ",
        "लयलय सससस लललल यययय ",
        "कलकल कसकस कयकय क..क ",
        "चलचल चसचस चयचय च,,च ",
        "तलतल तसतस तयतय त..त "
      ]
    },
    {
      title: "6.5",
      instruction: "Transition from abstract blocks to real typing patterns. Read the entire phrase in your mind before you start typing it. Connect the words smoothly, ensuring you strike the spacebar gently with the side of your resting thumb.",
      text: [
        "लय सस लल ",
        "ला सा या ",
        "जलज मलम समस ",
        "जलजल मलमल समसम ",
        "ली सी यी ",
        "कल कस कय ",
        "लील सीस यीय ",
        "कलकल कसकस कयकय "
      ]
    },
    {
      title: "6.6",
      instruction: "Endurance and stamina test. Type the full paragraph with deep focus to train your sustained muscle memory. You must press the ENTER key at the exact end of each paragraph to proceed. Prioritize absolute accuracy over speed.",
      text: [
        "लय सस लल यय. ला सा या मा. ली सी यी मी.",
        "लू सू यू मू. कल कस कय क.. जलज मलम समस नयन.",
        "लाल साल याय माम. लील सीस यीय मीम. लूल सूस यूय मूम.",
        "लयल ससस ललल ययय. जलजल मलमल समसम नयनय. लाला सासा याया मामा.",
        "लीली सीसी यीयी मीमी. लूलू सूसू यूयू मूमू. लयलय सससस लललल यययय.",
        "कलकल कसकस कयकय क..क. चलचल चसचस चयचय च,,च. तलतल तसतस तयतय त..त."
      ]
    },

    // ------------------------------------------
    // Lesson 7: Left Hand (Top & Home) + Right Shift
    // ------------------------------------------
    {
      title: "7.1",
      instruction: "Hold Right Shift and type the Top & Home rows with your left hand.",
      text: [
        "Welcome to the Shift Keys! In InScript, holding Shift with the left hand types independent vowels (Swar) instead of matras. ALWAYS use your Right Pinky to hold down the Right Shift key.",
        "The Right Shift Anchor: Reach your right pinky down to firmly hold the Right Shift key. Keep your hand straight and let the pinky stretch.",
        "The Left Hand (Home Row): While holding Right Shift, use your left fingers to type 'A' (ओ), 'S' (ए), 'D' (अ), 'F' (इ), and 'G' (उ).",
        "The Left Hand (Top Row): Keep holding Right Shift. Reach your left fingers up to type 'Q' (औ), 'W' (ऐ), 'E' (आ), 'R' (ई), and 'T' (ऊ). Let go of the Shift key immediately after completing your keystrokes."
      ],
      image: "/Lesson7inscript.webp"
    },
    {
      title: "7.2",
      instruction: "Begin your muscle memory training. Type these precise 2-letter blocks arranged in a strict grid. Do not rush; focus entirely on hitting the exact center of each key without looking down at your hands. Accuracy builds speed.",
      text: [
        "आओ ऐए इई उऊ ",
        "अआ इई उऊ एऐ ",
        "औओ अण इण उण ",
        "आण ईण ऊण ओण ",
        "एण अआ इई उऊ ",
        "आओ ऐए इई उऊ ",
        "अआ इई उऊ एऐ ",
        "औओ अण इण उण "
      ]
    },
    {
      title: "7.3",
      instruction: "Expand your finger reach. Type these 3-letter combinations while maintaining a perfectly steady rhythm. If you make a mistake, do not panic—simply locate the correct key by feel, pull your fingers back to the home row, and continue the pattern.",
      text: [
        "आओआ ऐएऐ इईइ उऊउ ",
        "अआअ इईइ उऊउ एऐए ",
        "औओऔ अणअ इणइ उणउ ",
        "आणआ ईणई ऊणऊ ओणओ ",
        "एणए अआअ इईइ उऊउ ",
        "आओआ ऐएऐ इईइ उऊउ ",
        "अआअ इईइ उऊउ एऐए ",
        "औओऔ अणअ इणइ उणउ "
      ]
    },
    {
      title: "7.4",
      instruction: "Build fluid keystroke transitions. These 4-letter blocks require your fingers to move sequentially. Keep your wrists slightly elevated above the desk and let your fingers curl naturally over the keys. Breathe and maintain a steady pace.",
      text: [
        "आओआओ ऐएऐए इईइई उऊउऊ ",
        "अआअआ इईइई उऊउऊ एऐएऐ ",
        "औओऔओ अणअण इणइण उणउण ",
        "आणआण ईणईण ऊणऊण ओणओण ",
        "एणएण अआअआ इईइई उऊउऊ ",
        "आओआओ ऐएऐए इईइई उऊउऊ ",
        "अआअआ इईइई उऊउऊ एऐएऐ ",
        "औओऔओ अणअण इणइण उणउण "
      ]
    },
    {
      title: "7.5",
      instruction: "Transition from abstract blocks to real typing patterns. Read the entire phrase in your mind before you start typing it. Connect the words smoothly, ensuring you strike the spacebar gently with the side of your resting thumb.",
      text: [
        "आओ ऐए इई ",
        "अआ इई उऊ ",
        "आओआ ऐएऐ इईइ ",
        "आओआओ ऐएऐए इईइई ",
        "औओ अण इण ",
        "आण ईण ऊण ",
        "औओऔ अणअ इणइ ",
        "औओऔओ अणअण इणइण "
      ]
    },
    {
      title: "7.6",
      instruction: "Endurance and stamina test. Type the full paragraph with deep focus to train your sustained muscle memory. You must press the ENTER key at the exact end of each paragraph to proceed. Prioritize absolute accuracy over speed.",
      text: [
        "आओ ऐए इई उऊ. अआ इई उऊ एऐ. औओ अण इण उण.",
        "आण ईण ऊण ओण. आओआ ऐएऐ इईइ उऊउ. अआअ इईइ उऊउ एऐए.",
        "औओऔ अणअ इणइ उणउ. आणआ ईणई ऊणऊ ओणओ. आओआओ ऐएऐए इईइई उऊउऊ.",
        "अआअआ इईइई उऊउऊ एऐएऐ. औओऔओ अणअण इणइण उणउण. आणआण ईणईण ऊणऊण ओणओण.",
        "एणएण अआअआ इईइई उऊउऊ. आओआ ऐएऐ इईइ उऊउ. अआ इई उऊ एऐ.",
        "औओ अण इण उण. औओऔ अणअ इणइ उणउ. औओऔओ अणअण इणइण उणउण."
      ]
    },

    // ------------------------------------------
    // Lesson 8: Left Hand (Bottom) + Right Shift
    // ------------------------------------------
    {
      title: "8.1",
      instruction: "Hold Right Shift and type the bottom row with your left hand, including Z.",
      text: [
        "Welcome to the Bottom Row Shifts! Curling your fingers downward while your opposite hand holds the Shift key is a complex stretch. Take your time and keep your wrists relaxed.",
        "The Right Shift Anchor: Reach your right pinky down to firmly hold the Right Shift key. Keep your hand straight and avoid twisting your right wrist.",
        "Left Hand (Z, X, C, V, B): While holding Right Shift, drop your left pinky to 'Z' (ऎ), your ring finger to 'X' (ँ - Chandrabindu), your middle finger to 'C' (ण), your index finger to 'V' (ऩ), and reach slightly right for 'B' (ळ).",
        "Return them to the home row immediately after each strike. Ensure your left wrist stays elevated so your fingers have room to curl cleanly."
      ],
      image: "/Lesson8inscript.webp"
    },
    {
      title: "8.2",
      instruction: "Begin your muscle memory training. Type these precise 2-letter blocks arranged in a strict grid. Do not rush; focus entirely on hitting the exact center of each key without looking down at your hands. Accuracy builds speed.",
      text: [
        "ऎँ णऩ ळऎ ँण ",
        "ऩळ ऎँ णऩ ळऎ ",
        "ँण ऩळ ऎँ णऩ ",
        "ळऎ ँण ऩळ ऎँ ",
        "ऎँ णऩ ळऎ ँण ",
        "ऩळ ऎँ णऩ ळऎ ",
        "ँण ऩळ ऎँ णऩ ",
        "ळऎ ँण ऩळ ऎँ "
      ]
    },
    {
      title: "8.3",
      instruction: "Expand your finger reach. Type these 3-letter combinations while maintaining a perfectly steady rhythm. If you make a mistake, do not panic—simply locate the correct key by feel, pull your fingers back to the home row, and continue the pattern.",
      text: [
        "ऎँण ऩळऎ ँणऩ ळऎँ ",
        "णऩळ ऎँण ऩळऎ ँणऩ ",
        "ळऎँ णऩळ ऎँण ऩळऎ ",
        "ँणऩ ळऎँ णऩळ ऎँण ",
        "ऎँण ऩळऎ ँणऩ ळऎँ ",
        "णऩळ ऎँण ऩळऎ ँणऩ ",
        "ळऎँ णऩळ ऎँण ऩळऎ ",
        "ँणऩ ळऎँ णऩळ ऎँण "
      ]
    },
    {
      title: "8.4",
      instruction: "Build fluid keystroke transitions. These 4-letter blocks require your fingers to move sequentially. Keep your wrists slightly elevated above the desk and let your fingers curl naturally over the keys. Breathe and maintain a steady pace.",
      text: [
        "ऎँणऩ ळऎँण ऩळऎँ ँणऩळ ",
        "णऩळऎ ऎँणऩ ळऎँण ऩळऎँ ",
        "ँणऩळ णऩळऎ ऎँणऩ ळऎँण ",
        "ळऎँण ऩळऎँ ँणऩळ णऩळऎ ",
        "ऎँणऩ ळऎँण ऩळऎँ ँणऩळ ",
        "णऩळऎ ऎँणऩ ळऎँण ऩळऎँ ",
        "ँणऩळ णऩळऎ ऎँणऩ ळऎँण ",
        "ळऎँण ऩळऎँ ँणऩळ णऩळऎ "
      ]
    },
    {
      title: "8.5",
      instruction: "Transition from abstract blocks to real typing patterns. Read the entire phrase in your mind before you start typing it. Connect the words smoothly, ensuring you strike the spacebar gently with the side of your resting thumb.",
      text: [
        "ऎँ णऩ ळऎ ",
        "ँण ऩळ ऎँ ",
        "ऎँण ऩळऎ ँणऩ ",
        "ऎँणऩ ळऎँण ऩळऎँ ",
        "णऩ ळऎ ँण ",
        "ळऎ ऎँ णऩ ",
        "णऩळ ऎँण ऩळऎ ",
        "णऩळऎ ऎँणऩ ळऎँण "
      ]
    },
    {
      title: "8.6",
      instruction: "Endurance and stamina test. Type the full paragraph with deep focus to train your sustained muscle memory. You must press the ENTER key at the exact end of each paragraph to proceed. Prioritize absolute accuracy over speed.",
      text: [
        "ऎँ णऩ ळऎ ँण. ऩळ ऎँ णऩ ळऎ. ँण ऩळ ऎँ णऩ.",
        "ळऎ ँण ऩळ ऎँ. ऎँण ऩळऎ ँणऩ ळऎँ. णऩळ ऎँण ऩळऎ ँणऩ.",
        "ळऎँ णऩळ ऎँण ऩळऎ. ँणऩ ळऎँ णऩळ ऎँण. ऎँणऩ ळऎँण ऩळऎँ ँणऩळ.",
        "णऩळऎ ऎँणऩ ळऎँण ऩळऎँ. ँणऩळ णऩळऎ ऎँणऩ ळऎँण. ळऎँण ऩळऎँ ँणऩळ णऩळऎ.",
        "ऎँ णऩ ळऎ ँण. ऩळ ऎँ णऩ ळऎ. ऎँण ऩळऎ ँणऩ ळऎँ.",
        "णऩळ ऎँण ऩळऎ ँणऩ. ऎँणऩ ळऎँण ऩळऎँ ँणऩळ. णऩळऎ ऎँणऩ ळऎँण ऩळऎँ."
      ]
    },

    // ------------------------------------------
    // Lesson 9: Right Hand (Top & Home) + Left Shift
    // ------------------------------------------
    {
      title: "9.1",
      instruction: "Hold Left Shift and type the Top & Home rows with your right hand, including |.",
      text: [
        "Welcome to the Right Hand Shifts! Holding Left Shift with the right hand types Heavy Consonants (Mahapran) in InScript.",
        "The Left Shift Anchor: Use your left pinky to firmly press and hold the Left Shift key. Keep your left hand securely anchored on the desk.",
        "Right Hand (Home Row): While holding Left Shift, use your right fingers to strike 'H' (फ), 'J' (ऱ), 'K' (ख), 'L' (थ), ':' (छ), and '\"' (ठ).",
        "Right Hand (Top Row & Extremes): Keep holding Left Shift. Stretch your right fingers up to type 'Y' (भ), 'U' (ङ), 'I' (घ), 'O' (ध), 'P' (झ), '{' (ढ), '}' (ञ), and stretch your pinky to its absolute limit for '|' (ऑ). Release the shift key immediately after completing the stroke."
      ],
      image: "/Lesson9inscript.webp"
    },
    {
      title: "9.2",
      instruction: "Begin your muscle memory training. Type these precise 2-letter blocks arranged in a strict grid. Do not rush; focus entirely on hitting the exact center of each key without looking down at your hands. Accuracy builds speed.",
      text: [
        "भघ धझ फख थछ ",
        "ठढ ञऑ ऑञ ढठ ",
        "छथ खफ झध घभ ",
        "फख थछ ठढ ञऑ ",
        "ऑञ ढठ छथ खफ ",
        "झध घभ भघ धझ ",
        "फख थछ ठढ ञऑ ",
        "ऑञ ढठ छथ खफ "
      ]
    },
    {
      title: "9.3",
      instruction: "Expand your finger reach. Type these 3-letter combinations while maintaining a perfectly steady rhythm. If you make a mistake, do not panic—simply locate the correct key by feel, pull your fingers back to the home row, and continue the pattern.",
      text: [
        "भघध झफख थछठ ढञऑ ",
        "ऑञढ ठछथ खफझ धघभ ",
        "धझफ खथछ ठढञ ऑञढ ",
        "ठछथ खफझ धघभ भघध ",
        "झफख थछठ ढञऑ ऑञढ ",
        "ठछथ खफझ धघभ भघध ",
        "झफख थछठ ढञऑ ऑञढ ",
        "ठछथ खफझ धघभ भघध "
      ]
    },
    {
      title: "9.4",
      instruction: "Build fluid keystroke transitions. These 4-letter blocks require your fingers to move sequentially. Keep your wrists slightly elevated above the desk and let your fingers curl naturally over the keys. Breathe and maintain a steady pace.",
      text: [
        "भघधझ फखथछ ठढञऑ ऑञढठ ",
        "छथखफ झधघभ भघधझ फखथछ ",
        "ठढञऑ ऑञढठ छथखफ झधघभ ",
        "धझफख थछठढ ञऑऑञ ढठछथ ",
        "खफझध घभभघ धझफख थछठढ ",
        "ञऑऑञ ढठछथ खफझध घभभघ ",
        "धझफख थछठढ ञऑऑञ ढठछथ ",
        "खफझध घभभघ धझफख थछठढ "
      ]
    },
    {
      title: "9.5",
      instruction: "Transition from abstract blocks to real typing patterns. Read the entire phrase in your mind before you start typing it. Connect the words smoothly, ensuring you strike the spacebar gently with the side of your resting thumb.",
      text: [
        "भघ धझ फख ",
        "थछ ठढ ञऑ ",
        "भघध झफख थछठ ",
        "भघधझ फखथछ ठढञऑ ",
        "ऑञ ढठ छथ ",
        "खफ झध घभ ",
        "ऑञढ ठछथ खफझ ",
        "ऑञढठ छथखफ झधघभ "
      ]
    },
    {
      title: "9.6",
      instruction: "Endurance and stamina test. Type the full paragraph with deep focus to train your sustained muscle memory. You must press the ENTER key at the exact end of each paragraph to proceed. Prioritize absolute accuracy over speed.",
      text: [
        "भघ धझ फख थछ. ठढ ञऑ ऑञ ढठ. छथ खफ झध घभ.",
        "फख थछ ठढ ञऑ. भघध झफख थछठ ढञऑ. ऑञढ ठछथ खफझ धघभ.",
        "धझफ खथछ ठढञ ऑञढ. ठछथ खफझ धघभ भघध. भघधझ फखथछ ठढञऑ ऑञढठ.",
        "छथखफ झधघभ भघधझ फखथछ. ठढञऑ ऑञढठ छथखफ झधघभ. धझफख थछठढ ञऑऑञ ढठछथ.",
        "खफझध घभभघ धझफख थछठढ. ञऑऑञ ढठछथ खफझध घभभघ. भघ धझ फख थछ.",
        "ठढ ञऑ ऑञ ढठ. भघध झफख थछठ ढञऑ. भघधझ फखथछ ठढञऑ ऑञढठ."
      ]
    },

    // ------------------------------------------
    // Lesson 10: Right Hand (Bottom) + Left Shift
    // ------------------------------------------
    {
      title: "10.1",
      instruction: "Hold Left Shift and type the bottom row with your right hand.",
      text: [
        "Welcome to the final shift lesson! Dropping your right fingers downward while holding the Left Shift key requires focus and coordination. Keep your hands relaxed.",
        "The Left Shift Anchor: Use your left pinky to firmly press and hold the Left Shift key. Keep your left wrist steady and avoid twisting your hand.",
        "The Index Finger (N & M): While holding Left Shift, drop your right index finger down and slightly left to tap 'N' (ळ), and straight down to tap 'M' (श). Return it to the home row immediately.",
        "The Outer Fingers (<, >, ?): Keep holding Left Shift. Drop your right middle finger down to '<' (ष), your ring finger to '>' (। - Purna Viram), and your right pinky to '?' (य़). Always keep your wrists elevated!"
      ],
      image: "/Lesson10inscript.webp"
    },
    {
      title: "10.2",
      instruction: "Begin your muscle memory training. Type these precise 2-letter blocks arranged in a strict grid. Do not rush; focus entirely on hitting the exact center of each key without looking down at your hands. Accuracy builds speed.",
      text: [
        "ळश ष। य़ळ शष ",
        "।य़ ळश ष। य़ळ ",
        "शष ।य़ ळश ष। ",
        "य़ळ शष ।य़ ळश ",
        "ष। य़ळ शष ।य़ ",
        "ळश ष। य़ळ शष ",
        "।य़ ळश ष। य़ळ ",
        "शष ।य़ ळश ष। "
      ]
    },
    {
      title: "10.3",
      instruction: "Expand your finger reach. Type these 3-letter combinations while maintaining a perfectly steady rhythm. If you make a mistake, do not panic—simply locate the correct key by feel, pull your fingers back to the home row, and continue the pattern.",
      text: [
        "ळशळ ष।ष य़ळय़ शषश ",
        "।य़। ळशळ ष।ष य़ळय़ ",
        "शषश ।य़। ळशळ ष।ष ",
        "य़ळय़ शषश ।य़। ळशळ ",
        "ष।ष य़ळय़ शषश ।य़। ",
        "ळशळ ष।ष य़ळय़ शषश ",
        "।य़। ळशळ ष।ष य़ळय़ ",
        "शषश ।य़। ळशळ ष।ष "
      ]
    },
    {
      title: "10.4",
      instruction: "Build fluid keystroke transitions. These 4-letter blocks require your fingers to move sequentially. Keep your wrists slightly elevated above the desk and let your fingers curl naturally over the keys. Breathe and maintain a steady pace.",
      text: [
        "ळशळश ष।ष। य़ळय़ळ शषशष ",
        "।य़।य़ ळशळश ष।ष। य़ळय़ळ ",
        "शषशष ।य़।य़ ळशळश ष।ष। ",
        "य़ळय़ळ शषशष ।य़।य़ ळशळश ",
        "ष।ष। य़ळय़ळ शषशष ।य़।य़ ",
        "ळशळश ष।ष। य़ळय़ळ शषशष ",
        "।य़।य़ ळशळश ष।ष। य़ळय़ळ ",
        "शषशष ।य़।य़ ळशळश ष।ष। "
      ]
    },
    {
      title: "10.5",
      instruction: "Transition from abstract blocks to real typing patterns. Read the entire phrase in your mind before you start typing it. Connect the words smoothly, ensuring you strike the spacebar gently with the side of your resting thumb.",
      text: [
        "ळश ष। य़ळ ",
        "।य़ ळश ष। ",
        "ळशळ ष।ष य़ळय़ ",
        "ळशळश ष।ष। य़ळय़ळ ",
        "शष ।य़ ळश ",
        "य़ळ शष ।य़ ",
        "शषश ।य़। ळशळ ",
        "शषशष ।य़।य़ ळशळश "
      ]
    },
    {
      title: "10.6",
      instruction: "Endurance and stamina test. Type the full paragraph with deep focus to train your sustained muscle memory. You must press the ENTER key at the exact end of each paragraph to proceed. Prioritize absolute accuracy over speed.",
      text: [
        "ळश ष। य़ळ शष. ।य़ ळश ष। य़ळ. शष ।य़ ळश ष।.",
        "य़ळ शष ।य़ ळश. ळशळ ष।ष य़ळय़ शषश. ।य़। ळशळ ष।ष य़ळय़.",
        "शषश ।य़। ळशळ ष।ष. य़ळय़ शषश ।य़। ळशळ. ळशळश ष।ष। य़ळय़ळ शषशष.",
        "।य़।य़ ळशळश ष।ष। य़ळय़ळ. शषशष ।य़।य़ ळशळश ष।ष।. य़ळय़ळ शषशष ।य़।य़ ळशळश.",
        "ष।ष। य़ळय़ळ शषशष ।य़।य़. ळशळश ष।ष। य़ळय़ळ शषशष. ।य़।य़ ळशळश ष।ष। य़ळय़ळ.",
        "शषशष ।य़।य़ ळशळश ष।ष।. ळश ष। य़ळ शष. ळशळ ष।ष य़ळय़ शषश."
      ]
    },

    // ------------------------------------------
    // Lesson 11: Number Row (` 1 2 3 4 5 6 7 8 9 0 - =)
    // ------------------------------------------
    {
      title: "11.1",
      instruction: "Reach up to the number row.",
      text: [
        "The Number Row. InScript makes numbers incredibly easy—they are mapped exactly to the standard English number keys! Reach up to type 1 2 3 4 5 6 7 8 9 0 without using the Shift key.",
        "The Left Hand: Stretch your left pinky far up and left for the backtick (`) and straight up for '1'. Use your ring finger for '2', middle finger for '3', and let your index finger stretch to both '4' and '5'.",
        "The Right Hand: Your right index finger reaches up to '6' and '7'. Use your middle finger for '8', and ring finger for '9'. Stretch your right pinky up for '0', the hyphen (-), and the equals (=) key.",
        "The Golden Rule: Because the number row is so far away, it is very tempting to lift your hands completely off the keyboard. Try to keep your wrists anchored and let your fingers do the stretching!"
      ],
      image: "/Lesson11inscript.webp"
    },
    {
      title: "11.2",
      instruction: "Begin your muscle memory training. Type these precise 2-letter blocks arranged in a strict grid. Do not rush; focus entirely on hitting the exact center of each key without looking down at your hands. Accuracy builds speed.",
      text: [
        "12 34 56 78 ",
        "90 12 34 56 ",
        "78 90 12 34 ",
        "56 78 90 12 ",
        "34 56 78 90 ",
        "12 34 56 78 ",
        "90 12 34 56 ",
        "78 90 12 34 "
      ]
    },
    {
      title: "11.3",
      instruction: "Expand your finger reach. Type these 3-letter combinations while maintaining a perfectly steady rhythm. If you make a mistake, do not panic—simply locate the correct key by feel, pull your fingers back to the home row, and continue the pattern.",
      text: [
        "123 456 789 012 ",
        "345 678 901 234 ",
        "567 890 123 456 ",
        "789 012 345 678 ",
        "901 234 567 890 ",
        "123 456 789 012 ",
        "345 678 901 234 ",
        "567 890 123 456 "
      ]
    },
    {
      title: "11.4",
      instruction: "Build fluid keystroke transitions. These 4-letter blocks require your fingers to move sequentially. Keep your wrists slightly elevated above the desk and let your fingers curl naturally over the keys. Breathe and maintain a steady pace.",
      text: [
        "1234 5678 9012 3456 ",
        "7890 1234 5678 9012 ",
        "3456 7890 1234 5678 ",
        "9012 3456 7890 1234 ",
        "5678 9012 3456 7890 ",
        "1234 5678 9012 3456 ",
        "7890 1234 5678 9012 ",
        "3456 7890 1234 5678 "
      ]
    },
    {
      title: "11.5",
      instruction: "Transition from abstract blocks to real typing patterns. Read the entire phrase in your mind before you start typing it. Connect the words smoothly, ensuring you strike the spacebar gently with the side of your resting thumb.",
      text: [
        "12 34 56 ",
        "90 12 34 ",
        "123 456 789 ",
        "1234 5678 9012 ",
        "78 90 12 ",
        "56 78 90 ",
        "345 678 901 ",
        "7890 1234 5678 "
      ]
    },
    {
      title: "11.6",
      instruction: "Endurance and stamina test. Type the full paragraph with deep focus to train your sustained muscle memory. You must press the ENTER key at the exact end of each paragraph to proceed. Prioritize absolute accuracy over speed.",
      text: [
        "12 34 56 78. 90 12 34 56. 123 456 789 012.",
        "345 678 901 234. 1234 5678 9012 3456. 7890 1234 5678 9012.",
        "78 90 12 34. 56 78 90 12. 567 890 123 456.",
        "789 012 345 678. 3456 7890 1234 5678. 9012 3456 7890 1234.",
        "34 56 78 90. 12 34 56 78. 901 234 567 890.",
        "123 456 789 012. 5678 9012 3456 7890. 1234 5678 9012 3456."
      ]
    },

    // ------------------------------------------
    // Lesson 12: Symbols & Modifiers (~ ! @ # $ % ^ & * ( ) _ +)
    // ------------------------------------------
    {
      title: "12.1",
      instruction: "Use Shift with numbers to type Hindi symbols.",
      text: [
        "Complex Conjuncts (Sanyuktakshar). Hold Shift and press the number keys to generate special Hindi symbols and conjuncts.",
        "Left Hand Symbols: Hold the Right Shift key with your right pinky. Use your left hand fingers to reach up and type !(ऍ), @(ॅ), #(्र), $(र्), and %(ज्ञ).",
        "Right Hand Symbols: Hold the Left Shift key with your left pinky. Use your right hand fingers to reach up and type ^(त्र), &(क्ष), *(श्र), (( ), )( ), _(ऋ), and +(़).",
        "These are vital for advanced vocabulary. Memorize these specific keystrokes carefully."
      ],
      image: "/Lesson12inscript.webp"
    },
    {
      title: "12.2",
      instruction: "Begin your muscle memory training. Type these precise 2-letter blocks arranged in a strict grid. Do not rush; focus entirely on hitting the exact center of each key without looking down at your hands. Accuracy builds speed.",
      text: [
        "ज्ञत्र क्षश्र रुज्ञ त्रक्ष ",
        "श्ररु ज्ञत्र क्षश्र रुज्ञ ",
        "त्रक्ष श्ररु ज्ञत्र क्षश्र ",
        "रुज्ञ त्रक्ष श्ररु ज्ञत्र ",
        "क्षश्र रुज्ञ त्रक्ष श्ररु ",
        "ज्ञत्र क्षश्र रुज्ञ त्रक्ष ",
        "श्ररु ज्ञत्र क्षश्र रुज्ञ ",
        "त्रक्ष श्ररु ज्ञत्र क्षश्र "
      ]
    },
    {
      title: "12.3",
      instruction: "Expand your finger reach. Type these 3-letter combinations while maintaining a perfectly steady rhythm. If you make a mistake, do not panic—simply locate the correct key by feel, pull your fingers back to the home row, and continue the pattern.",
      text: [
        "ज्ञत्रक्ष श्ररुज्ञ त्रक्षश्र रुज्ञत्र ",
        "क्षश्ररु ज्ञत्रक्ष श्ररुज्ञ त्रक्षश्र ",
        "रुज्ञत्र क्षश्ररु ज्ञत्रक्ष श्ररुज्ञ ",
        "त्रक्षश्र रुज्ञत्र क्षश्ररु ज्ञत्रक्ष ",
        "श्ररुज्ञ त्रक्षश्र रुज्ञत्र क्षश्ररु ",
        "ज्ञत्रक्ष श्ररुज्ञ त्रक्षश्र रुज्ञत्र ",
        "क्षश्ररु ज्ञत्रक्ष श्ररुज्ञ त्रक्षश्र ",
        "रुज्ञत्र क्षश्ररु ज्ञत्रक्ष श्ररुज्ञ "
      ]
    },
    {
      title: "12.4",
      instruction: "Build fluid keystroke transitions. These 4-letter blocks require your fingers to move sequentially. Keep your wrists slightly elevated above the desk and let your fingers curl naturally over the keys. Breathe and maintain a steady pace.",
      text: [
        "ज्ञत्रक्षश्र रुज्ञत्रक्ष श्ररुज्ञत्र क्षश्ररुज्ञ ",
        "त्रक्षश्ररु ज्ञत्रक्षश्र रुज्ञत्रक्ष श्ररुज्ञत्र ",
        "क्षश्ररुज्ञ त्रक्षश्ररु ज्ञत्रक्षश्र रुज्ञत्रक्ष ",
        "श्ररुज्ञत्र क्षश्ररुज्ञ त्रक्षश्ररु ज्ञत्रक्षश्र ",
        "रुज्ञत्रक्ष श्ररुज्ञत्र क्षश्ररुज्ञ त्रक्षश्ररु ",
        "ज्ञत्रक्षश्र रुज्ञत्रक्ष श्ररुज्ञत्र क्षश्ररुज्ञ ",
        "त्रक्षश्ररु ज्ञत्रक्षश्र रुज्ञत्रक्ष श्ररुज्ञत्र ",
        "क्षश्ररुज्ञ त्रक्षश्ररु ज्ञत्रक्षश्र रुज्ञत्रक्ष "
      ]
    },
    {
      title: "12.5",
      instruction: "Transition from abstract blocks to real typing patterns. Read the entire phrase in your mind before you start typing it. Connect the words smoothly, ensuring you strike the spacebar gently with the side of your resting thumb.",
      text: [
        "ज्ञत्र क्षश्र रुज्ञ ",
        "श्ररु ज्ञत्र क्षश्र ",
        "ज्ञत्रक्ष श्ररुज्ञ त्रक्षश्र ",
        "ज्ञत्रक्षश्र रुज्ञत्रक्ष श्ररुज्ञत्र ",
        "त्रक्ष श्ररु ज्ञत्र ",
        "रुज्ञ त्रक्ष श्ररु ",
        "क्षश्ररु ज्ञत्रक्ष श्ररुज्ञ ",
        "त्रक्षश्ररु ज्ञत्रक्षश्र रुज्ञत्रक्ष "
      ]
    },
    {
      title: "12.6",
      instruction: "Endurance and stamina test. Type the full paragraph with deep focus to train your sustained muscle memory. You must press the ENTER key at the exact end of each paragraph to proceed. Prioritize absolute accuracy over speed.",
      text: [
        "ज्ञत्र क्षश्र रुज्ञ त्रक्ष. श्ररु ज्ञत्र क्षश्र रुज्ञ. ज्ञत्रक्ष श्ररुज्ञ त्रक्षश्र रुज्ञत्र.",
        "क्षश्ररु ज्ञत्रक्ष श्ररुज्ञ त्रक्षश्र. ज्ञत्रक्षश्र रुज्ञत्रक्ष श्ररुज्ञत्र क्षश्ररुज्ञ. त्रक्षश्ररु ज्ञत्रक्षश्र रुज्ञत्रक्ष श्ररुज्ञत्र.",
        "त्रक्ष श्ररु ज्ञत्र क्षश्र. रुज्ञ त्रक्ष श्ररु ज्ञत्र. रुज्ञत्र क्षश्ररु ज्ञत्रक्ष श्ररुज्ञ.",
        "त्रक्षश्र रुज्ञत्र क्षश्ररु ज्ञत्रक्ष. क्षश्ररुज्ञ त्रक्षश्ररु ज्ञत्रक्षश्र रुज्ञत्रक्ष. श्ररुज्ञत्र क्षश्ररुज्ञ त्रक्षश्ररु ज्ञत्रक्षश्र.",
        "क्षश्र रुज्ञ त्रक्ष श्ररु. ज्ञत्र क्षश्र रुज्ञ त्रक्ष. श्ररुज्ञ त्रक्षश्र रुज्ञत्र क्षश्ररु.",
        "ज्ञत्रक्ष श्ररुज्ञ त्रक्षश्र रुज्ञत्र. रुज्ञत्रक्ष श्ररुज्ञत्र क्षश्ररुज्ञ त्रक्षश्ररु. ज्ञत्रक्षश्र रुज्ञत्रक्ष श्ररुज्ञत्र क्षश्ररुज्ञ."
      ]
    },

    // ------------------------------------------
    // Lesson 13: Real Passages 1 (InScript Mapping)
    // ------------------------------------------
    {
      title: "13.1",
      instruction: "You have learned all the keys! Now practice full passages.",
      text: [
        "Congratulations! You have successfully learned the location of every single key on the Mangal InScript keyboard layout.",
        "In this section, you will transition from typing abstract blocks of characters to typing real, grammatically correct Hindi sentences using pure Unicode.",
        "Let your subconscious muscle memory guide your fingers to the correct shapes. Do not look down at your hands, even if you make a mistake.",
        "Accuracy is your absolute primary goal right now. Trust the phonetic logic of your left and right hands. As your accuracy improves, your typing speed will naturally follow!"
      ],
      image: null
    },
    {
      title: "13.2",
      mode: "paragraph",
      instruction: "Full Paragraph Practice 1.",
      text: [
        "भारत एक विशाल देश है। इसकी संस्कृति प्राचीन है।",
        "यहां विभिन्न धर्म और जाति के लोग रहते हैं।",
        "हम सब मिलकर पहले अपने देश का नाम ऊंचा करें।",
        "भारत एक विशाल देश है। इसकी संस्कृति प्राचीन है।",
        "यहां विभिन्न धर्म और जाति के लोग रहते हैं।",
        "हम सब मिलकर पहले अपने देश का नाम ऊंचा करें।"
      ]
    },
    {
      title: "13.3",
      mode: "paragraph",
      instruction: "Full Paragraph Practice 2.",
      text: [
        "सभी भारतीय मिलजुलकर प्रेम से रहते हैं।",
        "हमारी संस्कृति बहुत पुरानी और मेहनत की है।",
        "हम अपने देश के विकास में उन्नति लासकते हैं।",
        "सभी भारतीय मिलजुलकर प्रेम से रहते हैं।",
        "हमारी संस्कृति बहुत पुरानी और मेहनत की है।",
        "हम अपने देश के विकास में उन्नति लासकते हैं।"
      ]
    },
    {
      title: "13.4",
      mode: "paragraph",
      instruction: "Full Paragraph Practice 3.",
      text: [
        "देश की राजधानी नई दिल्ली हमारे लिए गौरव है।",
        "गंगा हमारी पावन नदी है जिसमें जल बहता है।",
        "पहाड़ और जंगल इसे बड़ा सुंदर बनाते हैं।",
        "देश की राजधानी नई दिल्ली हमारे लिए गौरव है।",
        "गंगा हमारी पावन नदी है जिसमें जल बहता है।",
        "पहाड़ और जंगल इसे बड़ा सुंदर बनाते हैं।"
      ]
    },
    {
      title: "13.5",
      mode: "paragraph",
      instruction: "Full Paragraph Practice 4.",
      text: [
        "शिक्षा जीवन का मूल मन्त्र है जिससे कामयाबी है।",
        "बिना शिक्षा के मानव अपना लक्ष्य नहीं पा सकता।",
        "हमें हमेशा शिक्षा प्राप्त करके आगे बढ़ना चाहिए।",
        "शिक्षा जीवन का मूल मन्त्र है जिससे कामयाबी है।",
        "बिना शिक्षा के मानव अपना लक्ष्य नहीं पा सकता।",
        "हमें हमेशा शिक्षा प्राप्त करके आगे बढ़ना चाहिए।"
      ]
    },
    {
      title: "13.6",
      mode: "paragraph",
      instruction: "Full Paragraph Practice 5.",
      text: [
        "परिश्रम ही सफलता की सच्ची कुंजी कहलाती है।",
        "कभी भी निराश नहीं होना चाहिए और चलते रहो।",
        "सही दिशा में किया गया काम कभी व्यर्थ नहीं होता।",
        "परिश्रम ही सफलता की सच्ची कुंजी कहलाती है।",
        "कभी भी निराश नहीं होना चाहिए और चलते रहो।",
        "सही दिशा में किया गया काम कभी व्यर्थ नहीं होता।"
      ]
    },

    // ------------------------------------------
    // Lesson 14: Real Passages 2
    // ------------------------------------------
    {
      title: "14.1",
      mode: "paragraph",
      instruction: "Final Master Level. Prove your speed and rhythm.",
      text: [
        "Welcome to the Final Master Level! You are now typing complex paragraphs that require deep focus and sustained stamina.",
        "Master Endurance. Combine pure vowels, heavy consonants, and complex conjuncts in these long passages.",
        "This is the ultimate test of your muscle memory. Maintain a perfectly steady rhythm, striking the keys with even pressure and pacing.",
        "If you make an error, do not panic or let it break your rhythm. Recover gracefully, prioritize 100% accuracy, and keep pushing forward like a professional typist!"
      ],
      image: null
    },
    {
      title: "14.2",
      mode: "paragraph",
      instruction: "Master Paragraph Practice 1.",
      text: [
        "विद्यालय ज्ञान का मंदिर है जहां शिक्षा मिलती है।",
        "गुरूजन हमें अच्छा रास्ता और सम्मान सिखाते हैं।",
        "विद्यार्थी जीवन तप से भरी लगन का समय होता है।",
        "विद्यालय ज्ञान का मंदिर है जहां शिक्षा मिलती है।",
        "गुरूजन हमें अच्छा रास्ता और सम्मान सिखाते हैं।",
        "विद्यार्थी जीवन तप से भरी लगन का समय होता है।"
      ]
    },
    {
      title: "14.3",
      mode: "paragraph",
      instruction: "Master Paragraph Practice 2.",
      text: [
        "आज का समय तक्निकी और उन्नति का काल है।",
        "हमें समय के साथ मिलकर काम करना सुखद है।",
        "नई चीजों को सिखना लाभकारी और बेहतर है।",
        "आज का समय तक्निकी और उन्नति का काल है।",
        "हमें समय के साथ मिलकर काम करना सुखद है।",
        "नई चीजों को सिखना लाभकारी और बेहतर है।"
      ]
    },
    {
      title: "14.4",
      mode: "paragraph",
      instruction: "Master Paragraph Practice 3.",
      text: [
        "सुबह जल्दी उठना स्वर ओर स्वास्थ्य के लिए अच्छा है।",
        "व्यायाम करने से शरीर सुंदर और ताकतवर बनता है।",
        "हमें प्रतिदिन उठकर प्रार्थना करके प्रारम्भ करना चाहिए।",
        "सुबह जल्दी उठना स्वर ओर स्वास्थ्य के लिए अच्छा है।",
        "व्यायाम करने से शरीर सुंदर और ताकतवर बनता है।",
        "हमें प्रतिदिन उठकर प्रार्थना करके प्रारम्भ करना चाहिए।"
      ]
    },
    {
      title: "14.5",
      mode: "paragraph",
      instruction: "Master Paragraph Practice 4.",
      text: [
        "मित्रता सबसे अच्छा ओर निस्वार्थ संबंध होता है।",
        "सच्चा मित्र हमेशा मुश्कल समय में काम आता है।",
        "हमें अपने दोस्तों के साथ कभी झूठ नहीं बोलना चाहिए।",
        "मित्रता सबसे अच्छा ओर निस्वार्थ संबंध होता है।",
        "सच्चा मित्र हमेशा मुश्कल समय में काम आता है।",
        "हमें अपने दोस्तों के साथ कभी झूठ नहीं बोलना चाहिए।"
      ]
    },
    {
      title: "14.6",
      mode: "paragraph",
      instruction: "Master Paragraph Practice 5.",
      text: [
        "पर्यावरण की रक्षा करना हमारा सभी का कर्त्तव्य है।",
        "पेड़ पौधे हमारी धरती को जीवन पदान करते हैं।",
        "जल प्रदूषण रोकना हमारी परम्परा और धर्म है।",
        "पर्यावरण की रक्षा करना हमारा सभी का कर्त्तव्य है।",
        "पेड़ पौधे हमारी धरती को जीवन पदान करते हैं।",
        "जल प्रदूषण रोकना हमारी परम्परा और धर्म है।"
      ]
    }
  ];
};

// ==========================================
// 🇮🇳 HINDI (REMINGTON GAIL) LESSON CURRICULUM
// ==========================================
export const getRemingtonGailLessons = () => {
  return [
    // ------------------------------------------
    // Lesson 1: Home Row Core (a s d f j k l ;)
    // ------------------------------------------
    {
      title: "1.1",
      instruction: "Welcome to Remington GAIL! Place your fingers on the Home Row.",
      text: [
        "Welcome to Remington GAIL / CBI typing! This layout mimics the classic Hindi typewriter and shares many similarities with Kruti Dev. Your journey begins on the Home Row.",
        "The Left Hand: Rest your pinky lightly on 'A' (ं), your ring finger on 'S' (े), your middle finger on 'D' (क), and anchor your index finger firmly on 'F' (ि).",
        "The Right Hand: Anchor your right index finger firmly on 'J' (र), your middle finger on 'K' (ा), your ring finger on 'L' (स), and rest your pinky on the semicolon ';' (य).",
        "The Golden Rule: Gently rub the 'F' and 'J' keys to feel the small, raised physical bumps. Keep your wrists elevated, sit up straight, and never look down at your hands!"
      ],
      image: "/Homerowremingtonkeys.webp"
    },
    {
      title: "1.2",
      instruction: "Begin your muscle memory training. Type these precise 2-letter blocks arranged in a strict grid. Do not rush; focus entirely on hitting the exact center of each key without looking down at your hands. Accuracy builds speed.",
      text: [
        "कर कस सर रस ",
        "यक यक रा सा ",
        "कर कस सर रस ",
        "यक यक रा सा ",
        "कर कस सर रस ",
        "यक यक रा सा ",
        "कर कस सर रस ",
        "यक यक रा सा "
      ]
    },
    {
      title: "1.3",
      instruction: "Expand your finger reach. Type these 3-letter combinations while maintaining a perfectly steady rhythm. If you make a mistake, do not panic—simply locate the correct key by feel, pull your fingers back to the home row, and continue the pattern.",
      text: [
        "करक सरस कसर रकस ",
        "काक सार यार कयर ",
        "करक सरस कसर रकस ",
        "काक सार यार कयर ",
        "करक सरस कसर रकस ",
        "काक सार यार कयर ",
        "करक सरस कसर रकस ",
        "काक सार यार कयर "
      ]
    },
    {
      title: "1.4",
      instruction: "Build fluid keystroke transitions. These 4-letter blocks require your fingers to move sequentially. Keep your wrists slightly elevated above the desk and let your fingers curl naturally over the keys. Breathe and maintain a steady pace.",
      text: [
        "करकर सरसर कसरस यकयक ",
        "सकरक रकसक कारस सारक ",
        "करकर सरसर कसरस यकयक ",
        "सकरक रकसक कारस सारक ",
        "करकर सरसर कसरस यकयक ",
        "सकरक रकसक कारस सारक ",
        "करकर सरसर कसरस यकयक ",
        "सकरक रकसक कारस सारक "
      ]
    },
    {
      title: "1.5",
      instruction: "Transition from abstract blocks to real typing patterns. Read the entire phrase in your mind before you start typing it. Connect the words smoothly, ensuring you strike the spacebar gently with the side of your resting thumb.",
      text: [
        "कर कस सर ",
        "यक रा सा ",
        "करक सरस कसर ",
        "करकर सरसर कसरस ",
        "कर कस सर ",
        "यक रा सा ",
        "करक सरस कसर ",
        "करकर सरसर कसरस "
      ]
    },
    {
      title: "1.6",
      instruction: "Endurance and stamina test. Type the full paragraph with deep focus to train your sustained muscle memory. You must press the ENTER key at the exact end of each paragraph to proceed. Prioritize absolute accuracy over speed.",
      text: [
        "कर कस सर रस यक यक रा सा करक सरस कसर रकस",
        "काक सार यार कयर करकर सरसर कसरस यकयक सकरक रकसक कारस सारक",
        "कर कस सर रस यक यक रा सा करक सरस कसर रकस",
        "काक सार यार कयर करकर सरसर कसरस यकयक सकरक रकसक कारस सारक",
        "कर कस सर रस यक यक रा सा करक सरस कसर रकस",
        "काक सार यार कयर करकर सरसर कसरस यकयक सकरक रकसक कारस सारक"
      ]
    },

    // ------------------------------------------
    // Lesson 2: Home Row Extensions (g h ')
    // ------------------------------------------
    {
      title: "2.1",
      instruction: "Reach your index fingers inward for g and h, and your right pinky outward for the apostrophe (').",
      text: [
        "Welcome to the home row extensions! In this lesson, you will practice reaching sideways into the middle of the keyboard, as well as stretching your pinky outward.",
        "The Index Fingers (G & H): Stretch your left index finger inward to the right to tap the 'G' (ह) key. Stretch your right index finger inward to the left to tap the 'H' (ी) key. Always feel for the F and J bumps to return safely.",
        "The Right Pinky (Apostrophe): Keep your right index finger firmly planted on 'J'. Reach your right pinky outward to the right to strike the Apostrophe (') key, which types 'श'. Once pressed, immediately snap it back to the semicolon.",
        "The Golden Rule: The biggest temptation during sideways reaches is to let your entire hand slide across the keyboard. Resist it! Keep your wrists perfectly still, maintain your anchor fingers, and let only the reaching fingers do the work."
      ],
      image: "/Lesson2remington.webp"
    },
    {
      title: "2.2",
      instruction: "Begin your muscle memory training. Type these precise 2-letter blocks arranged in a strict grid. Do not rush; focus entirely on hitting the exact center of each key without looking down at your hands. Accuracy builds speed.",
      text: [
        "हर हस शक शर ",
        "ही शी रा सा ",
        "हर हस शक शर ",
        "ही शी शक यश ",
        "हर हस शक शर ",
        "ही शी रा सा ",
        "हर हस शक शर ",
        "ही शी शक यश "
      ]
    },
    {
      title: "2.3",
      instruction: "Expand your finger reach. Type these 3-letter combinations while maintaining a perfectly steady rhythm. If you make a mistake, do not panic—simply locate the correct key by feel, pull your fingers back to the home row, and continue the pattern.",
      text: [
        "शहर कहर शहर कहर ",
        "हीर शीर हशह हसक ",
        "शहर कहर शहर कहर ",
        "हीर शीर हशह हसक ",
        "शहर कहर शहर कहर ",
        "हीर शीर हशह हसक ",
        "शहर कहर शहर कहर ",
        "हीर शीर हशह हसक "
      ]
    },
    {
      title: "2.4",
      instruction: "Build fluid keystroke transitions. These 4-letter blocks require your fingers to move sequentially. Keep your wrists slightly elevated above the desk and let your fingers curl naturally over the keys. Breathe and maintain a steady pace.",
      text: [
        "शहरक कहरक शकरक हीरश ",
        "शशीर हशहर कहकह शहरक ",
        "शहरक कहरक शकरक हीरश ",
        "शशीर हशहर कहकह शहरक ",
        "शहरक कहरक शकरक हीरश ",
        "शशीर हशहर कहकह शहरक ",
        "शहरक कहरक शकरक हीरश ",
        "शशीर हशहर कहकह शहरक "
      ]
    },
    {
      title: "2.5",
      instruction: "Transition from abstract blocks to real typing patterns. Read the entire phrase in your mind before you start typing it. Connect the words smoothly, ensuring you strike the spacebar gently with the side of your resting thumb.",
      text: [
        "हर हस शक ",
        "ही शी रा ",
        "शहर कहर शहर ",
        "शहरक कहरक शकरक ",
        "हर हस शक ",
        "ही शी रा ",
        "शहर कहर शहर ",
        "शहरक कहरक शकरक "
      ]
    },
    {
      title: "2.6",
      instruction: "Endurance and stamina test. Type the full paragraph with deep focus to train your sustained muscle memory. You must press the ENTER key at the exact end of each paragraph to proceed. Prioritize absolute accuracy over speed.",
      text: [
        "हर हस शक शर ही शी शक यश शहर कहर शहर कहर",
        "हीर शीर हशह हसक शहरक कहरक शकरक हीरश शशीर हशहर कहकह शहरक",
        "हर हस शक शर ही शी शक यश शहर कहर शहर कहर",
        "हीर शीर हशह हसक शहरक कहरक शकरक हीरश शशीर हशहर कहकह शहरक",
        "हर हस शक शर ही शी शक यश शहर कहर शहर कहर",
        "हीर शीर हशह हसक शहरक कहरक शकरक हीरश शशीर हशहर कहकह शहरक"
      ]
    },

    // ------------------------------------------
    // Lesson 3: Top Row Left (q w e r t)
    // ------------------------------------------
    {
      title: "3.1",
      instruction: "Reach your left hand up to type q, w, e, r, and t.",
      text: [
        "Welcome to the Top Row! It is time to train your left hand to reach upwards. The secret to typing fast is keeping your base secure on the home row while only stretching the specific finger you need.",
        "Left Hand (Q, W, E): Keep your index finger anchored on 'F'. Stretch your pinky up to 'Q' (ु), your ring finger up to 'W' (ू), and your middle finger up to 'E' (म). After striking, always pull them back down to their resting spots.",
        "The Index Finger (R & T): Your left index finger has two jobs here. Stretch it straight up to tap 'R' (त), and reach up and slightly right to strike 'T' (ज). Immediately return it to the 'F' bump after every keystroke.",
        "The Golden Rule: Let your fingers do the reaching! Never move your entire wrist or slide your whole hand up the keyboard. Keep your wrists steady and slightly elevated."
      ],
      image: "/Lesson3remington.webp"
    },
    {
      title: "3.2",
      instruction: "Begin your muscle memory training. Type these precise 2-letter blocks arranged in a strict grid. Do not rush; focus entirely on hitting the exact center of each key without looking down at your hands. Accuracy builds speed.",
      text: [
        "मत जम मर रज ",
        "ताज राज तुम जुम ",
        "मत जम मर रज ",
        "ताज राज तुम जुम ",
        "मत जम मर रज ",
        "ताज राज तुम जुम ",
        "मत जम मर रज ",
        "ताज राज तुम जुम "
      ]
    },
    {
      title: "3.3",
      instruction: "Expand your finger reach. Type these 3-letter combinations while maintaining a perfectly steady rhythm. If you make a mistake, do not panic—simply locate the correct key by feel, pull your fingers back to the home row, and continue the pattern.",
      text: [
        "मतर जमर तजर राज ",
        "ताज जतम मुम तुम ",
        "मतर जमर तजर राज ",
        "ताज जतम मुम तुम ",
        "मतर जमर तजर राज ",
        "ताज जतम मुम तुम ",
        "मतर जमर तजर राज ",
        "ताज जतम मुम तुम "
      ]
    },
    {
      title: "3.4",
      instruction: "Build fluid keystroke transitions. These 4-letter blocks require your fingers to move sequentially. Keep your wrists slightly elevated above the desk and let your fingers curl naturally over the keys. Breathe and maintain a steady pace.",
      text: [
        "मतरम जमरज तजरत राजत ",
        "ताजम जतमर जुमत मुमर ",
        "मतरम जमरज तजरत राजत ",
        "ताजम जतमर जुमत मुमर ",
        "मतरम जमरज तजरत राजत ",
        "ताजम जतमर जुमत मुमर ",
        "मतरम जमरज तजरत राजत ",
        "ताजम जतमर जुमत मुमर "
      ]
    },
    {
      title: "3.5",
      instruction: "Transition from abstract blocks to real typing patterns. Read the entire phrase in your mind before you start typing it. Connect the words smoothly, ensuring you strike the spacebar gently with the side of your resting thumb.",
      text: [
        "मत जम मर ",
        "ताज राज तुम ",
        "मतर जमर तजर ",
        "मतरम जमरज तजरत ",
        "मत जम मर ",
        "ताज राज तुम ",
        "मतर जमर तजर ",
        "मतरम जमरज तजरत "
      ]
    },
    {
      title: "3.6",
      instruction: "Endurance and stamina test. Type the full paragraph with deep focus to train your sustained muscle memory. You must press the ENTER key at the exact end of each paragraph to proceed. Prioritize absolute accuracy over speed.",
      text: [
        "मत जम मर रज ताज राज तुम जुम मतर जमर तजर राज",
        "ताज जतम मुम तुम मतरम जमरज तजरत राजत ताजम जतमर जुमत मुमर",
        "मत जम मर रज ताज राज तुम जुम मतर जमर तजर राज",
        "ताज जतम मुम तुम मतरम जमरज तजरत राजत ताजम जतमर जुमत मुमर",
        "मत जम मर रज ताज राज तुम जुम मतर जमर तजर राज",
        "ताज जतम मुम तुम मतरम जमरज तजरत राजत ताजम जतमर जुमत मुमर"
      ]
    },

    // ------------------------------------------
    // Lesson 4: Top Row Right (y u i o p [ ] \)
    // ------------------------------------------
    {
      title: "4.1",
      instruction: "Right hand reaches up for y, u, i, o, p, [, ], and \\.",
      text: [
        "Welcome to the Top Row Right! It is time to train your right hand to stretch upwards. Keep your index finger anchored on 'J' while the other fingers do the reaching.",
        "Right Hand (Y, U, I): Keep your index finger anchored on 'J'. Stretch your index finger up and left to 'Y' (ल), and straight up to 'U' (न). Stretch your middle finger up to 'I' (प). Always pull them back down to their resting spots.",
        "The Outer Reaches (O, P, [, ], \\): Stretch your ring finger up to 'O' (व). Stretch your pinky up to 'P' (च), '[' (ख), ']' (,), and all the way to '\\' (?). The pinky has to cover a lot of ground, so keep your wrist steady and let the finger stretch.",
        "The Golden Rule: Because the right pinky handles so many keys, beginners often twist their entire hand outward. Keep your hand straight, rely on your 'J' anchor, and let your pinky build the flexibility to reach!"
      ],
      image: "/Lesson4remington.webp"
    },
    {
      title: "4.2",
      instruction: "Begin your muscle memory training. Type these precise 2-letter blocks arranged in a strict grid. Do not rush; focus entirely on hitting the exact center of each key without looking down at your hands. Accuracy builds speed.",
      text: [
        "पल नल चल वक ",
        "खत पान नाम वल ",
        "पल नल चल वक ",
        "खत पान नाम वल ",
        "पल नल चल वक ",
        "खत पान नाम वल ",
        "पल नल चल वक ",
        "खत पान नाम वल "
      ]
    },
    {
      title: "4.3",
      instruction: "Expand your finger reach. Type these 3-letter combinations while maintaining a perfectly steady rhythm. If you make a mistake, do not panic—simply locate the correct key by feel, pull your fingers back to the home row, and continue the pattern.",
      text: [
        "पलन नलक चलच वकव ",
        "खतख पान नाम वलव ",
        "पलन नलक चलच वकव ",
        "खतख पान नाम वलव ",
        "पलन नलक चलच वकव ",
        "खतख पान नाम वलव ",
        "पलन नलक चलच वकव ",
        "खतख पान नाम वलव "
      ]
    },
    {
      title: "4.4",
      instruction: "Build fluid keystroke transitions. These 4-letter blocks require your fingers to move sequentially. Keep your wrists slightly elevated above the desk and let your fingers curl naturally over the keys. Breathe and maintain a steady pace.",
      text: [
        "पलनल नलकन चलचव वकवक ",
        "खतखत पानप नामन वलवल ",
        "पलनल नलकन चलचव वकवक ",
        "खतखत पानप नामन वलवल ",
        "पलनल नलकन चलचव वकवक ",
        "खतखत पानप नामन वलवल ",
        "पलनल नलकन चलचव वकवक ",
        "खतखत पानप नामन वलवल "
      ]
    },
    {
      title: "4.5",
      instruction: "Transition from abstract blocks to real typing patterns. Read the entire phrase in your mind before you start typing it. Connect the words smoothly, ensuring you strike the spacebar gently with the side of your resting thumb.",
      text: [
        "पल नल चल ",
        "खत पान नाम ",
        "पलन नलक चलच ",
        "पलनल नलकन चलचव ",
        "पल नल चल ",
        "खत पान नाम ",
        "पलन नलक चलच ",
        "पलनल नलकन चलचव "
      ]
    },
    {
      title: "4.6",
      instruction: "Endurance and stamina test. Type the full paragraph with deep focus to train your sustained muscle memory. You must press the ENTER key at the exact end of each paragraph to proceed. Prioritize absolute accuracy over speed.",
      text: [
        "पल नल चल वक खत पान नाम वल पलन नलक चलच वकव",
        "खतख पान नाम वलव पलनल नलकन चलचव वकवक खतखत पानप नामन वलवल",
        "पल नल चल वक खत पान नाम वल पलन नलक चलच वकव",
        "खतख पान नाम वलव पलनल नलकन चलचव वकवक खतखत पानप नामन वलवल",
        "पल नल चल वक खत पान नाम वल पलन नलक चलच वकव",
        "खतख पान नाम वलव पलनल नलकन चलचव वकवक खतखत पानप नामन वलवल"
      ]
    },

    // ------------------------------------------
    // Lesson 5: Bottom Row Left (z x c v b)
    // ------------------------------------------
    {
      title: "5.1",
      instruction: "Drop your left fingers down to type z, x, c, v, and b.",
      text: [
        "Welcome to the Bottom Row! Reaching downwards can feel a bit unnatural at first because your fingers have to curl inward. Do not flatten your hands; keep a natural curve as you pull your fingers downward.",
        "Left Hand (Z, X, C): Keep your left index finger anchored on the 'F' bump. Drop your pinky down to 'Z' (्र), your ring finger down to 'X' (ग), and your middle finger down to 'C' (ब). Pull them back up to the home row immediately after striking.",
        "The Index Finger (V & B): Your left index finger does double duty here. Drop it straight down to tap 'V' (अ), and reach down and slightly right to strike 'B' (इ). Always return to the 'F' bump to stay oriented.",
        "The Golden Rule: Because the bottom row requires curling, beginners often tend to drop their entire wrist onto the desk to reach. Keep your wrists slightly elevated to give your fingers the clearance they need to curl cleanly!"
      ],
      image: "/Lesson5remington.webp"
    },
    {
      title: "5.2",
      instruction: "Begin your muscle memory training. Type these precise 2-letter blocks arranged in a strict grid. Do not rush; focus entirely on hitting the exact center of each key without looking down at your hands. Accuracy builds speed.",
      text: [
        "अब जब तब गन ",
        "बन गम अग इब ",
        "अब जब तब गन ",
        "बन गम अग इब ",
        "अब जब तब गन ",
        "बन गम अग इब ",
        "अब जब तब गन ",
        "बन गम अग इब "
      ]
    },
    {
      title: "5.3",
      instruction: "Expand your finger reach. Type these 3-letter combinations while maintaining a perfectly steady rhythm. If you make a mistake, do not panic—simply locate the correct key by feel, pull your fingers back to the home row, and continue the pattern.",
      text: [
        "अबज जबत तबग गनब ",
        "बनग गमक अगब इबज ",
        "अबज जबत तबग गनब ",
        "बनग गमक अगब इबज ",
        "अबज जबत तबग गनब ",
        "बनग गमक अगब इबज ",
        "अबज जबत तबग गनब ",
        "बनग गमक अगब इबज "
      ]
    },
    {
      title: "5.4",
      instruction: "Build fluid keystroke transitions. These 4-letter blocks require your fingers to move sequentially. Keep your wrists slightly elevated above the desk and let your fingers curl naturally over the keys. Breathe and maintain a steady pace.",
      text: [
        "अबजब जबतब तबगन गनबन ",
        "गमकग अगबग इबजब अगअग ",
        "अबजब जबतब तबगन गनबन ",
        "गमकग अगबग इबजब अगअग ",
        "अबजब जबतब तबगन गनबन ",
        "गमकग अगबग इबजब अगअग ",
        "अबजब जबतब तबगन गनबन ",
        "गमकग अगबग इबजब अगअग "
      ]
    },
    {
      title: "5.5",
      instruction: "Transition from abstract blocks to real typing patterns. Read the entire phrase in your mind before you start typing it. Connect the words smoothly, ensuring you strike the spacebar gently with the side of your resting thumb.",
      text: [
        "अब जब तब ",
        "बन गम अग ",
        "अबज जबत तबग ",
        "अबजब जबतब तबगन ",
        "अब जब तब ",
        "बन गम अग ",
        "अबज जबत तबग ",
        "अबजब जबतब तबगन "
      ]
    },
    {
      title: "5.6",
      instruction: "Endurance and stamina test. Type the full paragraph with deep focus to train your sustained muscle memory. You must press the ENTER key at the exact end of each paragraph to proceed. Prioritize absolute accuracy over speed.",
      text: [
        "अब जब तब गन बन गम अग इब अबज जबत तबग गनब",
        "बनग गमक अगब इबज अबजब जबतब तबगन गनबन गमकग अगबग इबजब अगअग",
        "अब जब तब गन बन गम अग इब अबज जबत तबग गनब",
        "बनग गमक अगब इबज अबजब जबतब तबगन गनबन गमकग अगबग इबजब अगअग",
        "अब जब तब गन बन गम अग इब अबज जबत तबग गनब",
        "बनग गमक अगब इबज अबजब जबतब तबगन गनबन गमकग अगबग इबजब अगअग"
      ]
    },

    // ------------------------------------------
    // Lesson 6: Bottom Row Right (n m , . /)
    // ------------------------------------------
    {
      title: "6.1",
      instruction: "Drop your right fingers down to type n, m, comma (,), period (.), and slash (/).",
      text: [
        "Welcome to the Bottom Row Right! This lesson completes the primary unshifted characters of the Remington GAIL layout. Reaching downwards requires keeping a natural curve in your fingers without flattening your hand.",
        "The Index Finger (N & M): Keep your right index finger anchored on the 'J' bump. Drop it down and slightly left to tap 'N' (द), and straight down to tap 'M' (उ). Immediately pull it back to the home row after striking.",
        "The Outer Fingers (Comma, Period, Slash): Drop your right middle finger down to the Comma ',' (ए). Drop your ring finger down to the Period '.' (ण्). Drop your right pinky down to the Slash '/' (ध).",
        "Congratulations! You have now mapped all the core unshifted keys. Keep your wrists slightly elevated above the desk. This gives your fingers the necessary clearance to curl downward cleanly without your hands dragging."
      ],
      image: "/Lesson6remington.webp"
    },
    {
      title: "6.2",
      instruction: "Begin your muscle memory training. Type these precise 2-letter blocks arranged in a strict grid. Do not rush; focus entirely on hitting the exact center of each key without looking down at your hands. Accuracy builds speed.",
      text: [
        "दम दा दि धन ",
        "एद उद दद उउ ",
        "दम दा दि धन ",
        "एद उद दद उउ ",
        "दम दा दि धन ",
        "एद उद दद उउ ",
        "दम दा दि धन ",
        "एद उद दद उउ "
      ]
    },
    {
      title: "6.3",
      instruction: "Expand your finger reach. Type these 3-letter combinations while maintaining a perfectly steady rhythm. If you make a mistake, do not panic—simply locate the correct key by feel, pull your fingers back to the home row, and continue the pattern.",
      text: [
        "दमन दान दिन धनद ",
        "एदद उदन ददम उउद ",
        "दमन दान दिन धनद ",
        "एदद उदन ददम उउद ",
        "दमन दान दिन धनद ",
        "एदद उदन ददम उउद ",
        "दमन दान दिन धनद ",
        "एदद उदन ददम उउद "
      ]
    },
    {
      title: "6.4",
      instruction: "Build fluid keystroke transitions. These 4-letter blocks require your fingers to move sequentially. Keep your wrists slightly elevated above the desk and let your fingers curl naturally over the keys. Breathe and maintain a steady pace.",
      text: [
        "दमदम दानद दिनद धनदद ",
        "एददद उददन ददमद उउदद ",
        "दमदम दानद दिनद धनदद ",
        "एददद उददन ददमद उउदद ",
        "दमदम दानद दिनद धनदद ",
        "एददद उददन ददमद उउदद ",
        "दमदम दानद दिनद धनदद ",
        "एददद उददन ददमद उउदद "
      ]
    },
    {
      title: "6.5",
      instruction: "Transition from abstract blocks to real typing patterns. Read the entire phrase in your mind before you start typing it. Connect the words smoothly, ensuring you strike the spacebar gently with the side of your resting thumb.",
      text: [
        "दम दा दि ",
        "एद उद दद ",
        "दमन दान दिन ",
        "दमदम दानद दिनद ",
        "दम दा दि ",
        "एद उद दद ",
        "दमन दान दिन ",
        "दमदम दानद दिनद "
      ]
    },
    {
      title: "6.6",
      instruction: "Endurance and stamina test. Type the full paragraph with deep focus to train your sustained muscle memory. You must press the ENTER key at the exact end of each paragraph to proceed. Prioritize absolute accuracy over speed.",
      text: [
        "दम दा दि धन. एद उद दद उउ. दमन दान दिन धनद.",
        "एदद उदन ददम उउद. दमदम दानद दिनद धनदद. एददद उददन ददमद उउदद.",
        "दम दा दि धन. एद उद दद उउ. दमन दान दिन धनद.",
        "एदद उदन ददम उउद. दमदम दानद दिनद धनदद. एददद उददन ददमद उउदद.",
        "दम दा दि धन. एद उद दद उउ. दमन दान दिन धनद.",
        "एदद उदन ददम उउद. दमदम दानद दिनद धनदद. एददद उददन ददमद उउदद."
      ]
    },

    // ------------------------------------------
    // Lesson 7: Left Hand (Top & Home Row) + Right Shift
    // ------------------------------------------
    {
      title: "7.1",
      instruction: "Hold Right Shift and type the Top & Home rows with your left hand, including the inward reach for G.",
      text: [
        "Welcome to Capitalization and Half-Letters! To type these special characters in Remington GAIL, you must use the Shift key. The unbreakable rule is to ALWAYS use the pinky finger of the OPPOSITE hand to hold down Shift.",
        "The Right Shift Anchor: Because we are typing with the left hand, reach your right pinky down to firmly hold the Right Shift key. Do not twist your right wrist; keep your hand straight and let the pinky stretch.",
        "The Left Hand (Home Row): Keep holding Right Shift. Use your left fingers to type 'A' (ँ), 'S' (ै), 'D' (क्), and 'F' (थ). Finally, stretch your left index finger inward to type 'G' (ळ).",
        "The Left Hand (Top Row): Keep holding Right Shift. Reach your left fingers up to type 'Q' (फ), 'W' (ॅ), 'E' (म्), 'R' (त्), and 'T' (ज्). Let go of the Shift key immediately after completing your keystrokes to return to the resting home row."
      ],
      image: "/Lesson7remington.webp"
    },
    {
      title: "7.2",
      instruction: "Begin your muscle memory training. Type these precise 2-letter blocks arranged in a strict grid. Do not rush; focus entirely on hitting the exact center of each key without looking down at your hands. Accuracy builds speed.",
      text: [
        "फक थक टक ठक ",
        "फफ थथ टट ठठ ",
        "फक थक टक ठक ",
        "फफ थथ टट ठठ ",
        "फक थक टक ठक ",
        "फफ थथ टट ठठ ",
        "फक थक टक ठक ",
        "फफ थथ टट ठठ "
      ]
    },
    {
      title: "7.3",
      instruction: "Expand your finger reach. Type these 3-letter combinations while maintaining a perfectly steady rhythm. If you make a mistake, do not panic—simply locate the correct key by feel, pull your fingers back to the home row, and continue the pattern.",
      text: [
        "फकफ थकथ टकट ठकठ ",
        "फथट ठफथ टठक फकठ ",
        "फकफ थकथ टकट ठकठ ",
        "फथट ठफथ टठक फकठ ",
        "फकफ थकथ टकट ठकठ ",
        "फथट ठफथ टठक फकठ ",
        "फकफ थकथ टकट ठकठ ",
        "फथट ठफथ टठक फकठ "
      ]
    },
    {
      title: "7.4",
      instruction: "Build fluid keystroke transitions. These 4-letter blocks require your fingers to move sequentially. Keep your wrists slightly elevated above the desk and let your fingers curl naturally over the keys. Breathe and maintain a steady pace.",
      text: [
        "फकफक थकथक टकटक ठकठक ",
        "फथटठ ठफथट टठकफ फकठक ",
        "फकफक थकथक टकटक ठकठक ",
        "फथटठ ठफथट टठकफ फकठक ",
        "फकफक थकथक टकटक ठकठक ",
        "फथटठ ठफथट टठकफ फकठक ",
        "फकफक थकथक टकटक ठकठक ",
        "फथटठ ठफथट टठकफ फकठक "
      ]
    },
    {
      title: "7.5",
      instruction: "Transition from abstract blocks to real typing patterns. Read the entire phrase in your mind before you start typing it. Connect the words smoothly, ensuring you strike the spacebar gently with the side of your resting thumb.",
      text: [
        "फक थक टक ",
        "फफ थथ टट ",
        "फकफ थकथ टकट ",
        "फकफक थकथक टकटक ",
        "फक थक टक ",
        "फफ थथ टट ",
        "फकफ थकथ टकट ",
        "फकफक थकथक टकटक "
      ]
    },
    {
      title: "7.6",
      instruction: "Endurance and stamina test. Type the full paragraph with deep focus to train your sustained muscle memory. You must press the ENTER key at the exact end of each paragraph to proceed. Prioritize absolute accuracy over speed.",
      text: [
        "फक थक टक ठक. फफ थथ टट ठठ. फकफ थकथ टकट ठकठ.",
        "फथट ठफथ टठक फकठ. फकफक थकथक टकटक ठकठक. फथटठ ठफथट टठकफ फकठक.",
        "फक थक टक ठक. फफ थथ टट ठठ. फकफ थकथ टकट ठकठ.",
        "फथट ठफथ टठक फकठ. फकफक थकथक टकटक ठकठक. फथटठ ठफथट टठकफ फकठक.",
        "फक थक टक ठक. फफ थथ टट ठठ. फकफ थकथ टकट ठकठ.",
        "फथट ठफथ टठक फकठ. फकफक थकथक टकटक ठकठक. फथटठ ठफथट टठकफ फकठक."
      ]
    },

    // ------------------------------------------
    // Lesson 8: Left Hand (Bottom) + Right Shift
    // ------------------------------------------
    {
      title: "8.1",
      instruction: "Hold Right Shift and type the bottom row with your left hand, including Z.",
      text: [
        "Welcome to the Bottom Row Shifts! Curling your fingers downward while your opposite hand holds the Shift key is one of the most complex stretches in typing. Take your time and keep your wrists relaxed.",
        "The Right Shift Anchor: Reach your right pinky down to firmly hold the Right Shift key. Keep your hand straight and avoid twisting your right wrist.",
        "Left Hand (Z, X, C): While holding Right Shift, drop your left pinky down to 'Z' (र्), your ring finger to 'X' (ग्), and your middle finger to 'C' (ब्). Return them to the home row immediately after each strike.",
        "The Index Finger (V & B): Keep holding Right Shift. Drop your left index finger straight down for 'V' (ट), and reach down and slightly right for 'B' (ठ). Ensure your left wrist stays elevated so your fingers have room to curl cleanly."
      ],
      image: "/Lesson8remington.webp"
    },
    {
      title: "8.2",
      instruction: "Begin your muscle memory training. Type these precise 2-letter blocks arranged in a strict grid. Do not rush; focus entirely on hitting the exact center of each key without looking down at your hands. Accuracy builds speed.",
      text: [
        "भक छक डक ढक ",
        "घक भभ छछ डड ",
        "भक छक डक ढक ",
        "घक भभ छछ डड ",
        "भक छक डक ढक ",
        "घक भभ छछ डड ",
        "भक छक डक ढक ",
        "घक भभ छछ डड "
      ]
    },
    {
      title: "8.3",
      instruction: "Expand your finger reach. Type these 3-letter combinations while maintaining a perfectly steady rhythm. If you make a mistake, do not panic—simply locate the correct key by feel, pull your fingers back to the home row, and continue the pattern.",
      text: [
        "भकभ छकछ डकड ढकट ",
        "घकघ भछड ढघभ भडघ ",
        "भकभ छकछ डकड ढकट ",
        "घकघ भछड ढघभ भडघ ",
        "भकभ छकछ डकड ढकट ",
        "घकघ भछड ढघभ भडघ ",
        "भकभ छकछ डकड ढकट ",
        "घकघ भछड ढघभ भडघ "
      ]
    },
    {
      title: "8.4",
      instruction: "Build fluid keystroke transitions. These 4-letter blocks require your fingers to move sequentially. Keep your wrists slightly elevated above the desk and let your fingers curl naturally over the keys. Breathe and maintain a steady pace.",
      text: [
        "भकभक छकछक डकडक ढकटठ ",
        "घकघक भछडघ ढघभछ भडघछ ",
        "भकभक छकछक डकडक ढकटठ ",
        "घकघक भछडघ ढघभछ भडघछ ",
        "भकभक छकछक डकडक ढकटठ ",
        "घकघक भछडघ ढघभछ भडघछ ",
        "भकभक छकछक डकडक ढकटठ ",
        "घकघक भछडघ ढघभछ भडघछ "
      ]
    },
    {
      title: "8.5",
      instruction: "Transition from abstract blocks to real typing patterns. Read the entire phrase in your mind before you start typing it. Connect the words smoothly, ensuring you strike the spacebar gently with the side of your resting thumb.",
      text: [
        "भक छक डक ",
        "घक भभ छछ ",
        "भकभ छकछ डकड ",
        "भकभक छकछक डकडक ",
        "भक छक डक ",
        "घक भभ छछ ",
        "भकभ छकछ डकड ",
        "भकभक छकछक डकडक "
      ]
    },
    {
      title: "8.6",
      instruction: "Endurance and stamina test. Type the full paragraph with deep focus to train your sustained muscle memory. You must press the ENTER key at the exact end of each paragraph to proceed. Prioritize absolute accuracy over speed.",
      text: [
        "भक छक डक ढक. घक भभ छछ डड. भकभ छकछ डकड ढकट.",
        "घकघ भछड ढघभ भडघ. भकभक छकछक डकडक ढकटठ. घकघक भछडघ ढघभछ भडघछ.",
        "भक छक डक ढक. घक भभ छछ डड. भकभ छकछ डकड ढकट.",
        "घकघ भछड ढघभ भडघ. भकभक छकछक डकडक ढकटठ. घकघक भछडघ ढघभछ भडघछ.",
        "भक छक डक ढक. घक भभ छछ डड. भकभ छकछ डकड ढकट.",
        "घकघ भछड ढघभ भडघ. भकभक छकछक डकडक ढकटठ. घकघक भछडघ ढघभछ भडघछ."
      ]
    },

    // ------------------------------------------
    // Lesson 9: Right Hand (Top & Home Row) + Left Shift
    // ------------------------------------------
    {
      title: "9.1",
      instruction: "Hold Left Shift and type the Top & Home rows with your right hand, including } and |.",
      text: [
        "Welcome to the Right Hand Shifts! Here you will practice holding the Left Shift key while your right hand navigates both the Home and Top rows, including the furthest outer reaches.",
        "The Left Shift Anchor: Use your left pinky to firmly press and hold the Left Shift key. Keep your left hand securely anchored on the desk to prevent your wrists from twisting.",
        "Right Hand (Home Row): While holding Left Shift, use your right fingers to strike 'H' (भ्), 'J' (श्र), 'K' (ज्ञ), 'L' (स्), ':' (रू), and '\"' (ष्).",
        "Right Hand (Top Row & Extremes): Keep holding Left Shift. Stretch your right fingers up to type 'Y' (ल्), 'U' (न्), 'I' (प्), 'O' (व्), 'P' (च्), '{' (ख्), and push your pinky to its absolute limits for '}' (द्व) and '|' (द्य). Release the shift key immediately after completing the stroke."
      ],
      image: "/Lesson9remington.webp"
    },
    {
      title: "9.2",
      instruction: "Begin your muscle memory training. Type these precise 2-letter blocks arranged in a strict grid. Do not rush; focus entirely on hitting the exact center of each key without looking down at your hands. Accuracy builds speed.",
      text: [
        "भघ धझ फख थछ ",
        "ठढ ञऑ ऑञ ढठ ",
        "छथ खफ झध घभ ",
        "फख थछ ठढ ञऑ ",
        "ऑञ ढठ छथ खफ ",
        "झध घभ भघ धझ ",
        "फख थछ ठढ ञऑ ",
        "ऑञ ढठ छथ खफ "
      ]
    },
    {
      title: "9.3",
      instruction: "Expand your finger reach. Type these 3-letter combinations while maintaining a perfectly steady rhythm. If you make a mistake, do not panic—simply locate the correct key by feel, pull your fingers back to the home row, and continue the pattern.",
      text: [
        "भघध झफख थछठ ढञऑ ",
        "ऑञढ ठछथ खफझ धघभ ",
        "धझफ खथछ ठढञ ऑञढ ",
        "ठछथ खफझ धघभ भघध ",
        "झफख थछठ ढञऑ ऑञढ ",
        "ठछथ खफझ धघभ भघध ",
        "झफख थछठ ढञऑ ऑञढ ",
        "ठछथ खफझ धघभ भघध "
      ]
    },
    {
      title: "9.4",
      instruction: "Build fluid keystroke transitions. These 4-letter blocks require your fingers to move sequentially. Keep your wrists slightly elevated above the desk and let your fingers curl naturally over the keys. Breathe and maintain a steady pace.",
      text: [
        "भघधझ फखथछ ठढञऑ ऑञढठ ",
        "छथखफ झधघभ भघधझ फखथछ ",
        "ठढञऑ ऑञढठ छथखफ झधघभ ",
        "धझफख थछठढ ञऑऑञ ढठछथ ",
        "खफझध घभभघ धझफख थछठढ ",
        "ञऑऑञ ढठछथ खफझध घभभघ ",
        "धझफख थछठढ ञऑऑञ ढठछथ ",
        "खफझध घभभघ धझफख थछठढ "
      ]
    },
    {
      title: "9.5",
      instruction: "Transition from abstract blocks to real typing patterns. Read the entire phrase in your mind before you start typing it. Connect the words smoothly, ensuring you strike the spacebar gently with the side of your resting thumb.",
      text: [
        "भघ धझ फख ",
        "थछ ठढ ञऑ ",
        "भघध झफख थछठ ",
        "भघधझ फखथछ ठढञऑ ",
        "ऑञ ढठ छथ ",
        "खफ झध घभ ",
        "ऑञढ ठछथ खफझ ",
        "ऑञढठ छथखफ झधघभ "
      ]
    },
    {
      title: "9.6",
      instruction: "Endurance and stamina test. Type the full paragraph with deep focus to train your sustained muscle memory. You must press the ENTER key at the exact end of each paragraph to proceed. Prioritize absolute accuracy over speed.",
      text: [
        "भघ धझ फख थछ. ठढ ञऑ ऑञ ढठ. छथ खफ झध घभ.",
        "फख थछ ठढ ञऑ. भघध झफख थछठ ढञऑ. ऑञढ ठछथ खफझ धघभ.",
        "धझफ खथछ ठढञ ऑञढ. ठछथ खफझ धघभ भघध. भघधझ फखथछ ठढञऑ ऑञढठ.",
        "छथखफ झधघभ भघधझ फखथछ. ठढञऑ ऑञढठ छथखफ झधघभ. धझफख थछठढ ञऑऑञ ढठछथ.",
        "खफझध घभभघ धझफख थछठढ. ञऑऑञ ढठछथ खफझध घभभघ. भघ धझ फख थछ.",
        "ठढ ञऑ ऑञ ढठ. भघध झफख थछठ ढञऑ. भघधझ फखथछ ठढञऑ ऑञढठ."
      ]
    },

    // ------------------------------------------
    // Lesson 10: Right Hand (Bottom) + Left Shift
    // ------------------------------------------
    {
      title: "10.1",
      instruction: "Hold Left Shift and type the bottom row with your right hand.",
      text: [
        "Welcome to the final shift lesson! Dropping your right fingers downward while holding the Left Shift key requires focus and coordination. Keep your hands relaxed.",
        "The Left Shift Anchor: Use your left pinky to firmly press and hold the Left Shift key. Keep your left wrist steady and avoid twisting your hand.",
        "The Index Finger (N & M): While holding Left Shift, drop your right index finger down and slightly left to tap 'N' (छ), and straight down to tap 'M' (ड). Return it to the home row immediately.",
        "The Outer Fingers (<, >, ?): Keep holding Left Shift. Drop your right middle finger down to '<' (ढ), your ring finger to '>' (झ), and your right pinky to '?' (घ). Always keep your wrists elevated to allow your fingers to curl cleanly!"
      ],
      image: "/Lesson10remington.webp"
    },
    {
      title: "10.2",
      instruction: "Begin your muscle memory training. Type these precise 2-letter blocks arranged in a strict grid. Do not rush; focus entirely on hitting the exact center of each key without looking down at your hands. Accuracy builds speed.",
      text: [
        "ळश ष। य़ळ शष ",
        "।य़ ळश ष। य़ळ ",
        "शष ।य़ ळश ष। ",
        "य़ळ शष ।य़ ळश ",
        "ष। य़ळ शष ।य़ ",
        "ळश ष। य़ळ शष ",
        "।य़ ळश ष। य़ळ ",
        "शष ।य़ ळश ष। "
      ]
    },
    {
      title: "10.3",
      instruction: "Expand your finger reach. Type these 3-letter combinations while maintaining a perfectly steady rhythm. If you make a mistake, do not panic—simply locate the correct key by feel, pull your fingers back to the home row, and continue the pattern.",
      text: [
        "ळशळ ष।ष य़ळय़ शषश ",
        "।य़। ळशळ ष।ष य़ळय़ ",
        "शषश ।य़। ळशळ ष।ष ",
        "य़ळय़ शषश ।य़। ळशळ ",
        "ष।ष य़ळय़ शषश ।य़। ",
        "ळशळ ष।ष य़ळय़ शषश ",
        "।य़। ळशळ ष।ष य़ळय़ ",
        "शषश ।य़। ळशळ ष।ष "
      ]
    },
    {
      title: "10.4",
      instruction: "Build fluid keystroke transitions. These 4-letter blocks require your fingers to move sequentially. Keep your wrists slightly elevated above the desk and let your fingers curl naturally over the keys. Breathe and maintain a steady pace.",
      text: [
        "ळशळश ष।ष। य़ळय़ळ शषशष ",
        "।य़।य़ ळशळश ष।ष। य़ळय़ळ ",
        "शषशष ।य़।य़ ळशळश ष।ष। ",
        "य़ळय़ळ शषशष ।य़।य़ ळशळश ",
        "ष।ष। य़ळय़ळ शषशष ।य़।य़ ",
        "ळशळश ष।ष। य़ळय़ळ शषशष ",
        "।य़।य़ ळशळश ष।ष। य़ळय़ळ ",
        "शषशष ।य़।य़ ळशळश ष।ष। "
      ]
    },
    {
      title: "10.5",
      instruction: "Transition from abstract blocks to real typing patterns. Read the entire phrase in your mind before you start typing it. Connect the words smoothly, ensuring you strike the spacebar gently with the side of your resting thumb.",
      text: [
        "ळश ष। य़ळ ",
        "।य़ ळश ष। ",
        "ळशळ ष।ष य़ळय़ ",
        "ळशळश ष।ष। य़ळय़ळ ",
        "शष ।य़ ळश ",
        "य़ळ शष ।य़ ",
        "शषश ।य़। ळशळ ",
        "शषशष ।य़।य़ ळशळश "
      ]
    },
    {
      title: "10.6",
      instruction: "Endurance and stamina test. Type the full paragraph with deep focus to train your sustained muscle memory. You must press the ENTER key at the exact end of each paragraph to proceed. Prioritize absolute accuracy over speed.",
      text: [
        "ळश ष। य़ळ शष. ।य़ ळश ष। य़ळ. शष ।य़ ळश ष।.",
        "य़ळ शष ।य़ ळश. ळशळ ष।ष य़ळय़ शषश. ।य़। ळशळ ष।ष य़ळय़.",
        "शषश ।य़। ळशळ ष।ष. य़ळय़ शषश ।य़। ळशळ. ळशळश ष।ष। य़ळय़ळ शषशष.",
        "।य़।य़ ळशळश ष।ष। य़ळय़ळ. शषशष ।य़।य़ ळशळश ष।ष।. य़ळय़ळ शषशष ।य़।य़ ळशळश.",
        "ष।ष। य़ळय़ळ शषशष ।य़।य़. ळशळश ष।ष। य़ळय़ळ शषशष. ।य़।य़ ळशळश ष।ष। य़ळय़ळ.",
        "शषशष ।य़।य़ ळशळश ष।ष।. ळश ष। य़ळ शष. ळशळ ष।ष य़ळय़ शषश."
      ]
    },

    // ------------------------------------------
    // Lesson 11: Number Row (` 1 2 3 4 5 6 7 8 9 0 - =)
    // ------------------------------------------
    {
      title: "11.1",
      instruction: "Reach up to the number row, including the backtick (`), hyphen (-), and equals (=) keys.",
      text: [
        "Welcome to the Number Row! This is the furthest reach your fingers will make. Always feel for the tactile bumps on the 'F' and 'J' keys to re-center your hands quickly after striking these keys.",
        "The Left Hand: Stretch your left pinky far up and left for the backtick (`) and straight up for '1'. Use your ring finger for '2', middle finger for '3', and let your index finger stretch to both '4' and '5'.",
        "The Right Hand: Your right index finger reaches up to '6' and '7'. Use your middle finger for '8', and ring finger for '9'. Stretch your right pinky up for '0', the hyphen (-), and the equals (=) key.",
        "The Golden Rule: Because the number row is so far away, it is very tempting to lift your hands completely off the keyboard. Try to keep your wrists anchored and let your fingers do the stretching!"
      ],
      image: "/Lesson11remington.webp"
    },
    {
      title: "11.2",
      instruction: "Begin your muscle memory training. Type these precise 2-letter blocks arranged in a strict grid. Do not rush; focus entirely on hitting the exact center of each key without looking down at your hands. Accuracy builds speed.",
      text: [
        "`d 1d 2d 3d ",
        "4d 5d 6k 7k ",
        "8k 9k 0k -k ",
        "=k d` k- k= ",
        "`d 1d 2d 3d ",
        "4d 5d 6k 7k ",
        "8k 9k 0k -k ",
        "=k d` k- k= "
      ]
    },
    {
      title: "11.3",
      instruction: "Expand your finger reach. Type these 3-letter combinations while maintaining a perfectly steady rhythm. If you make a mistake, do not panic—simply locate the correct key by feel, pull your fingers back to the home row, and continue the pattern.",
      text: [
        "`dj 1dj 2dj 3dj ",
        "4dj 5dj 6jk 7jk ",
        "8jk 9jk 0jk -jk ",
        "=jk j`d j-k j=k ",
        "`dj 1dj 2dj 3dj ",
        "4dj 5dj 6jk 7jk ",
        "8jk 9jk 0jk -jk ",
        "=jk j`d j-k j=k "
      ]
    },
    {
      title: "11.4",
      instruction: "Build fluid keystroke transitions. These 4-letter blocks require your fingers to move sequentially. Keep your wrists slightly elevated above the desk and let your fingers curl naturally over the keys. Breathe and maintain a steady pace.",
      text: [
        "`djk 1djk 2djk 3djk ",
        "4djk 5djk 6jkl 7jkl ",
        "8jkl 9jkl 0jkl -jkl ",
        "=jkl kj`d kj-k kj=k ",
        "`djk 1djk 2djk 3djk ",
        "4djk 5djk 6jkl 7jkl ",
        "8jkl 9jkl 0jkl -jkl ",
        "=jkl kj`d kj-k kj=k "
      ]
    },
    {
      title: "11.5",
      instruction: "Transition from abstract blocks to real typing patterns. Read the entire phrase in your mind before you start typing it. Connect the words smoothly, ensuring you strike the spacebar gently with the side of your resting thumb.",
      text: [
        "`d 1d 2d ",
        "8k 9k 0k ",
        "-k =k `dj ",
        "-jk =jk `djk ",
        "`d 1d 2d ",
        "8k 9k 0k ",
        "-k =k `dj ",
        "-jk =jk `djk "
      ]
    },
    {
      title: "11.6",
      instruction: "Endurance and stamina test. Type the full paragraph with deep focus to train your sustained muscle memory. You must press the ENTER key at the exact end of each paragraph to proceed. Prioritize absolute accuracy over speed.",
      text: [
        "`d 1d 2d 3d. `dj 1dj 2dj 3dj. `djk 1djk 2djk 3djk.",
        "4d 5d 6k 7k. 4dj 5dj 6jk 7jk. 4djk 5djk 6jkl 7jkl.",
        "8k 9k 0k -k. 8jk 9jk 0jk -jk. 8jkl 9jkl 0jkl -jkl.",
        "=k d` k- k=. =jk j`d j-k j=k. =jkl kj`d kj-k kj=k.",
        "`d 1d 2d 3d. `dj 1dj 2dj 3dj. `djk 1djk 2djk 3djk.",
        "4d 5d 6k 7k. 4dj 5dj 6jk 7jk. 4djk 5djk 6jkl 7jkl."
      ]
    },

    // ------------------------------------------
    // Lesson 12: Symbols & Modifiers (~ ! @ # $ % ^ & * ( ) _ +)
    // ------------------------------------------
    {
      title: "12.1",
      instruction: "Use Shift with numbers to type symbols, including tilde (~), underscore (_), and plus (+).",
      text: [
        "Welcome to Symbols and Modifiers! This lesson combines the extreme upward stretches of the number row with the cross-hand coordination of the Shift key.",
        "Left Hand Symbols: Hold the Right Shift key with your right pinky. Use your left hand fingers to reach up and type '~', '!', '@', '#', '$', and '%'.",
        "Right Hand Symbols: Hold the Left Shift key with your left pinky. Use your right hand fingers to reach up and type '^', '&', '*', '(', ')', '_', and '+'.",
        "The Golden Rule: Because these are the longest and most complex reaches on the keyboard, accuracy is far more important than speed. Take your time, keep your anchor fingers grounded when possible, and always use the opposite hand for the shift key."
      ],
      image: "/Lesson12remington.webp"
    },
    {
      title: "12.2",
      instruction: "Begin your muscle memory training. Type these precise 2-letter blocks arranged in a strict grid. Do not rush; focus entirely on hitting the exact center of each key without looking down at your hands. Accuracy builds speed.",
      text: [
        "~k !k @k #k ",
        "$k %k ^k &k ",
        "*k (k )k _k ",
        "+k k~ k_ k+ ",
        "~k !k @k #k ",
        "$k %k ^k &k ",
        "*k (k )k _k ",
        "+k k~ k_ k+ "
      ]
    },
    {
      title: "12.3",
      instruction: "Expand your finger reach. Type these 3-letter combinations while maintaining a perfectly steady rhythm. If you make a mistake, do not panic—simply locate the correct key by feel, pull your fingers back to the home row, and continue the pattern.",
      text: [
        "~kj !kj @kj #kj ",
        "$kj %kj ^kj &kj ",
        "*kj (kj )kj _kj ",
        "+kj j~k j_k j+k ",
        "~kj !kj @kj #kj ",
        "$kj %kj ^kj &kj ",
        "*kj (kj )kj _kj ",
        "+kj j~k j_k j+k "
      ]
    },
    {
      title: "12.4",
      instruction: "Build fluid keystroke transitions. These 4-letter blocks require your fingers to move sequentially. Keep your wrists slightly elevated above the desk and let your fingers curl naturally over the keys. Breathe and maintain a steady pace.",
      text: [
        "~kjk !kjk @kjk #kjk ",
        "$kjk %kjk ^kjk &kjk ",
        "*kjk (kjk )kjk _kjk ",
        "+kjk kj~k kj_k kj+k ",
        "~kjk !kjk @kjk #kjk ",
        "$kjk %kjk ^kjk &kjk ",
        "*kjk (kjk )kjk _kjk ",
        "+kjk kj~k kj_k kj+k "
      ]
    },
    {
      title: "12.5",
      instruction: "Transition from abstract blocks to real typing patterns. Read the entire phrase in your mind before you start typing it. Connect the words smoothly, ensuring you strike the spacebar gently with the side of your resting thumb.",
      text: [
        "~k !k @k ",
        "*k )k _k ",
        "+k ~kj _kj ",
        "+kjk ~kjk _kjk ",
        "~k !k @k ",
        "*k )k _k ",
        "+k ~kj _kj ",
        "+kjk ~kjk _kjk "
      ]
    },
    {
      title: "12.6",
      instruction: "Endurance and stamina test. Type the full paragraph with deep focus to train your sustained muscle memory. You must press the ENTER key at the exact end of each paragraph to proceed. Prioritize absolute accuracy over speed.",
      text: [
        "~k !k @k #k. ~kj !kj @kj #kj. ~kjk !kjk @kjk #kjk.",
        "$k %k ^k &k. $kj %kj ^kj &kj. $kjk %kjk ^kjk &kjk.",
        "*k (k )k _k. *kj (kj )kj _kj. *kjk (kjk )kjk _kjk.",
        "+k k~ k_ k+. +kj j~k j_k j+k. +kjk kj~k kj_k kj+k.",
        "~k !k @k #k. ~kj !kj @kj #kj. ~kjk !kjk @kjk #kjk.",
        "$k %k ^k &k. $kj %kj ^kj &kj. $kjk %kjk ^kjk &kjk."
      ]
    },

    // ------------------------------------------
    // Lesson 13: Real Passages 1
    // ------------------------------------------
    {
      title: "13.1",
      instruction: "You have learned all the keys! Now practice full passages.",
      text: [
        "Congratulations! You have successfully learned the location of every single key on the Remington GAIL keyboard layout.",
        "In this section, you will transition from typing abstract blocks of characters to typing real, meaningful Hindi sentences and paragraphs.",
        "Let your subconscious muscle memory guide your fingers to the correct shapes. Do not look down at your hands, even if you make a mistake.",
        "Accuracy is your absolute primary goal right now. Type at a steady, relaxed pace. As your accuracy improves, your typing speed will naturally follow!"
      ],
      image: null
    },
    {
      title: "13.2",
      mode: "paragraph",
      instruction: "Full Paragraph Practice 1.",
      text: [
        "भारत एक विशाल देश है। इसकी संस्कृति प्राचीन है।",
        "यहां विभिन्न धर्म और जाति के लोग रहते हैं।",
        "हम सब मिलकर पहले अपने देश का नाम ऊंचा करें।",
        "भारत एक विशाल देश है। इसकी संस्कृति प्राचीन है।",
        "यहां विभिन्न धर्म और जाति के लोग रहते हैं।",
        "हम सब मिलकर पहले अपने देश का नाम ऊंचा करें।"
      ]
    },
    {
      title: "13.3",
      mode: "paragraph",
      instruction: "Full Paragraph Practice 2.",
      text: [
        "सभी भारतीय मिलजुलकर प्रेम से रहते हैं।",
        "हमारी संस्कृति बहुत पुरानी और मेहनत की है।",
        "हम अपने देश के विकास में उन्नति लासकते हैं।",
        "सभी भारतीय मिलजुलकर प्रेम से रहते हैं।",
        "हमारी संस्कृति बहुत पुरानी और मेहनत की है।",
        "हम अपने देश के विकास में उन्नति लासकते हैं।"
      ]
    },
    {
      title: "13.4",
      mode: "paragraph",
      instruction: "Full Paragraph Practice 3.",
      text: [
        "देश की राजधानी नई दिल्ली हमारे लिए गौरव है।",
        "गंगा हमारी पावन नदी है जिसमें जल बहता है।",
        "पहाड़ और जंगल इसे बड़ा सुंदर बनाते हैं।",
        "देश की राजधानी नई दिल्ली हमारे लिए गौरव है।",
        "गंगा हमारी पावन नदी है जिसमें जल बहता है।",
        "पहाड़ और जंगल इसे बड़ा सुंदर बनाते हैं।"
      ]
    },
    {
      title: "13.5",
      mode: "paragraph",
      instruction: "Full Paragraph Practice 4.",
      text: [
        "शिक्षा जीवन का मूल मन्त्र है जिससे कामयाबी है।",
        "बिना शिक्षा के मानव अपना लक्ष्य नहीं पा सकता।",
        "हमें हमेशा शिक्षा प्राप्त करके आगे बढ़ना चाहिए।",
        "शिक्षा जीवन का मूल मन्त्र है जिससे कामयाबी है।",
        "बिना शिक्षा के मानव अपना लक्ष्य नहीं पा सकता।",
        "हमें हमेशा शिक्षा प्राप्त करके आगे बढ़ना चाहिए।"
      ]
    },
    {
      title: "13.6",
      mode: "paragraph",
      instruction: "Full Paragraph Practice 5.",
      text: [
        "परिश्रम ही सफलता की सच्ची कुंजी कहलाती है।",
        "कभी भी निराश नहीं होना चाहिए और चलते रहो।",
        "सही दिशा में किया गया काम कभी व्यर्थ नहीं होता।",
        "परिश्रम ही सफलता की सच्ची कुंजी कहलाती है।",
        "कभी भी निराश नहीं होना चाहिए और चलते रहो।",
        "सही दिशा में किया गया काम कभी व्यर्थ नहीं होता।"
      ]
    },

    // ------------------------------------------
    // Lesson 14: Real Passages 2
    // ------------------------------------------
    {
      title: "14.1",
      mode: "paragraph",
      instruction: "Final Master Level. Prove your speed and rhythm.",
      text: [
        "Welcome to the Final Master Level! You are now typing complex paragraphs that require deep focus and sustained stamina.",
        "This is the ultimate test of your muscle memory. Maintain a perfectly steady rhythm, striking the keys with even pressure and pacing.",
        "If you make an error, do not panic or let it break your rhythm. Recover gracefully and keep pushing forward like a professional typist.",
        "Keep your wrists elevated, breathe naturally, and trust your hands. You are ready for this!"
      ],
      image: null
    },
    {
      title: "14.2",
      mode: "paragraph",
      instruction: "Master Paragraph Practice 1.",
      text: [
        "विद्यालय ज्ञान का मंदिर है जहां शिक्षा मिलती है।",
        "गुरूजन हमें अच्छा रास्ता और सम्मान सिखाते हैं।",
        "विद्यार्थी जीवन तप से भरी लगन का समय होता है।",
        "विद्यालय ज्ञान का मंदिर है जहां शिक्षा मिलती है।",
        "गुरूजन हमें अच्छा रास्ता और सम्मान सिखाते हैं।",
        "विद्यार्थी जीवन तप से भरी लगन का समय होता है।"
      ]
    },
    {
      title: "14.3",
      mode: "paragraph",
      instruction: "Master Paragraph Practice 2.",
      text: [
        "आज का समय तक्निकी और उन्नति का काल है।",
        "हमें समय के साथ मिलकर काम करना सुखद है।",
        "नई चीजों को सिखना लाभकारी और बेहतर है।",
        "आज का समय तक्निकी और उन्नति का काल है।",
        "हमें समय के साथ मिलकर काम करना सुखद है।",
        "नई चीजों को सिखना लाभकारी और बेहतर है।"
      ]
    },
    {
      title: "14.4",
      mode: "paragraph",
      instruction: "Master Paragraph Practice 3.",
      text: [
        "सुबह जल्दी उठना स्वर ओर स्वास्थ्य के लिए अच्छा है।",
        "व्यायाम करने से शरीर सुंदर और ताकतवर बनता है।",
        "हमें प्रतिदिन उठकर प्रार्थना करके प्रारम्भ करना चाहिए।",
        "सुबह जल्दी उठना स्वर ओर स्वास्थ्य के लिए अच्छा है।",
        "व्यायाम करने से शरीर सुंदर और ताकतवर बनता है।",
        "हमें प्रतिदिन उठकर प्रार्थना करके प्रारम्भ करना चाहिए।"
      ]
    },
    {
      title: "14.5",
      mode: "paragraph",
      instruction: "Master Paragraph Practice 4.",
      text: [
        "मित्रता सबसे अच्छा ओर निस्वार्थ संबंध होता है।",
        "सच्चा मित्र हमेशा मुश्कल समय में काम आता है।",
        "हमें अपने दोस्तों के साथ कभी झूठ नहीं बोलना चाहिए।",
        "मित्रता सबसे अच्छा ओर निस्वार्थ संबंध होता है।",
        "सच्चा मित्र हमेशा मुश्कल समय में काम आता है।",
        "हमें अपने दोस्तों के साथ कभी झूठ नहीं बोलना चाहिए।"
      ]
    },
    {
      title: "14.6",
      mode: "paragraph",
      instruction: "Master Paragraph Practice 5.",
      text: [
        "पर्यावरण की रक्षा करना हमारा सभी का कर्त्तव्य है।",
        "पेड़ पौधे हमारी धरती को जीवन पदान करते हैं।",
        "जल प्रदूषण रोकना हमारी परम्परा और धर्म है।",
        "पर्यावरण की रक्षा करना हमारा सभी का कर्त्तव्य है।",
        "पेड़ पौधे हमारी धरती को जीवन पदान करते हैं।",
        "जल प्रदूषण रोकना हमारी परम्परा और धर्म है।"
      ]
    }
  ];
};

export const getRemingtonCBILessons = () => {
  const gailLessons = getRemingtonGailLessons();

  // Create a dynamic copy and swap "GAIL" with "CBI" in the text
  return gailLessons.map(lesson => {
    return {
      ...lesson,
      instruction: lesson.instruction ? lesson.instruction.replace(/GAIL/g, "CBI") : lesson.instruction,
      text: typeof lesson.text === 'string' 
        ? lesson.text.replace(/GAIL/g, "CBI") 
        : lesson.text
    };
  });
};

// ==========================================
// 🚀 MASTER EXPORT FUNCTION
// ==========================================
export const getCourseLessons = (layout, text) => {
  switch (layout) {
    case 'kruti_dev':
      return getKrutiDevLessons(text);
    case 'inscript':
      return getMangalInscriptLessons(text);
    case 'remington_gail':
      return getRemingtonGailLessons(text);
    case 'remington_cbi':
      return getRemingtonCBILessons(text);
    case 'english':
    default:
      return getEnglishLessons(text);
  }
};